webpackJsonp([22],[
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_promise__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_classCallCheck__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_createClass__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__instance__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__auth__ = __webpack_require__(20);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return API; });






var API = function () {
  function API() {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_classCallCheck___default()(this, API);

    this.axios = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__instance__["a" /* default */])();
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_createClass___default()(API, [{
    key: "get",
    value: function get(query) {
      var _this = this;

      var showLoader = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: "Bearer ".concat(__WEBPACK_IMPORTED_MODULE_4__auth__["a" /* default */].token.get())
        },
        showLoader: showLoader
      };
      var apiUrl = '/';
      var promise = new __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_promise___default.a(function (resolve, reject) {
        _this.axios.post(apiUrl, query, config).then(function (response) {
          var data = response.data;

          if (!data || data.errors) {
            return reject(data.errors);
          }

          return resolve(data);
        }).catch(function (errors) {
          return reject(errors);
        });
      });
      return promise;
    }
  }]);

  return API;
}();



/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__token__ = __webpack_require__(193);

/* harmony default export */ __webpack_exports__["a"] = ({
  token: __WEBPACK_IMPORTED_MODULE_0__token__
});

/***/ }),
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_auth__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__navigationGuards__ = __webpack_require__(209);





var Index = function Index() {
  return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 343));
};

var Login = function Login() {
  return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, 344));
};

var SignIn = function SignIn() {
  return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, 347));
};

var RequestNewPassword = function RequestNewPassword() {
  return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, 346));
};

var RenewPlan = function RenewPlan() {
  return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, 349));
};

var ChangePassword = function ChangePassword() {
  return __webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, 345));
};

var Class = function Class() {
  return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 329));
};

var Community = function Community() {
  return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 330));
};

var CommunityUsers = function CommunityUsers() {
  return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 342));
};

var CommunityUserList = function CommunityUserList() {
  return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 341));
};

var CommunityPosts = function CommunityPosts() {
  return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 339));
};

var CommunityModeration = function CommunityModeration() {
  return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, 334));
};

var CommunityPostsIndex = function CommunityPostsIndex() {
  return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 338));
};

var CommunityPostsShow = function CommunityPostsShow() {
  return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 340));
};

var CommunityPostModeration = function CommunityPostModeration() {
  return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 335));
};

var CommunityPostCommentModeration = function CommunityPostCommentModeration() {
  return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 333));
};

var CommunityNotifications = function CommunityNotifications() {
  return __webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, 337));
};

var CommunityUserNotificationsList = function CommunityUserNotificationsList() {
  return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 336));
};

var CommunityBookmarkedPosts = function CommunityBookmarkedPosts() {
  return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, 331));
};

var CommunityPostBookmark = function CommunityPostBookmark() {
  return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 332));
};

var PageNotFound = function PageNotFound() {
  return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, 348));
};

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
var routes = [{
  path: "/login",
  component: Login,
  children: [{
    path: "/",
    component: SignIn,
    name: "signIn"
  }, {
    path: "/password/forgot",
    component: RequestNewPassword,
    name: "forgotPassword"
  }, {
    path: "/password/edit",
    component: ChangePassword,
    name: "changePassword"
  }]
}, {
  path: "/renew",
  component: RenewPlan,
  name: "renewPlan"
}, {
  path: "/",
  name: "index",
  meta: {
    requiresAuth: true
  },
  component: Index
}, {
  path: "/class/:slug?",
  name: "class",
  meta: {
    requiresAuth: true
  },
  component: Class,
  beforeEnter: __WEBPACK_IMPORTED_MODULE_3__navigationGuards__["a" /* default */].postAvailable
}, {
  path: "/community/:communityId",
  meta: {
    requiresAuth: true
  },
  component: Community,
  children: [{
    path: "posts",
    component: CommunityPosts,
    children: [{
      path: "/",
      component: CommunityPostsIndex,
      name: "communityPosts",
      props: true
    }, {
      path: ":postId",
      component: CommunityPostsShow,
      name: "communityPostComments",
      props: true
    }]
  }, {
    path: "moderation",
    component: CommunityModeration,
    meta: {
      moderation: true
    },
    children: [{
      path: "posts",
      component: CommunityPostModeration,
      name: "communityPostModeration",
      beforeEnter: __WEBPACK_IMPORTED_MODULE_3__navigationGuards__["a" /* default */].communityModeration,
      meta: {
        moderation: true
      }
    }, {
      path: "comments",
      component: CommunityPostCommentModeration,
      name: "communityPostCommentModeration",
      beforeEnter: __WEBPACK_IMPORTED_MODULE_3__navigationGuards__["a" /* default */].communityModeration,
      meta: {
        moderation: true
      }
    }, {
      path: "users",
      component: CommunityUsers,
      children: [{
        path: "",
        component: CommunityUserList,
        name: "communityUserList",
        beforeEnter: __WEBPACK_IMPORTED_MODULE_3__navigationGuards__["a" /* default */].communityModeration,
        meta: {
          moderation: true
        }
      }]
    }]
  }, {
    path: "bookmarks",
    component: CommunityBookmarkedPosts,
    children: [{
      path: "/",
      component: CommunityPostBookmark,
      name: "CommunityPostBookmark"
    }]
  }, {
    path: "notifications",
    component: CommunityNotifications,
    children: [{
      path: "",
      component: CommunityUserNotificationsList,
      name: "communityUserNotificationsList"
    }]
  }]
}, {
  path: "*",
  name: "notFound",
  component: PageNotFound
}];
var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: "history",
  linkActiveClass: "active-class",
  routes: routes
});
router.beforeEach(function (to, from, next) {
  if (to.matched.some(function (matchedRoute) {
    return matchedRoute.meta.requiresAuth;
  }) && !__WEBPACK_IMPORTED_MODULE_2__helpers_auth__["a" /* default */].token.has()) {
    return next({
      path: "/login",
      query: {
        redirect: to.fullPath
      }
    });
  }

  if (to.path === "/login" && __WEBPACK_IMPORTED_MODULE_2__helpers_auth__["a" /* default */].token.has()) {
    return to.params.remoteRendering ? next("/login") : next("/");
  }

  return next();
});
/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__screens_Index_store__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_components_modal_store__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__screens_Search_store__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__screens_Faq_store__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__screens_Class_Content_store__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__screens_Class_Details_store__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__screens_Class_ClassSidebar_store__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__screens_Class_Header_store__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__screens_Class_Index_store__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__screens_Class_Progress_store__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__screens_Class_Details_Comments_store__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__screens_Class_Details_Description_store__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__screens_Class_Details_Downloads_store__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__screens_Class_Details_Notes_store__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__screens_Profile_store__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__shared_components_banner_store__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__screens_App_store__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__screens_Community_store__ = __webpack_require__(268);




















__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* default */]);
var debug = "production" !== 'production' || "production" !== 'staging';
/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* default */].Store({
  modules: {
    index: __WEBPACK_IMPORTED_MODULE_2__screens_Index_store__["a" /* default */],
    modal: __WEBPACK_IMPORTED_MODULE_3__shared_components_modal_store__["a" /* default */],
    search: __WEBPACK_IMPORTED_MODULE_4__screens_Search_store__["a" /* default */],
    faq: __WEBPACK_IMPORTED_MODULE_5__screens_Faq_store__["a" /* default */],
    classContent: __WEBPACK_IMPORTED_MODULE_6__screens_Class_Content_store__["a" /* default */],
    classDetails: __WEBPACK_IMPORTED_MODULE_7__screens_Class_Details_store__["a" /* default */],
    classHeader: __WEBPACK_IMPORTED_MODULE_9__screens_Class_Header_store__["a" /* default */],
    classIndex: __WEBPACK_IMPORTED_MODULE_10__screens_Class_Index_store__["a" /* default */],
    classProgress: __WEBPACK_IMPORTED_MODULE_11__screens_Class_Progress_store__["a" /* default */],
    classComments: __WEBPACK_IMPORTED_MODULE_12__screens_Class_Details_Comments_store__["a" /* default */],
    classDescription: __WEBPACK_IMPORTED_MODULE_13__screens_Class_Details_Description_store__["a" /* default */],
    classSidebar: __WEBPACK_IMPORTED_MODULE_8__screens_Class_ClassSidebar_store__["a" /* default */],
    classDownloads: __WEBPACK_IMPORTED_MODULE_14__screens_Class_Details_Downloads_store__["a" /* default */],
    classNotes: __WEBPACK_IMPORTED_MODULE_15__screens_Class_Details_Notes_store__["a" /* default */],
    profile: __WEBPACK_IMPORTED_MODULE_16__screens_Profile_store__["a" /* default */],
    banner: __WEBPACK_IMPORTED_MODULE_17__shared_components_banner_store__["a" /* default */],
    app: __WEBPACK_IMPORTED_MODULE_18__screens_App_store__["a" /* default */],
    community: __WEBPACK_IMPORTED_MODULE_19__screens_Community_store__["a" /* default */]
  },
  strict: debug
}));

/***/ }),
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_PROJECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return RESET_PROJECT_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SET_IMAGES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_TITLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_DESCRIPTION; });
var SET_PROJECT = 'SET_PROJECT';
var RESET_PROJECT_DATA = 'RESET_PROJECT_DATA';
var SET_IMAGES = 'SET_IMAGES';
var SET_TITLE = 'SET_TITLE';
var SET_DESCRIPTION = 'SET_DESCRIPTION';

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_VISIBLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TOGGLE_CATEGORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CLOSE_CATEGORIES; });
var SET_VISIBLE = 'SET_VISIBLE';
var TOGGLE_CATEGORY = 'TOGGLE_CATEGORY';
var CLOSE_CATEGORIES = 'CLOSE_CATEGORIES';

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_DURATION; });
var SET_DURATION = 'SET_DURATION';
/* unused harmony default export */ var _unused_webpack_default_export = ('DEFAULT');

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_COMMENT_LIST; });
/* unused harmony export RESET_ACTIVE_TAB */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_ACTIVE_COMMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return RESET_ACTIVE_COMMENT; });
var SET_COMMENT_LIST = 'SET_COMMENT_LIST';
var RESET_ACTIVE_TAB = 'RESET_ACTIVE_TAB';
var SET_ACTIVE_COMMENT = 'SET_ACTIVE_COMMENT';
var RESET_ACTIVE_COMMENT = 'RESET_ACTIVE_COMMENT';

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  SET_ACTIVE_DESCRIPTION: 'SET_ACTIVE_DESCRIPTION'
});

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_ACTIVE_TAB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RESET_ACTIVE_TAB; });
var SET_ACTIVE_TAB = 'SET_ACTIVE_TAB';
var RESET_ACTIVE_TAB = 'RESET_ACTIVE_TAB';

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  SET_ACTIVE_NOTE: 'SET_ACTIVE_NOTE'
});

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_ACTIVE_TAB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RESET_ACTIVE_TAB; });
var SET_ACTIVE_TAB = 'SET_ACTIVE_TAB';
var RESET_ACTIVE_TAB = 'RESET_ACTIVE_TAB';

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_ACTIVE_POST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RESET_ACTIVE_POST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_USER_POST_HIT; });
var SET_ACTIVE_POST = 'SET_ACTIVE_POST';
var RESET_ACTIVE_POST = 'RESET_ACTIVE_POST';
var SET_USER_POST_HIT = 'SET_USER_POST_HIT';

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_COMMUNITIES_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_ACTIVE_COMMUNITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_ACTIVE_COMMUNITY_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SET_ASIDE_POSTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SET_ASIDE_POSTS_COUNTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return APPEND_ASIDE_POST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return APPEND_POSTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SET_POSTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return SET_POSTS_COUNTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return ADD_COMMENT_TO_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return SET_ACTIVE_POST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return APPEND_POST_COMMENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return SET_POST_COMMENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return SET_POST_COMMENTS_COUNTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return SET_REPLIES_TO_COMMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return SET_ACTIVE_COMMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return RESET_ACTIVE_COMMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return SET_ACTIVE_COMMUNITY_TERMS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return UPDATE_POST_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return UPDATE_POST_COMMENT_ON_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return UPDATE_POST_ON_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return UPDATE_POST_ON_ASIDE_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return UPDATE_REPLY_ON_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return ADD_REPLY_ON_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SET_TAGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return SET_POPULAR_TAGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return SET_TAG_FILTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return SET_SEARCH_FILTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return SET_MODERATION_STATE_FILTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return TOGGLE_MODERATION_STATE_FILTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return RESET_POST_FILTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return SET_POST_UPLOAD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return RESET_POST_UPLOAD; });
/* unused harmony export SET_POST_IMAGE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return SET_POSTS_ORDER_BY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return SET_COMMENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return SET_TOTAL_COMMENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return UPDATE_COMMENT_ON_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return CHANGE_MOBILE_SIDEBAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return SET_USERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return SET_USERS_COUNTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return SET_USER_SEARCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return SET_USERS_ORDER_BY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return UPDATE_USER_STATE_ON_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return SET_USER_NOTIFICATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return SET_TOTAL_USER_NOTIFICATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return UPDATE_READ_NOTIFICATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return MARK_ALL_AS_READ_NOTIFICATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return UPDATE_USER_EMAIL_SETTINGS_ON_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return SET_COMMUNITY_USER_PROFILE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return RESET_COMMUNITY_USER_PROFILE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return RESET_COMMENT_REPLIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return SET_BADGES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return UPDATE_USER_BADGES_ON_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return SET_REPLYING_COMMENT; });
var SET_COMMUNITIES_LIST = 'SET_COMMUNITIES_LIST';
var SET_ACTIVE_COMMUNITY = 'SET_ACTIVE_COMMUNITY';
var SET_ACTIVE_COMMUNITY_USER = 'SET_ACTIVE_COMMUNITY_USER';
var SET_ASIDE_POSTS = 'SET_ASIDE_POSTS';
var SET_ASIDE_POSTS_COUNTER = 'SET_ASIDE_POSTS_COUNTER';
var APPEND_ASIDE_POST = 'APPEND_ASIDE_POST';
var APPEND_POSTS = 'APPEND_POSTS';
var SET_POSTS = 'SET_POSTS';
var SET_POSTS_COUNTER = 'SET_POSTS_COUNTER';
var ADD_COMMENT_TO_LIST = 'ADD_COMMENT_TO_LIST';
var SET_ACTIVE_POST = 'SET_ACTIVE_POST';
var APPEND_POST_COMMENTS = 'APPEND_POST_COMMENTS';
var SET_POST_COMMENTS = 'SET_POST_COMMENTS';
var SET_POST_COMMENTS_COUNTER = 'SET_POST_COMMENTS_COUNTER';
var SET_REPLIES_TO_COMMENT = 'SET_REPLIES_TO_COMMENT';
var SET_ACTIVE_COMMENT = 'SET_ACTIVE_COMMENT';
var RESET_ACTIVE_COMMENT = 'RESET_ACTIVE_COMMENT';
var SET_ACTIVE_COMMUNITY_TERMS = 'SET_ACTIVE_COMMUNITY_TERMS';
var UPDATE_POST_LIST = 'UPDATE_POST_LIST';
var UPDATE_POST_COMMENT_ON_LIST = 'UPDATE_POST_COMMENT_ON_LIST';
var UPDATE_POST_ON_LIST = 'UPDATE_POST_ON_LIST';
var UPDATE_POST_ON_ASIDE_LIST = 'UPDATE_POST_ON_ASIDE_LIST';
var UPDATE_REPLY_ON_LIST = 'UPDATE_REPLY_ON_LIST';
var ADD_REPLY_ON_LIST = 'ADD_REPLY_ON_LIST';
var SET_TAGS = 'SET_TAGS';
var SET_POPULAR_TAGS = 'SET_POPULAR_TAGS';
var SET_TAG_FILTER = 'SET_TAG_FILTER';
var SET_SEARCH_FILTER = 'SET_SEARCH_FILTER';
var SET_MODERATION_STATE_FILTER = 'SET_MODERATION_STATE_FILTER';
var TOGGLE_MODERATION_STATE_FILTER = 'TOGGLE_MODERATION_STATE_FILTER';
var RESET_POST_FILTER = 'RESET_POST_FILTER';
var SET_POST_UPLOAD = 'SET_POST_UPLOAD';
var RESET_POST_UPLOAD = 'RESET_POST_UPLOAD';
var SET_POST_IMAGE = 'SET_POST_IMAGE';
var SET_POSTS_ORDER_BY = 'SET_POSTS_ORDER_BY';
var SET_COMMENTS = 'SET_COMMENTS';
var SET_TOTAL_COMMENTS = 'SET_TOTAL_COMMENTS';
var UPDATE_COMMENT_ON_LIST = 'UPDATE_COMMENT_ON_LIST';
var CHANGE_MOBILE_SIDEBAR = 'CHANGE_MOBILE_SIDEBAR';
var SET_USERS = 'SET_USERS';
var SET_USERS_COUNTER = 'SET_USERS_COUNTER';
var SET_USER_SEARCH = 'SET_USER_SEARCH';
var SET_USERS_ORDER_BY = 'SET_USERS_ORDER_BY';
var UPDATE_USER_STATE_ON_LIST = 'UPDATE_USER_STATE_ON_LIST';
var SET_USER_NOTIFICATIONS = 'SET_USER_NOTIFICATIONS';
var SET_TOTAL_USER_NOTIFICATIONS = 'SET_TOTAL_USER_NOTIFICATIONS';
var UPDATE_READ_NOTIFICATION = 'UPDATE_READ_NOTIFICATION';
var MARK_ALL_AS_READ_NOTIFICATION = 'MARK_ALL_AS_READ_NOTIFICATION';
var UPDATE_USER_EMAIL_SETTINGS_ON_LIST = 'UPDATE_USER_EMAIL_SETTINGS_ON_LIST';
var SET_COMMUNITY_USER_PROFILE = 'SET_COMMUNITY_USER_PROFILE';
var RESET_COMMUNITY_USER_PROFILE = 'RESET_COMMUNITY_USER_PROFILE';
var RESET_COMMENT_REPLIES = 'RESET_COMMENT_REPLIES';
var SET_BADGES = 'SET_BADGES';
var UPDATE_USER_BADGES_ON_LIST = 'UPDATE_USER_BADGES_ON_LIST';
var SET_REPLYING_COMMENT = 'SET_REPLYING_COMMENT';

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_FAQ_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_ACTIVE_FAQ; });
var SET_FAQ_LIST = 'SET_FAQ_LIST';
var SET_ACTIVE_FAQ = 'SET_ACTIVE_FAQ';

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_request_api__ = __webpack_require__(0);


var api = function api() {
  return new __WEBPACK_IMPORTED_MODULE_0__helpers_request_api__["a" /* default */]();
};

var fetch = function fetch() {
  var query = {
    query: "{\n      related_classes {\n        id\n        status\n        post {\n          id\n          title\n          slug\n          category {\n            name\n          }\n        }\n      }\n    }"
  };
  return api().get(query);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  fetch: fetch
});

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_USER_INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RESET_USER_INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_CATEGORIES_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SET_RELATED_POSTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SET_CURRENT_POST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SET_CATEGORIES_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SET_POSTS_DETAILS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SET_INTRODUCTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return TOGGLE_CATEGORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return HIDE_CATEGORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return CLOSE_CATEGORIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return SET_COURSE_PROGRESS; });
var SET_USER_INFO = 'SET_USER_INFO';
var RESET_USER_INFO = 'RESET_USER_INFO';
var SET_CATEGORIES_LIST = 'SET_CATEGORIES_LIST';
var SET_RELATED_POSTS = 'SET_RELATED_POSTS';
var SET_CURRENT_POST = 'SET_CURRENT_POST';
var SET_CATEGORIES_STATUS = 'SET_CATEGORIES_STATUS';
var SET_POSTS_DETAILS = 'SET_POSTS_DETAILS';
var SET_INTRODUCTION = 'SET_INTRODUCTION';
var TOGGLE_CATEGORY = 'TOGGLE_CATEGORY';
var HIDE_CATEGORY = 'HIDE_CATEGORY';
var CLOSE_CATEGORIES = 'CLOSE_CATEGORIES';
var SET_COURSE_PROGRESS = 'SET_COURSE_PROGRESS';

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_USER_PHOTO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CLEAR_USER_PHOTO; });
var SET_USER_PHOTO = 'SET_USER_PHOTO';
var CLEAR_USER_PHOTO = 'CLEAR_USER_PHOTO';

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_SEARCH_FILTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_SEARCH_RESULTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_COUNT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return APPEND_RESULT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return RESET_SEARCH_FILTER; });
var SET_SEARCH_FILTER = 'SET_SEARCH_FILTER';
var SET_SEARCH_RESULTS = 'SET_SEARCH_RESULTS';
var SET_COUNT = 'SET_COUNT';
var APPEND_RESULT = 'APPEND_RESULT';
var RESET_SEARCH_FILTER = 'RESET_SEARCH_FILTER';

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ('SET_BANNER');

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OPEN_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CLOSE_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return OPEN_CUSTOM_MODAL; });
var OPEN_MODAL = 'OPEN_MODAL';
var CLOSE_MODAL = 'CLOSE_MODAL';
var OPEN_CUSTOM_MODAL = 'OPEN_CUSTOM_MODAL';

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex_router_sync__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__notifications__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__meta__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__i18n__ = __webpack_require__(106);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__store__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_2__meta__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_4__router__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_5__i18n__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_1__notifications__["a"]; });






__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__notifications__["a" /* default */]);


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(306)

var Component = __webpack_require__(17)(
  /* script */
  __webpack_require__(187),
  /* template */
  __webpack_require__(317),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_i18n__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__messages__ = __webpack_require__(202);



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]);
var i18n = new __WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]({
  locale: 'ptBr',
  messages: __WEBPACK_IMPORTED_MODULE_2__messages__["a" /* default */]
});
/* harmony default export */ __webpack_exports__["a"] = (i18n);

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(307)

var Component = __webpack_require__(17)(
  /* script */
  __webpack_require__(190),
  /* template */
  __webpack_require__(321),
  /* scopeId */
  "data-v-f6034292",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(17)(
  /* script */
  __webpack_require__(189),
  /* template */
  __webpack_require__(318),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var timeout = null;

var debounce = function debounce(callback, wait) {
  if (timeout) {
    clearTimeout(timeout);
  }

  timeout = setTimeout(callback, wait);
};

/* harmony default export */ __webpack_exports__["a"] = (debounce);

/***/ }),
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_define_property__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_core_js_object_define_properties__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_core_js_object_define_properties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_core_js_object_define_properties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_core_js_object_get_own_property_descriptors__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_core_js_object_get_own_property_descriptors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_core_js_object_get_own_property_descriptors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_core_js_object_get_own_property_descriptor__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs2_core_js_object_get_own_property_symbols__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs2_core_js_object_get_own_property_symbols___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs2_core_js_object_get_own_property_symbols__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_corejs2_core_js_object_keys__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_corejs2_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_corejs2_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_corejs2_helpers_defineProperty__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_corejs2_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_corejs2_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components_notifications_NotificationContainer__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_components_notifications_NotificationContainer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__shared_components_notifications_NotificationContainer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__screens_Login_components_NoCookiesModal__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__screens_Login_components_NoCookiesModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__screens_Login_components_NoCookiesModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__helpers_events_postMessage__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__router__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__helpers_auth__ = __webpack_require__(20);








function ownKeys(object, enumerableOnly) { var keys = __WEBPACK_IMPORTED_MODULE_5__babel_runtime_corejs2_core_js_object_keys___default()(object); if (__WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs2_core_js_object_get_own_property_symbols___default.a) { var symbols = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs2_core_js_object_get_own_property_symbols___default()(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_core_js_object_get_own_property_descriptor___default()(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_6__babel_runtime_corejs2_helpers_defineProperty___default()(target, key, source[key]); }); } else if (__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_core_js_object_get_own_property_descriptors___default.a) { __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_core_js_object_define_properties___default()(target, __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_core_js_object_get_own_property_descriptors___default()(source)); } else { ownKeys(Object(source)).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_define_property___default()(target, key, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_core_js_object_get_own_property_descriptor___default()(source, key)); }); } } return target; }








var THEME_EDIT_ID = 'theme-edit-style';
var NOT_FOUND_ROUTE = 'notFound';
/* harmony default export */ __webpack_exports__["default"] = ({
  created: function created() {
    var _this = this;

    var currentRoute = this.$router.currentRoute.name;

    if (currentRoute !== NOT_FOUND_ROUTE) {
      this.fetchProject().then(function () {
        _this.adjustProtocol();

        _this.setLanguage();

        if (_this.project.theme_style) {
          _this.loadCustomStyle();
        }
      }).catch(function () {
        _this.notFound = true;

        _this.$router.push('/notFound');
      });
      __WEBPACK_IMPORTED_MODULE_11__helpers_events_postMessage__["a" /* default */].listen(this.receiveData);
    }
  },
  data: function data() {
    return {
      notFound: false,
      postMessages: {
        changeRoute: this.changeRoute,
        authenticate: this.authenticate,
        setStyle: this.updateStyle,
        setImages: this.setImages
      }
    };
  },
  metaInfo: function metaInfo() {
    return {
      title: this.titleProject,
      meta: [{
        vmid: 'og:title',
        property: 'og:title',
        content: this.titleProject
      }, {
        vmid: 'og:description',
        property: 'og:description',
        content: this.description
      }, {
        vmid: 'description',
        name: 'description',
        content: this.description
      }]
    };
  },
  methods: _objectSpread({
    setLanguage: function setLanguage() {
      __WEBPACK_IMPORTED_MODULE_9_vue__["default"].config.lang = this.project.language;
      this.$i18n.locale = __WEBPACK_IMPORTED_MODULE_9_vue__["default"].config.lang;
    },
    adjustProtocol: function adjustProtocol() {
      var _process$env = __webpack_require__.i({"NODE_ENV":"production","KMB_AUTH_URL":"//login.formuladelancamento.com.br/users/sign_in","KMB_FORGOT_PASSWORD_URL":"//login.formuladelancamento.com.br/users/password","KMB_AUTH_SECRET":"923cd89bb87c02407d8afbcc7a3b89ab7e26166c3c7e3143a47ba23c545198d8","KMB_API_URL":"//api.formuladelancamento.com.br","KMB_PROJECTS_DOMAIN":"client.formuladelancamento.com.br","KMB_USER_AVATAR_MAX_SIZE":10485760,"KMB_MEDIA_STORE_URL":"//storage.formuladelancamento.com.br","KMB_CLIENT_ADMIN_URL":"https://app.formuladelancamento.com.br"}),
          enviroment = _process$env.NODE_ENV,
          defaultDomain = _process$env.KMB_PROJECTS_DOMAIN;

      if (enviroment === 'development') {
        return;
      }

      var _location = location,
          href = _location.href;
      var defaultDomainRegex = new RegExp("(.)*.".concat(defaultDomain));

      if (defaultDomainRegex.test(href)) {
        this.adjustDefaultDomainProtocol();
        return;
      }

      this.adjustCustomDomainProtocol();
    },
    adjustDefaultDomainProtocol: function adjustDefaultDomainProtocol() {
      var _location2 = location,
          protocol = _location2.protocol,
          href = _location2.href;
      var domain = href.substring(protocol.length);

      if (protocol !== 'https:') {
        location.href = "https:".concat(domain);
      }
    },
    adjustCustomDomainProtocol: function adjustCustomDomainProtocol() {
      var _location3 = location,
          protocol = _location3.protocol,
          href = _location3.href;
      var domain = href.substring(protocol.length);
      var hasCertificate = this.project.ssl_certificate;

      if (hasCertificate && protocol !== 'https:') {
        location.href = "https:".concat(domain);
      }
    },
    receiveData: function receiveData(currentData) {
      var action = currentData.action,
          data = currentData.data;
      this.postMessages[action](data);
    },
    changeRoute: function changeRoute(_ref) {
      var name = _ref.name,
          params = _ref.params;
      __WEBPACK_IMPORTED_MODULE_12__router__["a" /* default */].push({
        name: name,
        params: params
      });
    },
    updateStyle: function updateStyle(style) {
      var body = document.body;
      var styleTag = body.querySelector("#".concat(THEME_EDIT_ID));

      if (!styleTag) {
        styleTag = document.createElement('style');
        styleTag.setAttribute('id', THEME_EDIT_ID);
        body.appendChild(styleTag);
      }

      styleTag.innerHTML = style;
    },
    loadCustomStyle: function loadCustomStyle() {
      var head = document.head;
      var cdnAddress = this.project.theme_style.cdn_address;
      var styleTagLink = this.normalizeUrl(cdnAddress);

      if (cdnAddress) {
        var styleTag = document.createElement('link');
        styleTag.setAttribute('id', THEME_EDIT_ID);
        styleTag.setAttribute('href', styleTagLink);
        styleTag.setAttribute('rel', 'stylesheet');
        styleTag.setAttribute('type', 'text/css');
        head.appendChild(styleTag);
      }
    },
    normalizeUrl: function normalizeUrl(url) {
      var protocolPattern = /https?:\/\//i;
      return protocolPattern.test(url) ? url : "//".concat(url);
    },
    setImages: function setImages(images) {
      this.setImagesOnState(images);
    },
    authenticate: function authenticate(authToken) {
      if (!__WEBPACK_IMPORTED_MODULE_13__helpers_auth__["a" /* default */].token.has()) {
        __WEBPACK_IMPORTED_MODULE_13__helpers_auth__["a" /* default */].token.set(authToken);
      }
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vuex__["a" /* mapActions */])({
    fetchProject: 'app/fetchProject',
    setImagesOnState: 'app/setImages'
  })),
  computed: _objectSpread({
    loadedRequisites: function loadedRequisites() {
      return this.projectId || this.notFound;
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vuex__["b" /* mapGetters */])({
    projectId: 'app/projectId',
    project: 'app/project',
    titleProject: 'app/title',
    description: 'app/description'
  })),
  components: {
    NoCookiesModal: __WEBPACK_IMPORTED_MODULE_10__screens_Login_components_NoCookiesModal___default.a,
    NotificationContainer: __WEBPACK_IMPORTED_MODULE_7__shared_components_notifications_NotificationContainer___default.a
  }
});

/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_components_modal_GeneralLayout__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_components_modal_GeneralLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__shared_components_modal_GeneralLayout__);

/* harmony default export */ __webpack_exports__["default"] = ({
  computed: {
    areCookiesEnabled: function areCookiesEnabled() {
      return navigator.cookieEnabled;
    }
  },
  methods: {
    close: function close() {}
  },
  components: {
    LayoutGeneral: __WEBPACK_IMPORTED_MODULE_0__shared_components_modal_GeneralLayout___default.a
  }
});

/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'IconClose'
});

/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    showCloseButton: {
      type: Boolean,
      required: false,
      default: true
    },
    modalType: {
      type: String,
      required: false,
      default: ''
    }
  },
  computed: {
    modalTypeClass: function modalTypeClass() {
      var modalClass = 'c-modal';

      if (this.modalType) {
        return "".concat(modalClass, "--").concat(this.modalType);
      }

      return modalClass;
    }
  }
});

/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_components_icons_close__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_components_icons_close___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__shared_components_icons_close__);

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    config: {
      type: Object,
      required: true
    },
    firstAction: {
      type: Object,
      required: false,
      default: null
    },
    secondAction: {
      type: Object,
      required: false,
      default: null
    },
    description: {
      type: String,
      required: false,
      default: null
    }
  },
  computed: {
    containerClass: function containerClass() {
      if (this.type === 'warn') {
        return 'warning';
      }

      return this.type;
    },
    iconClass: function iconClass() {
      var replace = this.containerClass;

      if (this.type === 'info') {
        replace = 'warning';
      }

      return "c-icon--".concat(replace);
    },
    type: function type() {
      return this.config.item.type;
    },
    firstActionText: function firstActionText() {
      if (this.firstAction && this.firstAction.text) {
        return this.firstAction.text;
      }

      return 'ok';
    },
    secondActionText: function secondActionText() {
      if (this.secondAction && this.secondAction.text) {
        return this.secondAction.text;
      }

      return 'cancel';
    }
  },
  components: {
    IconClose: __WEBPACK_IMPORTED_MODULE_0__shared_components_icons_close___default.a
  }
});

/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_components_notifications_NotificationBody__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_components_notifications_NotificationBody___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__shared_components_notifications_NotificationBody__);

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      animation: {
        enter: function enter(element) {
          var height = element.clientHeight;
          return {
            opacity: [1, 0],
            translateY: [0, height],
            scale: [1, 0.2]
          };
        },
        leave: {
          opacity: 0,
          height: 0
        }
      }
    };
  },
  components: {
    NotificationBody: __WEBPACK_IMPORTED_MODULE_0__shared_components_notifications_NotificationBody___default.a
  }
});

/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "set", function() { return set; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "get", function() { return get; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "has", function() { return has; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "destroy", function() { return destroy; });
var KEY = 'kmb-client-user-auth-token';
var set = function set(token) {
  return window.sessionStorage.setItem(KEY, token);
};
var get = function get() {
  return window.sessionStorage.getItem(KEY);
};
var has = function has() {
  var token = get();
  return token && token !== 'undefined';
};
var destroy = function destroy() {
  window.sessionStorage.removeItem(KEY);
};

/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var validateOrigin = function validateOrigin(receivedOrigin) {
  var expectedOrigin = "https://app.formuladelancamento.com.br";
  return expectedOrigin === receivedOrigin;
};

var listen = function listen(callback) {
  return window.addEventListener('message', function (event) {
    var origin = event.origin,
        data = event.data;

    if (validateOrigin(origin)) {
      callback(data);
    }
  });
};

/* harmony default export */ __webpack_exports__["a"] = ({
  listen: listen
});

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__interceptors__ = __webpack_require__(198);


var KMB_API_URL = "//api.formuladelancamento.com.br";
var instance;
/* harmony default export */ __webpack_exports__["a"] = (function () {
  if (instance) {
    return instance;
  }

  var LoaderResponse = __WEBPACK_IMPORTED_MODULE_1__interceptors__["a" /* loader */].response;
  instance = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
    baseURL: KMB_API_URL
  });
  instance.interceptors.request.use(__WEBPACK_IMPORTED_MODULE_1__interceptors__["a" /* loader */].request);
  instance.interceptors.response.use(function (response) {
    return response;
  }, __WEBPACK_IMPORTED_MODULE_1__interceptors__["b" /* token */]);
  instance.interceptors.response.use(LoaderResponse.success, LoaderResponse.error);
  return instance;
});

/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__auth__ = __webpack_require__(20);


var mediaStoreUrl = "//storage.formuladelancamento.com.br";
var source;

var getConfig = function getConfig() {
  return {
    headers: {
      'Content-Type': 'multipart/form-data',
      Authorization: "Bearer ".concat(__WEBPACK_IMPORTED_MODULE_1__auth__["a" /* default */].token.get())
    }
  };
};

var uploadPostImage = function uploadPostImage(_ref) {
  var imageFile = _ref.imageFile,
      thumbFile = _ref.thumbFile,
      userId = _ref.userId,
      _ref$onProgress = _ref.onProgress,
      onProgress = _ref$onProgress === void 0 ? null : _ref$onProgress;
  var formData = new FormData();
  var config = getConfig();
  var CancelToken = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.CancelToken;
  source = CancelToken.source();
  config.onUploadProgress = onProgress;
  config.cancelToken = source.token;
  formData.append('files[0]', imageFile, imageFile.name);
  formData.append('files[1]', thumbFile, thumbFile.name);
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("".concat(mediaStoreUrl, "/v1/medias/upload_community_user_post_image?user_id=").concat(userId), formData, config);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  uploadPostImage: uploadPostImage
});

/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);

var apiUrl = "//api.formuladelancamento.com.br";
var headers = {
  'Content-Type': 'application/json'
};

var getProjectId = function getProjectId() {
  var protocol = window.location.protocol;
  var hostName = window.location.hostname;
  var domain = "".concat(protocol, "//").concat(hostName);
  var webhookUrl = "".concat(apiUrl, "/webhook/project_find_by.json");
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(webhookUrl, {
    domain: domain
  }, {
    headers: headers
  });
};

/* harmony default export */ __webpack_exports__["a"] = ({
  getProjectId: getProjectId
});

/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__token__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__loader__ = __webpack_require__(199);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__token__["a"]; });
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__loader__; });




/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_promise__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_promise__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "request", function() { return request; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "response", function() { return response; });

var events = {
  requestStart: new Event('requestStart'),
  requestEnd: new Event('requestEnd')
};
var request = function request(config) {
  if (config.showLoader) {
    window.dispatchEvent(events.requestStart);
  }

  return config;
};
var response = {
  success: function success(response) {
    if (response.config.showLoader) {
      window.dispatchEvent(events.requestEnd);
    }

    return response;
  },
  error: function error(_error) {
    if (_error.config.showLoader) {
      window.dispatchEvent(events.requestEnd);
    }

    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_promise___default.a.reject(_error);
  }
};

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_promise__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__auth__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(25);



/* harmony default export */ __webpack_exports__["a"] = (function (error) {
  if (error.response.status !== 401) {
    return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_promise___default.a.reject(error);
  }

  __WEBPACK_IMPORTED_MODULE_1__auth__["a" /* default */].token.destroy();
  __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push({
    path: '/login'
  });
  return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_promise___default.a.reject({});
});

/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__auth__ = __webpack_require__(20);


var mediaStoreUrl = "//storage.formuladelancamento.com.br";

var getConfig = function getConfig() {
  return {
    'Content-Type': 'multipart/form-data',
    headers: {
      Authorization: "Bearer ".concat(__WEBPACK_IMPORTED_MODULE_1__auth__["a" /* default */].token.get())
    }
  };
};

var upload = function upload(file) {
  var formData = new FormData();
  formData.append('file', file);
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post("".concat(mediaStoreUrl, "/v1/medias"), formData, getConfig());
};

/* harmony default export */ __webpack_exports__["a"] = ({
  upload: upload
});

/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__languages_en_US__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__languages_pt_BR__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__languages_es_ES__ = __webpack_require__(204);



/* harmony default export */ __webpack_exports__["a"] = ({
  enUs: __WEBPACK_IMPORTED_MODULE_0__languages_en_US__["a" /* default */],
  ptBr: __WEBPACK_IMPORTED_MODULE_1__languages_pt_BR__["a" /* default */],
  esEs: __WEBPACK_IMPORTED_MODULE_2__languages_es_ES__["a" /* default */]
});

/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  monthNames: {
    short: {
      january: 'JAN',
      february: 'FEB',
      march: 'MAR',
      april: 'APR',
      may: 'MAY',
      june: 'JUN',
      july: 'JUL',
      august: 'AUG',
      september: 'SEP',
      october: 'OCT',
      november: 'NOV',
      december: 'DEC'
    },
    long: {
      january: 'January',
      february: 'February',
      march: 'March',
      april: 'April',
      may: 'May',
      june: 'June',
      july: 'July',
      august: 'August',
      september: 'September',
      october: 'October',
      november: 'November',
      december: 'December'
    }
  },
  pageNotFound: {
    warning: 'Page not found :(',
    backToPortal: 'Back to portal'
  },
  login: {
    email: {
      label: 'User\'s E-mail',
      placeholder: 'Type your Email'
    },
    password: {
      label: 'Password',
      placeholder: 'Type your Password',
      forgot: 'Forgot Password?',
      show: 'Show Password'
    },
    recoverPassword: {
      greetings: 'Hello',
      label: 'Enter your email to recover your password. We\'ll send you a link to reset yout password.',
      resetPasswordLabel: 'Configure a new password',
      errorMessage: 'Email not found or blocked.',
      successMessage: 'Success! A process to renew password was sent to your email.',
      renewMessage: 'Fill the form to renew your password.',
      renewError: 'Error while renewing your password, try again.',
      smallPasswordError: 'Your password must be at least 8 characters long',
      wrongPasswordError: 'The given passwords do not match',
      renewSuccess: 'Password updated successfully.',
      button: 'REDEFINE PASSWORD',
      backToLogin: 'Back to login',
      newPassword: 'New password',
      newPasswordConfirm: 'Confirm the new password'
    },
    keepMeLogged: {
      label: 'Keep me logged In'
    },
    signInButton: {
      label: 'Sign In'
    },
    welcome: 'Welcome!',
    signin: 'Sign in',
    error: 'Failure on login, verify your credentials and try again.',
    errorNotFound: 'Contact support',
    renew: 'You renewed and the address changed to a project'
  },
  index: {
    content: {
      introduction: 'Introduction',
      showIntroduction: 'SHOW INTRODUCTION',
      hideIntroduction: 'HIDE INTRODUCTION',
      minutes: 'Minutes',
      classes: 'Classes',
      showClasses: 'Show Classes',
      hideClasses: 'Hide Classes',
      dateOpenModule: 'This module will be available at',
      openSubmodule: 'OPEN SUBMODULE',
      closeSubmodule: 'CLOSE SUBMODULE',
      completed: 'COMPLETED',
      concluded: 'CONCLUDED',
      completedAt: 'COMPLETED AT',
      beginClass: 'BEGIN CLASS',
      emptyMessage: 'Currently there is not any content for this module!.',
      progressiveUnavailable: 'COMPLETE THE PREVIOUS LESSONS'
    },
    header: {
      startCourse: 'START COURSE',
      resumeCourse: 'RESUME COURSE',
      notes: {
        button: 'My notes',
        modal: {
          title: 'My notes',
          download: 'DOWNLOAD NOTES'
        }
      },
      faq: {
        button: 'FAQ',
        modal: {
          title: 'Frequent Asked Questions'
        }
      },
      search: {
        title: 'What are you looking for?',
        popularTags: 'POPULAR TAGS',
        resultCount: '{resultCount} results found for "{searchFilter}"',
        seeMore: 'See More'
      },
      nextClass: {
        title: 'YOUR NEXT CLASS'
      },
      emailSupport: 'suporte@ignicaodigital.com.br',
      doubts: 'Do you have questions or problems? Talk to our support:'
    },
    sidebar: {
      completedModules: 'COMPLETED MODULES'
    }
  },
  general: {
    labels: {
      loading: 'Loading...',
      uploading: 'Uploading File'
    },
    actions: {
      search: 'Search',
      communitySearch: 'Search in the community',
      clearSearch: 'Clear search',
      start: 'START',
      cancel: 'Cancel',
      orderBy: 'Order By',
      updateChanges: 'UPDATE CHANGES',
      access: 'Access',
      edit: 'Edit',
      remove: 'Remove',
      save: 'Save',
      back: 'Back',
      mute: 'Mute',
      unmute: 'Unmute {user}',
      saveChanges: 'Save Changes',
      filter: 'Filter'
    },
    messages: {
      noRecordFound: 'No records Found'
    },
    time: {
      formatFns: 'M/d/YYYY - H:mm',
      format: 'm/d/Y - H:i \\hour\\s',
      min: 'Min'
    }
  },
  logout: {
    label: 'Logout'
  },
  class: {
    details: {
      tags: 'Tags',
      nav: {
        description: 'Description',
        comments: 'Comments',
        extraContent: 'Extra',
        notes: 'Notes'
      },
      comments: {
        title: 'Comments',
        reply: 'Reply',
        post: 'Post',
        remove: 'Remove',
        pending: 'WAITING MODERATION',
        highlight: 'Highlight',
        highlighted: 'Highlighted',
        removeHighlight: 'Remove Highlight'
      },
      downloads: {
        download: 'Download',
        visualize: 'Visualize'
      }
    },
    progress: {
      completeClass: 'COMPLETE CLASS',
      moveToNext: 'AND MOVE TO NEXT',
      moveToPrev: 'BACK TO PREVIOUS CLASS',
      seeIndex: 'OPEN CLASS INDEX'
    },
    sidebar: {
      module: 'Module',
      noContent: 'There is no content right now'
    }
  },
  profile: {
    loadingImage: 'Loading Image...',
    imageAlt: 'Profile Image',
    changeImage: 'Change Image',
    fileSizeError: 'The file size exceeds the limit allowed',
    errorLoadingImage: 'Error loading image',
    menuTitle: 'PROFILE AND PASSWORD',
    name: 'Name',
    password: 'Password',
    retypePassword: 'Retype Password',
    passwords: {
      alertError: 'Error updating your password, review the data and try again.',
      alertSuccess: 'Password updated successfully.',
      notMatching: 'Passwords does not match.'
    },
    updatedMessage: 'Profile successfully updated',
    updateError: 'Error updating your profile, try again later'
  },
  cookie: {
    disabled: 'Cookies disabled',
    enable: 'Your browser cookies are disabled, reactivate then, and reload the page.'
  },
  banner: {
    defaultText: 'Edit your banner in settings',
    defaultButtonText: 'button action'
  },
  community: {
    notFound: 'Community not Found',
    title: 'Community',
    night_mode: 'Night mode',
    discussion: 'Discussion',
    labels: {
      like: 'Like',
      liked: 'Liked',
      likes: 'Likes',
      bestComments: 'Best Comments',
      updatedAt: 'Updated At'
    },
    users: {
      title: 'Users',
      members: 'Members',
      notMuted: 'Not muted',
      profile: {
        title: 'Profile',
        view: 'View Profile',
        header: 'Member Profile',
        statistics: 'Statistics',
        badges: 'Badges',
        notifications: 'Mail Notifications',
        createdPosts: 'Created Posts',
        createdComments: 'Created Comments',
        likes: 'Likes',
        postsLikes: 'Posts Likes',
        commentsLikes: 'Comments Likes'
      },
      mailSettings: {
        info: 'Notify me when...',
        postComment: 'Someone comments on my post',
        postLike: 'Someone likes my post',
        followedPostComment: 'Someone comments on a folllowed post',
        followedPostLike: 'Someone likes a followed post',
        commentLike: 'Someone likes any of my comments',
        reply: 'Someone replies any of my comments',
        postMention: 'Someone mentions me in a post',
        commentMention: 'Someone mentions me in a comment',
        badge: 'I receive a badge',
        postApproved: 'My post is approved',
        commentApproved: 'My comment is approved'
      }
    },
    list: {
      selectOne: 'Select the Community'
    },
    events: {
      openDate: 'Open Date',
      closeDate: 'Close Date'
    },
    posts: {
      viewPost: 'View {kind}',
      title: 'Posts',
      searchLabel: 'Search for member by name or email',
      actions: {
        create: 'Create New Post',
        start: 'Write new post',
        comment: 'What is on your mind?'
      },
      removed: 'Removed post',
      follow: 'Follow post',
      unfollow: 'Unfollow post',
      writeTitle: 'Write a title',
      createBookmark: 'Add to bookmark',
      removeBookmark: 'Remove from bookmark',
      kind: {
        post: 'Post',
        event: 'Event'
      },
      toTop: 'To Top',
      toAside: 'To Sidebar',
      pinTitle: 'Pin',
      pin: {
        top: 'Pin To Top',
        aside: 'Pin to Sidebar'
      },
      unpin: {
        top: 'Unpin From Top',
        aside: 'Unpin from Sidebar'
      },
      messages: {
        follow: {
          success: 'Post followed with success!',
          error: 'Could not follow post.'
        },
        unfollow: {
          success: 'Post unfollowed with success!',
          error: 'Could not unfollow post.'
        },
        createBookmark: {
          success: 'Post added to bookmark with success!',
          error: 'Could not add post from bookmark.'
        },
        removeBookmark: {
          success: 'Post removed from bookmark with success!',
          error: 'Could not remove post from bookmark.'
        },
        create: {
          error: 'Fill in the title, tag and content'
        }
      }
    },
    badges: {
      title: 'Badges',
      assign: 'Give badges',
      select: 'Select one or more badges',
      selected: 'None selected badge | 1 selected badge | {count} selected badges',
      no_badges_registered: 'There are no medals registered'
    },
    comments: {
      loadAll: 'Load all comments',
      title: 'No comment | 1 comment | {count} comments',
      label: 'Comments',
      actions: {
        create: 'Comment',
        remove: 'Remove Comment',
        update: 'Update Comment',
        comment: 'Write a comment'
      },
      warnings: {
        remove: 'Are you sure you want remove this comment'
      },
      replies: {
        view: '1 reply | {count} replies',
        viewMore: 'View more replies'
      }
    },
    useTerms: {
      title: 'Use Terms',
      accept: 'Accept Use Terms',
      decline: 'I decline the terms',
      agreed: 'I agree with the use terms of the community',
      seeTerms: 'See the use terms of the community'
    },
    moderation: {
      title: 'Moderation',
      postStatus: 'Post status',
      status: {
        pending: 'Pending',
        visible: 'Visible',
        locked: 'Locked',
        muted: 'Muted'
      },
      filters: {
        apply: 'Apply',
        pending: 'Pending',
        locked: 'Locked',
        muted: 'Muted',
        posts: 'Filter posts',
        comments: 'Filter comments'
      }
    },
    tags: {
      popular: 'Most popular tags',
      add: 'Click and / or type to add tags',
      showAll: 'Show all',
      showLess: 'Show less',
      selectLabel: 'Click or press enter to add',
      deselectLabel: 'Click or press enter to remove',
      selectedLabel: 'Added',
      emptyListLabel: 'List is empty',
      all: 'All tags'
    },
    rules: {
      title: 'Rules',
      sidebarLabel: 'Community rules'
    },
    orders: {
      resultCount: 'Showing {resultCount} of {totalResult} members',
      apply: 'Apply',
      recent: 'Recent',
      popular: 'More popular',
      label: 'ORDER MEMBERS BY',
      posts: 'More posts created',
      postLikes: 'More likes received in posts',
      comments: 'More comments created',
      commentLikes: 'More likes received in comments',
      badges: 'More badges received'
    },
    notifications: {
      title: 'Notifications',
      timeFrom: '{time} ago',
      seeAll: 'See all',
      markAsRead: 'Mark as read',
      markAsUnread: 'Mark as unread',
      markAllAsRead: 'Mark all as read'
    },
    bookmark: {
      title: 'Bookmarks'
    },
    medias: {
      video: {
        urlPlaceholder: 'Youtube or Vimeo URL',
        postTitle: 'Add video to post',
        commentTitle: 'Add video to comment',
        add: 'Add to post'
      }
    }
  },
  pagination: {
    first: 'First',
    last: 'Last',
    next: 'Next',
    previous: 'Previous'
  },
  emojis: {
    search: 'Search',
    notfound: 'No Emoji Found',
    categories: {
      search: 'Search Results',
      recent: 'Frequently Used',
      people: 'Smileys & People',
      nature: 'Animals & Nature',
      foods: 'Food & Drink',
      activity: 'Activity',
      places: 'Travel & Places',
      objects: 'Objects',
      symbols: 'Symbols',
      flags: 'Flags',
      custom: 'Custom'
    }
  },
  textEditor: {
    toolbar: {
      fontSize: 'Font Size',
      fontType: 'Font Type',
      align: 'Align Text',
      headerType: 'Header Type',
      clean: 'Clean Text',
      textColor: 'Text Color',
      textBackground: 'Text Background',
      bold: 'Bold',
      italic: 'Italic',
      underlined: 'Underlined',
      strike: 'Strike',
      unorderedList: 'Unordered List',
      orderedList: 'Ordered List',
      link: 'Insert Link',
      image: 'Insert Image',
      subscript: 'Subscript',
      superscript: 'Superscript',
      blockquote: 'Blockquote',
      increaseIndent: 'Increase Indent',
      decreaseIndent: 'Decrease Indent'
    },
    fontSize: {
      small: 'small',
      medium: 'medium',
      large: 'large',
      huge: 'huge'
    },
    font: {
      sansSerif: 'Sans Serif',
      serif: 'Serif',
      monospace: 'Monospace'
    }
  }
});

/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  monthNames: {
    short: {
      january: 'ENE',
      february: 'FEB',
      march: 'MAR',
      april: 'ABR',
      may: 'MAY',
      june: 'JUN',
      july: 'JUL',
      august: 'AGO',
      september: 'SEP',
      october: 'OCT',
      november: 'NOV',
      december: 'DIC'
    },
    long: {
      january: 'Enero',
      february: 'Febrero',
      march: 'Marzo',
      april: 'Abril',
      may: 'Mayo',
      june: 'Junio',
      july: 'Julio',
      august: 'Agosto',
      september: 'Septiembre',
      october: 'Octubre',
      november: 'Noviembre',
      december: 'Diciembre'
    }
  },
  pageNotFound: {
    warning: 'Página no encontrada :(',
    backToPortal: 'Volver al portal'
  },
  login: {
    email: {
      label: 'Correo Electrónico de Usuario',
      placeholder: 'Correo Electrónico'
    },
    password: {
      label: 'Contraseña',
      placeholder: 'Contraseña',
      forgot: '¿Olvidaste tu contraseña?',
      show: 'Mostrar Contraseña'
    },
    recoverPassword: {
      greetings: '¡Hola',
      label: 'Ingressa tu correo electrónico a continuación.Te enviaremos un enlace para restablecer su contraseña.',
      resetPasswordLabel: 'Configure una nueva contraseña',
      errorMessage: 'Correo electrónico no encontrado o bloqueado.',
      successMessage: '¡Listo! El proceso de reconfiguracíon de contraseña fue enviado para su correo electrónico.',
      renewMessage: 'Ingressa sus datos en el formulario para renovar su contraseña.',
      renewError: 'Error al renovar su contraseña, vuelva a intentarlo.',
      smallPasswordError: 'Prueba con una contraseña que tenga al menos 8 caracteres.',
      wrongPasswordError: 'Las contraseñas no coinciden',
      renewSuccess: 'Tu contraseña ha sido actualizada.',
      button: 'restablecer Contraseña',
      backToLogin: 'Volver al login',
      newPassword: 'Nueva Contraseña',
      newPasswordConfirm: 'Confirmar nueva contraseña'
    },
    keepMeLogged: {
      label: 'Recuérdame'
    },
    signInButton: {
      label: 'INICIAR SESIÓN'
    },
    welcome: '¡Bienvenido!',
    signin: 'Inicia sesión en tu cuenta.',
    error: 'Error al acceder a tu cuenta, verifique los datos ingresados.',
    errorNotFound: 'Contactar con soporte',
    renew: 'Renueva y la dirección cambia a proyecto'
  },
  index: {
    content: {
      introduction: 'Introducción',
      showIntroduction: 'MOSTRAR INTRODUCCIÓN',
      hideIntroduction: 'OCULTAR INTRODUCCIÓN',
      minutes: 'Minutos',
      classes: 'Clases',
      showClasses: 'MOSTRAR CLASES',
      hideClasses: 'OCULTAR CLASES',
      dateOpenModule: 'ESTE MÓDULO ESTARÁ DISPONIBLE EN',
      openSubmodule: 'ABRIR SUBMÓDULO',
      closeSubmodule: 'CERRAR SUBMÓDULO',
      completed: 'COMPLETO',
      concluded: 'CONCLUIDO',
      completedAt: 'CONCLUIDO EN',
      beginClass: 'EMPEZAR CLASSE',
      emptyMessage: '¡En este momento no hay ninguno contenido para este módulo!.',
      progressiveUnavailable: 'COMPLETE LAS CLASES ANTERIORES'
    },
    header: {
      startCourse: 'EMPEZAR CURSO',
      resumeCourse: 'CONTINUAR CURSO',
      notes: {
        button: 'MIS ANOTACIONES',
        modal: {
          title: 'Mis anotaciones',
          download: 'DESCARGAR NOTAS'
        }
      },
      faq: {
        button: 'PREGUNTAS FRECUENTES',
        modal: {
          title: 'Preguntas frecuentes'
        }
      },
      search: {
        title: '¿Qué estás buscando?',
        popularTags: 'TAGS MÁS POPULARES',
        resultCount: '{resultCount} resultados encontrados con el filtro "{searchFilter}"',
        seeMore: 'Vea Más'
      },
      nextClass: {
        title: 'SU PRÓXIMA CLASE'
      },
      emailSupport: 'suporte@ignicaodigital.com.br',
      doubts: '¿Tiene dudas o problemas? Hable con nuestro soporte:'
    },
    sidebar: {
      completedModules: 'MÓDULOS COMPLETADOS'
    }
  },
  general: {
    labels: {
      loading: 'Cargando...',
      uploading: 'Haciendo Upload'
    },
    actions: {
      search: 'Buscar',
      communitySearch: 'Buscar en la comunidad',
      clearSearch: 'Borrar búsqueda',
      start: 'EMPEZAR',
      cancel: 'Cancelar',
      orderBy: 'Ordenar por',
      updateChanges: 'GUARDAR CAMBIOS',
      access: 'Acceso',
      edit: 'Editar',
      remove: 'Eliminar',
      save: 'Guardar',
      back: 'Volver',
      mute: 'Silenciar',
      unmute: 'Sacar {user} del modo silencioso',
      saveChanges: 'Guardar Cambios',
      filter: 'Filtro'
    },
    messages: {
      noRecordFound: 'No se encontraron registros'
    }
  },
  logout: {
    label: 'Salir'
  },
  class: {
    details: {
      tags: 'Tags',
      nav: {
        description: 'DESCRIPCIÓN',
        comments: 'COMENTARIOS',
        extraContent: 'EXTRA',
        notes: 'ANOTACIONES'
      },
      comments: {
        title: 'Comentarios',
        reply: 'Contestar',
        post: 'Publicar',
        remove: 'Quitar',
        pending: 'PENDIENTE DE MODERACIÓN',
        highlight: 'Resaltar',
        highlighted: 'Respuesta Resaltada',
        removeHighlight: 'Eliminar Resaltado'
      },
      downloads: {
        download: 'Descargar',
        visualize: 'Visualizar'
      }
    },
    progress: {
      completeClass: 'COMPLETAR CLASE',
      moveToNext: 'E IR PARA LA PRÓXIMA',
      moveToPrev: 'VOLVER A LA CLASE ANTERIOR',
      seeIndex: 'VER ÍNDICE DE CLASES'
    },
    sidebar: {
      module: 'Módulo',
      noContent: 'En este momento no hay contenido'
    }
  },
  profile: {
    loadingImage: 'Cargando Imagen...',
    imageAlt: 'Imagen de Perfil',
    changeImage: 'Cambiar Imagen',
    fileSizeError: 'El tamaño de la imagen es demasiado grande',
    errorLoadingImage: 'Error al cargar la imagen',
    menuTitle: 'MI PERFIL Y CONTRASEÑA',
    name: 'Nombre',
    password: 'Contraseña',
    retypePassword: 'Confirmar Contraseña',
    passwords: {
      alertError: 'Error al cambiar la contrasenha, verifique dados ingresados.',
      alertSuccess: 'Contraseña actualizada correctamente.',
      notMatching: 'Las contraseñas no coinciden.'
    },
    updatedMessage: 'Perfil actualizado con éxito',
    updateError: 'Error al actualizar el perfil, intenta de nuevo más tarde'
  },
  cookie: {
    disabled: 'Cookies no permitidas',
    enable: 'Las cookies deben estar habilitadas en tu navegador web, se las permita y actualice la página.'
  },
  banner: {
    defaultText: 'Editar su banner en la configuración',
    defaultButtonText: 'acción del botón'
  },
  community: {
    notFound: 'Comunidad no encontrada',
    title: 'Comunidad',
    night_mode: 'Modo nocturno',
    discussion: 'Discusión',
    labels: {
      like: 'Me gusta',
      liked: 'Me gustó',
      likes: 'Me gusta',
      updatedAt: 'Actualizado a'
    },
    users: {
      title: 'Usuarios',
      members: 'Miembros',
      notMuted: 'No silenciado',
      profile: {
        title: 'Perfil',
        view: 'Ver Perfil',
        header: 'Perfil del Usuario',
        statistics: 'Estadísticas',
        badges: 'Medallas',
        notifications: 'Notificaciones de Email',
        createdPosts: 'Posts creados',
        createdComments: 'Comentarios creados',
        likes: 'Gustos',
        postsLikes: 'Curtidos de Posts',
        commentsLikes: 'Curtidos de Comentarios'
      },
      mailSettings: {
        info: 'Me avisa cuando...',
        postComment: 'Alguien comentar en mi post',
        postLike: 'Alguien gusta de mi post',
        followedPostComment: 'Alguien comentar en un post que estoy siguiendo',
        followedPostLike: 'Alguien gusta de un post que estoy siguiendo',
        commentLike: 'Alguien que gusta de un comentario que escribí',
        reply: 'Alguien responder un comentario que escribí',
        postMention: 'Alguien me menciona en un post',
        commentMention: 'Alguien me menciona en un comentario',
        badge: 'Yo recibo una medalla',
        postApproved: 'Mi post es aprobado',
        commentApproved: 'Mi comentario es aprobado'
      }
    },
    list: {
      selectOne: 'Seleccione la comunidad deseada'
    },
    events: {
      openDate: 'Fecha de Inicio',
      closeDate: 'Fecha de Finalización'
    },
    posts: {
      viewPost: 'Ver {kind}',
      title: 'Posts',
      searchLabel: 'Buscar miembro por nombre o e-mail',
      actions: {
        create: 'Crear un Nuevo Post',
        start: 'Escribir nuevo post',
        comment: '¿En que estas pensando?'
      },
      removed: 'Post eliminado',
      follow: 'Seguir post',
      unfollow: 'No seguir post',
      writeTitle: 'Escriba un título',
      createBookmark: 'Agregar a los favoritos',
      removeBookmark: 'Quitar de los favoritos',
      kind: {
        post: 'Post',
        event: 'Acontecimiento'
      },
      toTop: 'En la parte superior',
      toAside: 'Ao Lado',
      pinTitle: 'Arreglar',
      pin: {
        top: 'Pin en la parte superior',
        aside: 'Pin ao Lado'
      },
      unpin: {
        top: 'Desanclar desde arriba',
        aside: 'Desenrosque lateral'
      },
      messages: {
        follow: {
          success: 'Post seguido con éxito!',
          error: 'No se pudo seguir el post.'
        },
        unfollow: {
          success: 'Post dejado de seguir con éxito!',
          error: 'No se pudo dejar de seguir el post.'
        },
        createBookmark: {
          success: 'Post agregado a los favoritos con éxito!',
          error: 'No se pudo agregar el post a los favoritos.'
        },
        removeBookmark: {
          success: 'Post quitado de los favoritos con éxito!',
          error: 'No se pudo quitar el post de los favoritos.'
        },
        create: {
          error: 'Rellene el título, el tag y el contenido'
        }
      }
    },
    badges: {
      title: 'Medallas',
      assign: 'Dar medallas',
      select: 'Seleccione una o más medallas',
      selected: 'Ninguna medalla seleccionada | 1 medalla seleccionada | {count} medallas seleccionadas',
      no_badges_registered: 'No hay medallas catastradas'
    },
    comments: {
      loadAll: 'Carregar todos los comentarios',
      title: 'No hay comentarios | 1 comentario | {count} comentarios',
      label: 'Comentarios',
      actions: {
        create: 'Comentar',
        remove: 'Quitar Comentario',
        update: 'Actualizar Comentario',
        comment: 'Escribir un comentario'
      },
      warnings: {
        remove: 'Está seguro de que desea eliminar este comentario'
      },
      replies: {
        view: '1 respuesta | {count} respuestas',
        viewMore: 'Ver más respuestas'
      }
    },
    useTerms: {
      title: 'Terminos de Uso',
      accept: 'Aceptar Terminos de Uso',
      decline: 'Rechazo los terminos',
      agreed: 'Acepto los terminos de uso de la comunidad',
      seeTerms: 'Ver los terminos de uso de la comunidad'
    },
    moderation: {
      title: 'Moderación',
      postStatus: 'Estado del post',
      status: {
        pending: 'Pendiente',
        visible: 'Visible',
        locked: 'Bloqueado',
        muted: 'En silencio'
      },
      filters: {
        apply: 'Aplicar',
        pending: 'Pendientes',
        locked: 'Bloqueados',
        muted: 'En silencio',
        posts: 'Filtrar posts',
        comments: 'Filtrar comentarios'
      }
    },
    tags: {
      popular: 'Etiquetas más populares',
      add: 'Haz clic y / o escribe para añadir etiquetas',
      showAll: 'Muestra todo',
      showLess: 'Muestra menos',
      selectLabel: 'Haz clic o presione enter para añadir',
      deselectLabel: 'Haz clic o presione enter para eliminar',
      selectedLabel: 'Agregada',
      emptyListLabel: 'la lista esta vacía',
      all: 'Todas las etiquetas'
    },
    rules: {
      title: 'Normas',
      sidebarLabel: 'Normas de la comunidad'
    },
    orders: {
      resultCount: 'Mostrando {resultCount} de {totalResult} miembros',
      apply: 'Aplicar',
      label: 'ORDENAR MIEMBROS POR',
      posts: 'Más mensajes creados',
      postLikes: 'Más curtidos recibidos en los posts',
      comments: 'Más comentarios',
      commentLikes: 'Más curtidos recibidos en comentarios',
      badges: 'Mayor cantidad de medallas'
    },
    notifications: {
      title: 'Notificaciones',
      timeFrom: 'Hace {time}',
      seeAll: 'Ver todo',
      markAsRead: 'Marcar como leído',
      markAsUnread: 'Marcar como no leído',
      markAllAsRead: 'Marcar todas como leídas'
    },
    bookmark: {
      title: 'Favoritos'
    },
    medias: {
      video: {
        urlPlaceholder: 'Youtube o Vimeo URL',
        postTitle: 'Añadir vídeo al post',
        commentTitle: 'Añadir vídeo al comentario',
        add: 'Añadir al post'
      }
    }
  },
  pagination: {
    first: 'Primera',
    last: 'Última',
    next: 'Seguiente',
    previous: 'Anterior'
  },
  emojis: {
    search: 'Buscar',
    notfound: 'No hay Emoji encontrado',
    categories: {
      search: 'Resultados',
      recent: 'Reciente',
      people: 'Gente & Smileys',
      nature: 'Animales & Naturaleza',
      foods: 'Comida y Bebida',
      activity: 'Actividad',
      places: 'Viajes y Lugares',
      objects: 'Objetos',
      symbols: 'Simbolos',
      flags: 'Banderas',
      custom: 'Personalizado'
    }
  },
  textEditor: {
    toolbar: {
      fontSize: 'Tamaño de Fuente',
      fontType: 'Tipo de Fuente',
      align: 'Alinear texto',
      headerType: 'Tipo de Encabezado',
      clean: 'Limpiar Texto',
      textColor: 'Color de Texto',
      textBackground: 'Color de fondo de Texto',
      bold: 'Negrito',
      italic: 'Itálico',
      underlined: 'Subrayado',
      strike: 'Rayado',
      unorderedList: 'Lista no Ordenada',
      orderedList: 'Lista Ordenada',
      link: 'Insertar Link',
      image: 'Insertar Imagen',
      subscript: 'Subscript',
      superscript: 'Superscript',
      blockquote: 'Cita',
      increaseIndent: 'Aumentar la Indentación',
      decreaseIndent: 'Disminuir la Indentación'
    },
    fontSize: {
      small: 'small',
      medium: 'medium',
      large: 'large',
      huge: 'huge'
    },
    font: {
      sansSerif: 'Sans Serif',
      serif: 'Serif',
      monospace: 'Monospace'
    }
  }
});

/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  monthNames: {
    short: {
      january: 'JAN',
      february: 'FEV',
      march: 'MAR',
      april: 'ABR',
      may: 'MAI',
      june: 'JUN',
      july: 'JUL',
      august: 'AGO',
      september: 'SET',
      october: 'OUT',
      november: 'NOV',
      december: 'DEZ'
    },
    long: {
      january: 'Janeiro',
      february: 'Fevereiro',
      march: 'Março',
      april: 'Abril',
      may: 'Maio',
      june: 'Junho',
      july: 'Julho',
      august: 'Agosto',
      september: 'Setembro',
      october: 'Outubro',
      november: 'Novembro',
      december: 'Dezembro'
    }
  },
  pageNotFound: {
    warning: 'Página não encontrada :(',
    backToPortal: 'Voltar ao portal'
  },
  login: {
    email: {
      label: 'E-mail de Usuário',
      placeholder: 'Email'
    },
    password: {
      label: 'Senha',
      placeholder: 'Senha',
      forgot: 'Esqueceu a senha?',
      show: 'Exibir Senha'
    },
    recoverPassword: {
      greetings: 'Olá',
      label: 'Informe seu e-mail cadastrado abaixo. Mandaremos um link para redefinir a sua senha.',
      resetPasswordLabel: 'Configure uma nova senha a baixo',
      errorMessage: 'Email não encontrado ou bloqueado.',
      successMessage: 'Sucesso! O processo de renovação de senha foi enviado para o seu email.',
      renewMessage: 'Preencha o formulário para renovar sua senha.',
      renewError: 'Erro ao renovar a senha, tente novamente.',
      smallPasswordError: 'Sua senha deve ter no mínimo 8 caracteres',
      wrongPasswordError: 'As senhas digitas não conferem',
      renewSuccess: 'Senha atualizada com sucesso.',
      button: 'REDEFINIR SENHA',
      backToLogin: 'Voltar ao login',
      newPassword: 'Nova senha',
      newPasswordConfirm: 'Confirme nova senha'
    },
    keepMeLogged: {
      label: 'Mantenha-me Logado'
    },
    signInButton: {
      label: 'ENTRAR'
    },
    welcome: 'Bem-vindo!',
    signin: 'Conecte-se na sua conta',
    error: 'Erro ao efetuar o login, verifique os dados informados.',
    errorNotFound: 'Entre em contato com o suporte',
    renew: 'Você renovou e o endereço mudou para um projeto'
  },
  index: {
    content: {
      introduction: 'Introdução',
      showIntroduction: 'MOSTRAR INTRODUÇÃO',
      hideIntroduction: 'ESCONDER INTRODUÇÃO',
      minutes: 'Minutos',
      classes: 'Aulas',
      showClasses: 'EXIBIR AULAS',
      hideClasses: 'ESCONDER AULAS',
      dateOpenModule: 'ESTE MÓDULO SERÁ LIBERADO EM',
      openSubmodule: 'ABRIR SUBMÓDULO',
      closeSubmodule: 'FECHAR SUBMÓDULO',
      completed: 'COMPLETO',
      concluded: 'CONCLUÍDO',
      completedAt: 'CONCLUÍDO EM',
      beginClass: 'INICIAR AULA',
      emptyMessage: 'No momento não há nenhum conteúdo para este módulo!.',
      progressiveUnavailable: 'COMPLETE AS AULAS ANTERIORES'
    },
    header: {
      startCourse: 'INICIAR CURSO',
      resumeCourse: 'CONTINUAR CURSO',
      notes: {
        button: 'MINHAS ANOTAÇÕES',
        modal: {
          title: 'Minhas anotações',
          download: 'BAIXAR NOTAS'
        }
      },
      faq: {
        button: 'PERGUNTAS FREQUENTES',
        modal: {
          title: 'Perguntas frequentes'
        }
      },
      search: {
        title: 'O que você está procurando?',
        popularTags: 'TAGS POPULARES',
        resultCount: '{resultCount} resultados encontrados com o filtro "{searchFilter}"',
        seeMore: 'Veja Mais'
      },
      nextClass: {
        title: 'SUA PRÓXIMA AULA'
      },
      emailSupport: 'suporte@ignicaodigital.com.br',
      doubts: 'Tem dúvidas ou problemas? Fale com o nosso suporte:'
    },
    sidebar: {
      completedModules: 'MÓDULOS COMPLETADOS'
    }
  },
  general: {
    labels: {
      loading: 'Carregando...',
      uploading: 'Fazendo Upload'
    },
    actions: {
      search: 'Pesquisar',
      communitySearch: 'Buscar na comunidade',
      clearSearch: 'Limpar busca',
      start: 'COMEÇAR',
      cancel: 'Cancelar',
      orderBy: 'Ordenar por',
      updateChanges: 'SALVAR ALTERAÇÕES',
      access: 'Acessar',
      edit: 'Editar',
      remove: 'Remover',
      save: 'Salvar',
      back: 'Voltar',
      mute: 'Silenciar',
      unmute: 'Tirar {user} do modo silencioso',
      saveChanges: 'Salvar Alterações',
      filter: 'Filtrar'
    },
    messages: {
      noRecordFound: 'Nenhum registro encontrado'
    },
    time: {
      formatFns: 'd/M/YYYY - H:mm',
      format: 'd/m/Y - H:i \\hr\\s',
      min: 'Min'
    }
  },
  logout: {
    label: 'Sair'
  },
  class: {
    details: {
      tags: 'Tags',
      nav: {
        description: 'Descrição',
        comments: 'Comentários',
        extraContent: 'Extra',
        notes: 'Anotações'
      },
      comments: {
        title: 'Comentários',
        reply: 'Responder',
        remove: 'Remover',
        post: 'Postar',
        pending: 'AGUARDANDO MODERAÇÃO',
        highlight: 'Destacar Resposta',
        highlighted: 'Resposta Destacada',
        removeHighlight: 'Remover Destaque'
      },
      downloads: {
        download: 'Baixar',
        visualize: 'Visualizar'
      }
    },
    progress: {
      completeClass: 'COMPLETAR AULA',
      moveToNext: 'E IR PARA A PRÓXIMA',
      moveToPrev: 'VOLTAR PARA AULA ANTERIOR',
      seeIndex: 'VER ÍNDICE DE AULAS'
    },
    sidebar: {
      module: 'Módulo',
      noContent: 'No momento não existe nenhum conteúdo'
    }
  },
  profile: {
    loadingImage: 'Carregando Imagem...',
    imageAlt: 'Imagem de Perfil',
    changeImage: 'Alterar Imagem',
    fileSizeError: 'O tamanho da imagem é superior ao permitido',
    errorLoadingImage: 'Erro ao carregar imagem',
    menuTitle: 'MEU PERFIL E SENHA',
    name: 'Nome',
    password: 'Senha',
    retypePassword: 'Confirmar Senha',
    passwords: {
      alertError: 'Erro atualizando a senha, verifique os dados informados.',
      alertSuccess: 'Senha atualizada com sucesso.',
      notMatching: 'As senhas informadas são divergentes.'
    },
    updatedMessage: 'Perfil atualizado com sucesso',
    updateError: 'Erro atualizando perfil, tente novamente mais tarde'
  },
  cookie: {
    disabled: 'Cookies não habilitados',
    enable: 'Os cookies do seu navegador não estão ativados, reative e recarregue a página.'
  },
  banner: {
    defaultText: 'Edite o seu banner nas configurações',
    defaultButtonText: 'Ação do botão'
  },
  community: {
    notFound: 'Comunidade não encontrada',
    title: 'Comunidade',
    night_mode: 'Modo noturno',
    discussion: 'Discussão',
    labels: {
      like: 'Curtir',
      liked: 'Curtido',
      likes: 'Curtidas',
      bestComments: 'Melhor resposta',
      updatedAt: 'Atualizado a'
    },
    users: {
      title: 'Usuários',
      members: 'Membros',
      notMuted: 'Não silenciado',
      profile: {
        title: 'Perfil',
        view: 'Ver Perfil',
        header: 'Perfil do Usuário',
        statistics: 'Estatísticas',
        badges: 'Medalhas',
        notifications: 'Notificações por Email',
        createdPosts: 'Posts Criados',
        createdComments: 'Comentários Criados',
        likes: 'Curtidas',
        postsLikes: 'Curtidas de Posts',
        commentsLikes: 'Curtidas de Comentários'
      },
      mailSettings: {
        info: 'Me notifique quando...',
        postComment: 'Alguém comentar no meu post',
        postLike: 'Alguém curtir o meu post',
        followedPostComment: 'Alguém comentar em um post que estou seguindo',
        followedPostLike: 'Alguém curtir um post que estou seguindo',
        commentLike: 'Alguém curtir um comentário que escrevi',
        reply: 'Alguém responder um comentário que escrevi',
        postMention: 'Alguém me mencionar em um post',
        commentMention: 'Alguém me mencionar em um comentário',
        badge: 'Eu receber uma medalha',
        postApproved: 'Meu post for aprovado',
        commentApproved: 'Meu comentário for aprovado'
      }
    },
    list: {
      selectOne: 'Selecione a Comunidade Desejada'
    },
    events: {
      openDate: 'Início',
      closeDate: 'Fim'
    },
    posts: {
      viewPost: 'Visualizar {kind}',
      title: 'Posts',
      searchLabel: 'Buscar membro por nome ou e-mail',
      actions: {
        create: 'Criar Novo Post',
        start: 'Escrever novo post',
        comment: 'No que você está pensando?'
      },
      removed: 'Post removido',
      follow: 'Seguir post',
      unfollow: 'Não seguir post',
      writeTitle: 'Escreva um título',
      createBookmark: 'Adicionar aos favoritos',
      removeBookmark: 'Remover dos favoritos',
      kind: {
        post: 'Post',
        event: 'Evento'
      },
      toTop: 'No Topo',
      toAside: 'Na Lateral',
      pinTitle: 'Fixar',
      pin: {
        top: 'Fixar no Topo',
        aside: 'Fixar na Lateral'
      },
      unpin: {
        top: 'Desafixar do Topo',
        aside: 'Desafixar da Lateral'
      },
      messages: {
        follow: {
          success: 'Post seguido com sucesso!',
          error: 'Não foi possível seguir o post.'
        },
        unfollow: {
          success: 'Post deixado de seguir com sucesso!',
          error: 'Não foi possível deixar de seguir o post.'
        },
        createBookmark: {
          success: 'Post adicionado aos favoritos com sucesso!',
          error: 'Não foi possível adicionar o post aos favoritos.'
        },
        removeBookmark: {
          success: 'Post removido dos favoritos com sucesso!',
          error: 'Não foi possível remover o post dos favoritos.'
        },
        create: {
          error: 'Preencha o título, a tag e o conteúdo'
        }
      }
    },
    badges: {
      title: 'Medalhas',
      assign: 'Dar medalhas',
      select: 'Selecione uma ou mais medalhas',
      selected: 'Nenhuma medalha selecionada | 1 medalha selecionada | {count} medalhas selecionadas',
      no_badges_registered: 'Não existem medalhas cadastradas'
    },
    comments: {
      loadAll: 'Carregar todos os comentários',
      title: 'Nenhum comentário | 1 comentário | {count} comentários',
      label: 'Comentários',
      actions: {
        create: 'Comentar',
        remove: 'Remover Comentário',
        update: 'Atualizar Comentário',
        comment: 'Escrever um comentário'
      },
      warnings: {
        remove: 'Tem certeza que deseja remover este comentário'
      },
      replies: {
        view: '1 resposta | {count} respostas',
        viewMore: 'Ver mais respostas'
      }
    },
    useTerms: {
      title: 'Termos de Uso',
      accept: 'Aceitar Termos de Uso',
      decline: 'Eu recuso os termos',
      agreed: 'Aceito os termos de uso da comunidade',
      seeTerms: 'Ver termos de uso da comunidade'
    },
    moderation: {
      title: 'Moderação',
      postStatus: 'Status do post',
      status: {
        pending: 'Pendente',
        visible: 'Visível',
        locked: 'Trancado',
        muted: 'Silenciado'
      },
      filters: {
        apply: 'Aplicar',
        locked: 'Trancados',
        pending: 'Pendentes',
        muted: 'Silenciados',
        posts: 'Filtrar posts',
        comments: 'Filtrar comentários'
      }
    },
    tags: {
      popular: 'Tags mais populares',
      add: 'Clique e/ou digite para adicionar tags',
      showAll: 'Mostrar tudo',
      showLess: 'Mostrar menos',
      selectLabel: 'Clique ou pressione enter para adicionar',
      deselectLabel: 'Clique ou pressione enter para remover',
      selectedLabel: 'Adicionada',
      emptyListLabel: 'Não existem tags disponíveis',
      all: 'Todas as tags'
    },
    rules: {
      title: 'Regras',
      sidebarLabel: 'Regras da comunidade'
    },
    orders: {
      resultCount: 'Mostrando {resultCount} de {totalResult} membros',
      apply: 'Aplicar',
      recent: 'Mais recente',
      popular: 'Mais popular',
      label: 'ORDENAR MEMBROS POR',
      posts: 'Mais posts criados',
      postLikes: 'Mais curtidas recebidas em posts',
      comments: 'Mais comentários escritos',
      commentLikes: 'Mais curtidas recebidas em comentários',
      badges: 'Maior quantidade de medalhas',
      bestComments: 'Maior quantidade de boas respostas em comentários'
    },
    notifications: {
      title: 'Notificações',
      timeFrom: '{time} atrás',
      seeAll: 'Ver tudo',
      markAsRead: 'Marcar como lida',
      markAsUnread: 'Marcar como não lida',
      markAllAsRead: 'Marcar todas como lidas'
    },
    bookmark: {
      title: 'Favoritos'
    },
    medias: {
      video: {
        urlPlaceholder: 'URL do Youtube ou Vimeo',
        postTitle: 'Adicionar vídeo ao post',
        commentTitle: 'Adicionar vídeo ao comentário',
        add: 'Adicionar ao post'
      }
    }
  },
  pagination: {
    first: 'Primeira',
    last: 'Última',
    next: 'Próxima',
    previous: 'Anterior'
  },
  emojis: {
    search: 'Pesquisa',
    notfound: 'Nenhum Emoji encontrado',
    categories: {
      search: 'Resultado',
      recent: 'Recentes',
      people: 'Pessoas & Smileys',
      nature: 'Animais & Natureza',
      foods: 'Comida & Bebidas',
      activity: 'Atividade',
      places: 'Viagem & Lugares',
      objects: 'Objetos',
      symbols: 'Símbolos',
      flags: 'Bandeiras',
      custom: 'Personalizado'
    }
  },
  textEditor: {
    toolbar: {
      fontSize: 'Tamanho da Fonte',
      fontType: 'Tipo da Fonte',
      align: 'Alinhar Texto',
      headerType: 'Tipo de Cabeçalho',
      clean: 'Limpar Texto',
      textColor: 'Cor do Texto',
      textBackground: 'Cor de Fundo do Texto',
      bold: 'Negrito',
      italic: 'Itálico',
      underlined: 'Sublinhado',
      strike: 'Riscado',
      unorderedList: 'Lista não Ordenada',
      orderedList: 'Lista Ordenada',
      link: 'Inserir Link',
      image: 'Inserir Imagem',
      subscript: 'Subscript',
      superscript: 'Superscript',
      blockquote: 'Citação',
      increaseIndent: 'Aumentar Indentação',
      decreaseIndent: 'Diminuir Indentação'
    },
    fontSize: {
      small: 'pequena',
      medium: 'média',
      large: 'grande',
      huge: 'gigante'
    },
    font: {
      sansSerif: 'Sans Serif',
      serif: 'Serif',
      monospace: 'Monospace'
    }
  }
});

/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App__);



new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  i18n: __WEBPACK_IMPORTED_MODULE_1__config__["a" /* i18n */],
  store: __WEBPACK_IMPORTED_MODULE_1__config__["b" /* store */],
  router: __WEBPACK_IMPORTED_MODULE_1__config__["c" /* router */],
  notifications: __WEBPACK_IMPORTED_MODULE_1__config__["d" /* notifications */],
  vueMeta: __WEBPACK_IMPORTED_MODULE_1__config__["e" /* vueMeta */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_2__App___default.a);
  }
}).$mount('#app');

/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_meta__ = __webpack_require__(322);


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_meta__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_vue_meta__["a" /* default */]);

/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_notification__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_velocity_animate__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_velocity_animate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_velocity_animate__);



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_notification___default.a, {
  velocity: __WEBPACK_IMPORTED_MODULE_2_velocity_animate___default.a
});
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_vue_notification___default.a);

/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(57);


var communityModeration = function communityModeration(to, from, next) {
  var params = {
    communityId: to.params.communityId
  };
  __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].dispatch('community/fetchById', params).then(function () {
    if (__WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.community.activeCommunityUser.permission === 'moderation') {
      return next();
    }

    return next("/community/".concat(to.params.communityId));
  });
};

var postAvailable = function postAvailable(to, from, next) {
  if (!to.params.slug) {
    return next();
  }

  return __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].dispatch('classIndex/checkIfCanBeAccessed', to.params.slug).then(function (response) {
    if (!response.data.by_slug || !response.data.by_slug.available) {
      return next('/*');
    }

    return next();
  });
};

/* harmony default export */ __webpack_exports__["a"] = ({
  communityModeration: communityModeration,
  postAvailable: postAvailable
});

/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_request_domain__ = __webpack_require__(197);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchProject", function() { return fetchProject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetProjectData", function() { return resetProjectData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setImages", function() { return setImages; });


var fetchProject = function fetchProject(_ref) {
  var commit = _ref.commit,
      dispatch = _ref.dispatch;
  return __WEBPACK_IMPORTED_MODULE_1__helpers_request_domain__["a" /* default */].getProjectId().then(function (response) {
    var data = response.data;
    commit(__WEBPACK_IMPORTED_MODULE_0__types__["a" /* SET_PROJECT */], data);
    commit(__WEBPACK_IMPORTED_MODULE_0__types__["b" /* SET_TITLE */], data.name);
    commit(__WEBPACK_IMPORTED_MODULE_0__types__["c" /* SET_DESCRIPTION */], data.description);
    dispatch('setImages', data.theme_medias);
  });
};
var resetProjectData = function resetProjectData(_ref2) {
  var commit = _ref2.commit;
  return commit(__WEBPACK_IMPORTED_MODULE_0__types__["d" /* RESET_PROJECT_DATA */]);
};
var setImages = function setImages(_ref3, images) {
  var commit = _ref3.commit;

  if (images.favicon) {
    var link = document.createElement('link');
    link.setAttribute('rel', 'shortucut icon');
    link.setAttribute('type', 'image/x-icon');
    link.href = images.favicon.url;
    document.head.appendChild(link);
  }

  return commit(__WEBPACK_IMPORTED_MODULE_0__types__["e" /* SET_IMAGES */], images);
};

/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "project", function() { return project; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "projectId", function() { return projectId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "images", function() { return images; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "title", function() { return title; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "description", function() { return description; });
var project = function project(state) {
  return state.project;
};
var projectId = function projectId(state) {
  return state.project.id;
};
var images = function images(state) {
  return state.images;
};
var title = function title(state) {
  return state.title;
};
var description = function description(state) {
  return state.description;
};

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(213);



/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__,
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__,
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* mutations */],
  state: __WEBPACK_IMPORTED_MODULE_2__mutations__["b" /* state */]
});

/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_defineProperty__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_core_js_object_assign__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(87);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return state; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mutations; });



var _mutations;


var project = {
  id: ''
};
var state = {
  project: project,
  images: {},
  title: '',
  description: ''
};
var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__types__["a" /* SET_PROJECT */], function (state, project) {
  state.project = project;
}), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__types__["b" /* SET_TITLE */], function (state, title) {
  state.title = title;
}), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__types__["c" /* SET_DESCRIPTION */], function (state, description) {
  state.description = description;
}), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__types__["d" /* RESET_PROJECT_DATA */], function (state) {
  state.project = project;
}), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__types__["e" /* SET_IMAGES */], function (state, images) {
  state.images = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_core_js_object_assign___default()({}, images);
}), _mutations);

/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(88);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setVisible", function() { return setVisible; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toggleCategory", function() { return toggleCategory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetClassIndex", function() { return resetClassIndex; });

var setVisible = function setVisible(_ref, isVisible) {
  var commit = _ref.commit;
  document.body.className = isVisible ? 'c-modal-open' : '';
  commit(__WEBPACK_IMPORTED_MODULE_0__types__["a" /* SET_VISIBLE */], isVisible);
};
var toggleCategory = function toggleCategory(_ref2, category) {
  var commit = _ref2.commit;
  commit(__WEBPACK_IMPORTED_MODULE_0__types__["b" /* TOGGLE_CATEGORY */], category);
};
var resetClassIndex = function resetClassIndex(_ref3) {
  var commit = _ref3.commit,
      dispatch = _ref3.dispatch;
  commit(__WEBPACK_IMPORTED_MODULE_0__types__["c" /* CLOSE_CATEGORIES */]);
  dispatch('index/fetchCategories', null, {
    root: true
  });
};

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isVisible", function() { return isVisible; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "openCategories", function() { return openCategories; });
var isVisible = function isVisible(state) {
  return state.isVisible;
};
var openCategories = function openCategories(state) {
  return state.openCategories;
};

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(217);



/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__,
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__,
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* mutations */],
  state: __WEBPACK_IMPORTED_MODULE_2__mutations__["b" /* state */]
});

/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_defineProperty__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(88);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return state; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mutations; });


var _mutations;


var state = {
  openCategories: [],
  isVisible: false
};
var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* SET_VISIBLE */], function (state, isVisible) {
  state.isVisible = isVisible;
}), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["b" /* TOGGLE_CATEGORY */], function (state, category) {
  var index = state.openCategories.lastIndexOf(category.id);

  if (index !== -1) {
    state.openCategories = state.openCategories.filter(function (id) {
      return category.id !== id;
    });
    return;
  }

  state.openCategories.push(category.id);
}), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["c" /* CLOSE_CATEGORIES */], function (state) {
  state.openCategories = [];
}), _mutations);

/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(89);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setDuration", function() { return setDuration; });

var setDuration = function setDuration(_ref, duration) {
  var commit = _ref.commit;
  commit(__WEBPACK_IMPORTED_MODULE_0__types__["a" /* SET_DURATION */], duration);
};
/* harmony default export */ __webpack_exports__["default"] = (function () {});

/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "duration", function() { return duration; });
var duration = function duration(state) {
  var minutes = state.duration / 60;
  return Math.floor(minutes);
};
/* harmony default export */ __webpack_exports__["default"] = (function (state) {
  return state;
});

/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(221);



/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__,
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__,
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* mutations */],
  state: __WEBPACK_IMPORTED_MODULE_2__mutations__["b" /* state */]
});

/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_defineProperty__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(89);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return state; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mutations; });


var state = {
  duration: 0
};
var mutations = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* SET_DURATION */], function (state, duration) {
  state.duration = duration;
});

/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_request_api__ = __webpack_require__(0);


var api = function api() {
  return new __WEBPACK_IMPORTED_MODULE_0__helpers_request_api__["a" /* default */]();
};

var getList = function getList(postId) {
  var query = {
    query: "{\n      comments_by_post_id(post_id: ".concat(postId, " ) {\n        id\n        content\n        created_at\n        approved\n        user {\n          name\n          photo\n        }\n        admin_user {\n          name\n          photo\n        }\n        comments_with_pending_approve {\n          id\n          content\n          created_at\n          approved\n          user {\n            name\n            photo\n          }\n          admin_user {\n            name\n            photo\n          }\n          comments_with_pending_approve {\n            id\n            content\n            created_at\n            approved\n            user {\n              name\n              photo\n            }\n            admin_user {\n              name\n              photo\n            }\n          }\n        }\n      }\n    }")
  };
  return api().get(query);
};

var create = function create(postId, comment, commentId, projectId) {
  var safeCommentId = commentId;

  if (!safeCommentId) {
    safeCommentId = null;
  }

  var query = {
    variables: {
      comment: comment
    },
    query: "mutation createUserComment($comment: String!) {\n      createUserComment(\n        input: {\n          post_id: ".concat(postId, "\n          comment_id: ").concat(safeCommentId, "\n          content: $comment\n          project_id: ").concat(projectId, "\n        }\n      ) {\n        comment {\n          id\n          content\n          created_at\n          post_id\n          comment_id\n          user_id\n        }\n        message\n      }\n    }")
  };
  return api().get(query);
};

var destroy = function destroy(id) {
  var query = {
    query: "mutation destroyComment {\n      destroyComment(\n        input: {\n          id: ".concat(id, "\n        }\n      ) {\n        message\n      }\n    }")
  };
  return api().get(query);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  getList: getList,
  create: create,
  destroy: destroy
});

/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__queries_comments__ = __webpack_require__(222);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getList", function() { return getList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "create", function() { return create; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "remove", function() { return remove; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setActiveComment", function() { return setActiveComment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetActiveComment", function() { return resetActiveComment; });


var getList = function getList(_ref, activePostId) {
  var commit = _ref.commit;
  __WEBPACK_IMPORTED_MODULE_1__queries_comments__["a" /* default */].getList(activePostId).then(function (response) {
    var data = response.data;
    commit(__WEBPACK_IMPORTED_MODULE_0__types__["a" /* SET_COMMENT_LIST */], data.comments_by_post_id);
  });
};
var create = function create(_ref2, _ref3) {
  var rootState = _ref2.rootState,
      dispatch = _ref2.dispatch;
  var comment = _ref3.comment,
      commentId = _ref3.commentId,
      projectId = _ref3.projectId;
  var activePost = rootState.classIndex.activePost;
  __WEBPACK_IMPORTED_MODULE_1__queries_comments__["a" /* default */].create(activePost.id, comment, commentId, projectId).then(function () {
    dispatch('getList', activePost.id);
  });
};
var remove = function remove(_ref4) {
  var rootState = _ref4.rootState,
      dispatch = _ref4.dispatch,
      state = _ref4.state;
  var activePost = rootState.classIndex.activePost;
  var id = state.activeComment.id;
  __WEBPACK_IMPORTED_MODULE_1__queries_comments__["a" /* default */].destroy(id).then(function () {
    dispatch('getList', activePost.id);
  });
};
var setActiveComment = function setActiveComment(_ref5, comment) {
  var commit = _ref5.commit;
  return commit(__WEBPACK_IMPORTED_MODULE_0__types__["b" /* SET_ACTIVE_COMMENT */], comment);
};
var resetActiveComment = function resetActiveComment(_ref6) {
  var commit = _ref6.commit;
  return commit(__WEBPACK_IMPORTED_MODULE_0__types__["c" /* RESET_ACTIVE_COMMENT */]);
};

/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "activeTab", function() { return activeTab; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "list", function() { return list; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "activeComment", function() { return activeComment; });
var activeTab = function activeTab(state) {
  return state.activeTab;
};
var list = function list(state) {
  return state.commentList;
};
var activeComment = function activeComment(state) {
  return state.activeComment;
};

/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(226);



/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__,
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__,
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* mutations */],
  state: __WEBPACK_IMPORTED_MODULE_2__mutations__["b" /* state */]
});

/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_define_property__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_core_js_object_define_properties__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_core_js_object_define_properties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_core_js_object_define_properties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_core_js_object_get_own_property_descriptors__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_core_js_object_get_own_property_descriptors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_core_js_object_get_own_property_descriptors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_core_js_object_get_own_property_descriptor__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs2_core_js_object_get_own_property_symbols__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs2_core_js_object_get_own_property_symbols___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs2_core_js_object_get_own_property_symbols__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_corejs2_core_js_object_keys__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_corejs2_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_corejs2_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_corejs2_helpers_defineProperty__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_corejs2_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_corejs2_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__types__ = __webpack_require__(90);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return state; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mutations; });








var _mutations;

function ownKeys(object, enumerableOnly) { var keys = __WEBPACK_IMPORTED_MODULE_5__babel_runtime_corejs2_core_js_object_keys___default()(object); if (__WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs2_core_js_object_get_own_property_symbols___default.a) { var symbols = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs2_core_js_object_get_own_property_symbols___default()(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_core_js_object_get_own_property_descriptor___default()(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_6__babel_runtime_corejs2_helpers_defineProperty___default()(target, key, source[key]); }); } else if (__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_core_js_object_get_own_property_descriptors___default.a) { __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_core_js_object_define_properties___default()(target, __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_core_js_object_get_own_property_descriptors___default()(source)); } else { ownKeys(Object(source)).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_define_property___default()(target, key, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_core_js_object_get_own_property_descriptor___default()(source, key)); }); } } return target; }


var state = {
  commentList: [],
  setActiveComment: {}
};
var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_6__babel_runtime_corejs2_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__types__["a" /* SET_COMMENT_LIST */], function (state, comments) {
  state.commentList = comments;
}), __WEBPACK_IMPORTED_MODULE_6__babel_runtime_corejs2_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__types__["b" /* SET_ACTIVE_COMMENT */], function (state, comment) {
  state.activeComment = _objectSpread({}, comment);
}), __WEBPACK_IMPORTED_MODULE_6__babel_runtime_corejs2_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_7__types__["c" /* RESET_ACTIVE_COMMENT */], function (state) {
  state.activeComment = {};
}), _mutations);

/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_request_api__ = __webpack_require__(0);


var api = function api() {
  return new __WEBPACK_IMPORTED_MODULE_0__helpers_request_api__["a" /* default */]();
};

var load = function load(postId) {
  var query = {
    query: "{\n      post(id: ".concat(postId, "){\n        description\n      }\n    }")
  };
  return api().get(query);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  load: load
});

/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__queries_descriptions__ = __webpack_require__(227);


/* harmony default export */ __webpack_exports__["default"] = (function (_ref) {
  var commit = _ref.commit,
      rootState = _ref.rootState;
  var activePost = rootState.classIndex.activePost;
  __WEBPACK_IMPORTED_MODULE_1__queries_descriptions__["a" /* default */].load(activePost.id).then(function (response) {
    var data = response.data;
    var description = data.post.description;
    commit(__WEBPACK_IMPORTED_MODULE_0__types__["a" /* default */].SET_ACTIVE_DESCRIPTION, description);
  });
});

/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = (function (state) {
  return state.active;
});

/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(231);



/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__,
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__,
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* mutations */],
  state: __WEBPACK_IMPORTED_MODULE_2__mutations__["b" /* state */]
});

/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_defineProperty__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(91);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return state; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mutations; });


var state = {
  active: {}
};
var mutations = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].SET_ACTIVE_DESCRIPTION, function (state, description) {
  state.active = description;
});

/***/ }),
/* 232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(92);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setActiveTab", function() { return setActiveTab; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetActiveTab", function() { return resetActiveTab; });

var setActiveTab = function setActiveTab(_ref, slug) {
  var commit = _ref.commit;
  commit(__WEBPACK_IMPORTED_MODULE_0__types__["a" /* SET_ACTIVE_TAB */], slug);
};
var resetActiveTab = function resetActiveTab(_ref2) {
  var commit = _ref2.commit;
  commit(__WEBPACK_IMPORTED_MODULE_0__types__["b" /* RESET_ACTIVE_TAB */]);
};

/***/ }),
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "activeTab", function() { return activeTab; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "test", function() { return test; });
var activeTab = function activeTab(state) {
  return state.activeTab;
};
var test = function test(state) {
  return state;
};

/***/ }),
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(235);



/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__,
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__,
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* mutations */],
  state: __WEBPACK_IMPORTED_MODULE_2__mutations__["b" /* state */]
});

/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_defineProperty__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(92);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return state; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mutations; });


var _mutations;


var defaultTab = 'description';
var state = {
  activeTab: defaultTab
};
var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* SET_ACTIVE_TAB */], function (state, slug) {
  state.activeTab = slug;
}), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["b" /* RESET_ACTIVE_TAB */], function (state) {
  state.activeTab = defaultTab;
}), _mutations);

/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_request_api__ = __webpack_require__(0);


var api = function api() {
  return new __WEBPACK_IMPORTED_MODULE_0__helpers_request_api__["a" /* default */]();
};

var load = function load(postId) {
  var query = {
    query: "{\n      note(id: ".concat(postId, ") {\n        id\n        content\n        post {\n          id\n        }\n      }\n    }")
  };
  return api().get(query);
};

var save = function save(note) {
  var query = {
    variables: {
      content: note.content
    },
    query: "mutation postNote($content: String!) {\n      postNote(input: {\n        content: $content,\n        post_id: ".concat(note.postId, "\n      })\n      {\n        note {\n          id\n          content\n          post {\n            id\n          }\n        }\n      }\n    }")
  };
  return api().get(query);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  load: load,
  save: save
});

/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__queries_notes__ = __webpack_require__(236);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "load", function() { return load; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "save", function() { return save; });


var load = function load(_ref) {
  var commit = _ref.commit,
      rootState = _ref.rootState;
  var activePost = rootState.classIndex.activePost;
  commit(__WEBPACK_IMPORTED_MODULE_0__types__["a" /* default */].SET_ACTIVE_NOTE, {});
  return __WEBPACK_IMPORTED_MODULE_1__queries_notes__["a" /* default */].load(activePost.id).then(function (response) {
    var data = response.data;
    var note = data.note;
    commit(__WEBPACK_IMPORTED_MODULE_0__types__["a" /* default */].SET_ACTIVE_NOTE, note);
  });
};
var save = function save(_ref2, noteContent) {
  var commit = _ref2.commit,
      rootState = _ref2.rootState;
  var activePost = rootState.classIndex.activePost;
  var note = {
    postId: activePost.id,
    content: noteContent
  };
  __WEBPACK_IMPORTED_MODULE_1__queries_notes__["a" /* default */].save(note).then(function (response) {
    var data = response.data;
    var postNote = data.postNote;
    commit(__WEBPACK_IMPORTED_MODULE_0__types__["a" /* default */].SET_ACTIVE_NOTE, postNote.note);
  });
};

/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = (function (state) {
  return state.active;
});

/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(240);



/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__,
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__,
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* mutations */],
  state: __WEBPACK_IMPORTED_MODULE_2__mutations__["b" /* state */]
});

/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_defineProperty__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(93);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return state; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mutations; });


var state = {
  active: {}
};
var mutations = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].SET_ACTIVE_NOTE, function (state, note) {
  state.active = note;
});

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(94);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setActiveTab", function() { return setActiveTab; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetActiveTab", function() { return resetActiveTab; });

var setActiveTab = function setActiveTab(_ref, slug) {
  var commit = _ref.commit;
  commit(__WEBPACK_IMPORTED_MODULE_0__types__["a" /* SET_ACTIVE_TAB */], slug);
};
var resetActiveTab = function resetActiveTab(_ref2) {
  var commit = _ref2.commit;
  commit(__WEBPACK_IMPORTED_MODULE_0__types__["b" /* RESET_ACTIVE_TAB */]);
};

/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "activeTab", function() { return activeTab; });
var activeTab = function activeTab(state) {
  return state.activeTab;
};
/* harmony default export */ __webpack_exports__["default"] = (function (state) {
  return state;
});

/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(244);



/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__,
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__,
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* mutations */],
  state: __WEBPACK_IMPORTED_MODULE_2__mutations__["b" /* state */]
});

/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_defineProperty__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(94);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return state; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mutations; });


var _mutations;


var defaultTab = 'description';
var state = {
  activeTab: defaultTab
};
var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* SET_ACTIVE_TAB */], function (state, slug) {
  state.activeTab = slug;
}), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["b" /* RESET_ACTIVE_TAB */], function (state) {
  state.activeTab = defaultTab;
}), _mutations);

/***/ }),
/* 245 */
/***/ (function(module, exports) {



/***/ }),
/* 246 */
/***/ (function(module, exports) {



/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__getters__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__mutations__);



/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__,
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__,
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__["mutations"],
  state: __WEBPACK_IMPORTED_MODULE_2__mutations__["state"]
});

/***/ }),
/* 248 */
/***/ (function(module, exports) {



/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_request_api__ = __webpack_require__(0);


var api = function api() {
  return new __WEBPACK_IMPORTED_MODULE_0__helpers_request_api__["a" /* default */]();
};

var bySlug = function bySlug(slug) {
  var query = {
    query: "{\n      by_slug(slug: \"".concat(slug, "\"){\n        id\n        title\n        amount_comments\n        estimated_time\n        enable_comment\n        primary_category {\n          name\n          quantity_finished_posts\n          progress\n        }\n        category {\n          name\n        }\n        tags {\n          tag\n        }\n        medias {\n          id\n          title\n          description\n          content\n          is_primary_by_slug(slug: \"").concat(slug, "\")\n          slug\n          media_kind {\n            id\n            slug\n          }\n        }\n        user_post {\n          id\n          status\n        }\n      }\n    }")
  };
  return api().get(query);
};

var checkIfCanBeAccessed = function checkIfCanBeAccessed(slug) {
  var query = {
    query: "{\n      by_slug(slug: \"".concat(slug, "\") {\n        available\n      }\n    }")
  };
  return api().get(query);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  bySlug: bySlug,
  checkIfCanBeAccessed: checkIfCanBeAccessed
});

/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_request_api__ = __webpack_require__(0);


var api = function api() {
  return new __WEBPACK_IMPORTED_MODULE_0__helpers_request_api__["a" /* default */]();
};

var create = function create(userPostId) {
  var query = {
    query: "mutation createUserPostHit {\n      createUserPostHit(input: {\n        user_post_id: ".concat(userPostId, "\n      })\n      {\n        user_post_hit {\n          id\n        }\n        message\n      }\n    }")
  };
  return api().get(query);
};

var update = function update(userPostHitId) {
  var query = {
    query: "mutation updateUserPostHit {\n      updateUserPostHit(\n        input: {\n          id: ".concat(userPostHitId, "\n        }\n      )\n      {\n        message\n      }\n    }")
  };
  return api().get(query);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  create: create,
  update: update
});

/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__queries_post__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__queries_userPostHit__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Index_queries_relatedClasses__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(25);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchPostData", function() { return fetchPostData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchNextPost", function() { return fetchNextPost; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "registerPostHit", function() { return registerPostHit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updatePostHit", function() { return updatePostHit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "checkIfCanBeAccessed", function() { return checkIfCanBeAccessed; });





var fetchPostData = function fetchPostData(_ref) {
  var commit = _ref.commit,
      dispatch = _ref.dispatch,
      rootState = _ref.rootState;
  var currentSlug = rootState.route.params.slug;
  if (!currentSlug) return dispatch('fetchNextPost');
  return __WEBPACK_IMPORTED_MODULE_1__queries_post__["a" /* default */].bySlug(currentSlug).then(function (response) {
    var post = response.data.by_slug;
    commit(__WEBPACK_IMPORTED_MODULE_0__types__["a" /* SET_ACTIVE_POST */], post);
    dispatch('registerPostHit', post.user_post.id);
  });
};
var fetchNextPost = function fetchNextPost() {
  return __WEBPACK_IMPORTED_MODULE_3__Index_queries_relatedClasses__["a" /* default */].fetch().then(function (response) {
    var data = response.data;
    var nextPost = data.related_classes[0].post;
    __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */].push({
      name: 'class',
      params: {
        slug: nextPost.slug
      }
    });
  });
};
var registerPostHit = function registerPostHit(_ref2, userPostId) {
  var commit = _ref2.commit;
  __WEBPACK_IMPORTED_MODULE_2__queries_userPostHit__["a" /* default */].create(userPostId).then(function (response) {
    var data = response.data;
    var createUserPostHit = data.createUserPostHit;
    commit(__WEBPACK_IMPORTED_MODULE_0__types__["c" /* SET_USER_POST_HIT */], createUserPostHit.user_post_hit.id);
  });
};
var updatePostHit = function updatePostHit(_ref3) {
  var state = _ref3.state;
  var userPostHit = state.userPostHit;

  if (!userPostHit.id) {
    return;
  }

  __WEBPACK_IMPORTED_MODULE_2__queries_userPostHit__["a" /* default */].update(userPostHit.id);
};
var checkIfCanBeAccessed = function checkIfCanBeAccessed(_ref4, slug) {
  var _ = _ref4._;
  return __WEBPACK_IMPORTED_MODULE_1__queries_post__["a" /* default */].checkIfCanBeAccessed(slug);
};

/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "medias", function() { return medias; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "activePost", function() { return activePost; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "media", function() { return media; });
var medias = function medias(state) {
  return state.activePost.medias;
};
var activePost = function activePost(state) {
  return state.activePost;
};
var media = function media(state) {
  if (state.activePost.medias.length) {
    return state.activePost.medias.filter(function (mediaToCheck) {
      return mediaToCheck.is_primary_by_slug;
    })[0];
  }

  return {};
};

/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(254);



/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__,
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__,
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* mutations */],
  state: __WEBPACK_IMPORTED_MODULE_2__mutations__["b" /* state */]
});

/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_defineProperty__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(95);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return state; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mutations; });


var _mutations;


var state = {
  activePost: {
    medias: []
  },
  userPostHit: {}
};
var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* SET_ACTIVE_POST */], function (state, activePost) {
  state.activePost = activePost;
}), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["b" /* RESET_ACTIVE_POST */], function (state) {
  state.activePost = {
    medias: []
  };
}), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["c" /* SET_USER_POST_HIT */], function (state, userPostHitId) {
  state.userPostHit = {
    id: userPostHitId
  };
}), _mutations);

/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_request_api__ = __webpack_require__(0);


var complete = function complete(classId) {
  var api = new __WEBPACK_IMPORTED_MODULE_0__helpers_request_api__["a" /* default */]();
  var query = {
    query: "mutation completeUserPost{\n      completeUserPost(input: {\n        post_id: ".concat(classId, "\n      })\n      { message }\n    }")
  };
  return api.get(query);
};

var getNext = function getNext(currentPostId) {
  var api = new __WEBPACK_IMPORTED_MODULE_0__helpers_request_api__["a" /* default */]();
  var query = {
    query: "{\n      next_post(id: ".concat(currentPostId, ") {\n        slug\n      }\n    }")
  };
  return api.get(query);
};

var getPrevious = function getPrevious(currentPostId) {
  var api = new __WEBPACK_IMPORTED_MODULE_0__helpers_request_api__["a" /* default */]();
  var query = {
    query: "{\n      previous_post(id: ".concat(currentPostId, ") {\n        slug\n      }\n    }")
  };
  return api.get(query);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  complete: complete,
  getNext: getNext,
  getPrevious: getPrevious
});

/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__queries_class__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(25);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "complete", function() { return complete; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sendToNextClass", function() { return sendToNextClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sendToPreviousClass", function() { return sendToPreviousClass; });


var complete = function complete(_ref, classId) {
  var _ = _ref._;
  return __WEBPACK_IMPORTED_MODULE_0__queries_class__["a" /* default */].complete(classId);
};
var sendToNextClass = function sendToNextClass(_ref2) {
  var rootState = _ref2.rootState;
  var classId = rootState.classIndex.activePost.id;
  __WEBPACK_IMPORTED_MODULE_0__queries_class__["a" /* default */].getNext(classId).then(function (response) {
    var data = response.data;
    var nextPost = data.next_post;

    if (!nextPost) {
      __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push({
        name: 'index'
      });
    }

    __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push({
      name: 'class',
      params: {
        slug: nextPost.slug
      }
    });
  });
};
var sendToPreviousClass = function sendToPreviousClass(_ref3) {
  var rootState = _ref3.rootState;
  var classId = rootState.classIndex.activePost.id;
  __WEBPACK_IMPORTED_MODULE_0__queries_class__["a" /* default */].getPrevious(classId).then(function (response) {
    var data = response.data;
    var previousPost = data.previous_post;

    if (!previousPost) {
      __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push({
        name: 'index'
      });
    }

    __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push({
      name: 'class',
      params: {
        slug: previousPost.slug
      }
    });
  });
};

/***/ }),
/* 257 */
/***/ (function(module, exports) {



/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__getters__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__mutations__);



/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__,
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__,
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__["mutations"],
  state: __WEBPACK_IMPORTED_MODULE_2__mutations__["state"]
});

/***/ }),
/* 259 */
/***/ (function(module, exports) {



/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_request_api__ = __webpack_require__(0);


var api = function api() {
  return new __WEBPACK_IMPORTED_MODULE_0__helpers_request_api__["a" /* default */]();
};

var getList = function getList(communityId) {
  var query = {
    query: "{ community_badges(community_id: \"".concat(communityId, "\")\n      {\n        id\n        name\n        medal_color\n        tie_color\n        description\n        icon {\n          icon\n        }\n        community_badge_image_url\n        created_at\n        updated_at\n      }\n    }")
  };
  return api().get(query);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  getList: getList
});

/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_request_api__ = __webpack_require__(0);


var api = function api() {
  return new __WEBPACK_IMPORTED_MODULE_0__helpers_request_api__["a" /* default */]();
};

var fetchPostComments = function fetchPostComments(postData) {
  var postId = postData.postId;
  var page = postData.page || 1;
  var query = {
    variables: {
      postId: postId,
      page: page
    },
    query: "query community_post_comments($postId: String!, $page: Int!) {\n      community_post_comments(\n        community_post_id: $postId,\n        page: $page,\n        comment_id: ".concat(postData.commentId, "\n      ) {\n        id\n        content\n        moderation_state\n        number_of_replies\n        comment_id\n        cached_votes_up\n        liked_by_user\n        best_comment\n        medias {\n          id\n          url\n          kind\n        }\n        user {\n          id\n          name\n          photo\n        }\n        community_user {\n          id\n          permission\n          is_active\n          is_muted\n        }\n      }\n    }")
  };
  return api().get(query);
};

var countPostComments = function countPostComments(postId) {
  var query = {
    variables: {
      postId: postId
    },
    query: "query count_community_post_comments($postId: String!) {\n      count_community_post_comments(community_post_id: $postId) {}\n    }"
  };
  return api().get(query);
};

var createComment = function createComment(commentData) {
  var content = commentData.content,
      postId = commentData.postId,
      parentCommentId = commentData.parentCommentId,
      videos = commentData.videos,
      images = commentData.images,
      mentions = commentData.mentions;
  var query = {
    variables: {
      content: content,
      videos: videos,
      images: images,
      mentions: mentions
    },
    query: "mutation createCommunityPostComment($content: String!, $videos: [String], $images: [String], $mentions: [Int]) {\n      createCommunityPostComment(input: {\n        community_post_id: ".concat(postId, ",\n        content: $content,\n        comment_id: ").concat(parentCommentId, ",\n        videos: $videos,\n        images: $images,\n        mentions: $mentions\n      }) {\n        community_post_comment {\n          id\n          content\n          moderation_state\n          number_of_replies\n          comment_id\n          cached_votes_up\n          liked_by_user\n          best_comment\n          medias {\n            id\n            url\n            kind\n          }\n          user {\n            id\n            name\n            photo\n          }\n          community_user {\n            id\n            permission\n            is_active\n            is_muted\n          }\n        }\n      }\n    }")
  };
  return api().get(query);
};

var updateComment = function updateComment(commentData) {
  var content = commentData.content,
      id = commentData.id,
      videos = commentData.videos,
      images = commentData.images,
      mentions = commentData.mentions;
  var query = {
    variables: {
      content: content,
      videos: videos,
      images: images,
      mentions: mentions
    },
    query: "mutation updateUserCommunityPostComment($content: String!, $videos: [String], $images: [String], $mentions: [Int]) {\n      updateUserCommunityPostComment(input: {\n        id: ".concat(id, ",\n        content: $content,\n        videos: $videos,\n        images: $images,\n        mentions: $mentions\n      }) {\n        community_post_comment {\n          id\n          content\n          moderation_state\n          comment_id\n          cached_votes_up\n          liked_by_user\n          best_comment\n          medias {\n            id\n            url\n            kind\n          }\n          user {\n            id\n            name\n            photo\n          }\n          community_user {\n            id\n            permission\n            is_active\n            is_muted\n          }\n        }\n      }\n    }")
  };
  return api().get(query);
};

var destroyComment = function destroyComment(commentId) {
  var query = {
    query: "mutation destroyCommunityPostComment {\n      destroyCommunityPostComment(input: {\n        id: ".concat(commentId, "\n      }) {\n        message\n      }\n    }")
  };
  return api().get(query);
};

var like = function like(commentId) {
  var query = {
    query: "mutation likeCommunityPostComment {\n      likeCommunityPostComment(input: {\n        id: ".concat(commentId, "\n      }) {\n        community_post_comment {\n          id\n          content\n          moderation_state\n          comment_id\n          cached_votes_up\n          liked_by_user\n          best_comment\n          medias {\n            id\n            url\n            kind\n          }\n          user {\n            id\n            name\n            photo\n          }\n          community_user {\n            id\n            permission\n            is_active\n            is_muted\n          }\n        }\n        message\n      }\n    }")
  };
  return api().get(query);
};

var updateModerationState = function updateModerationState(data) {
  var moderationState = data.moderationState;
  var query = {
    variables: {
      moderationState: moderationState
    },
    query: "mutation updateAdminCommunityPostComment ($moderationState: String!) {\n      updateAdminCommunityPostComment(\n        input: {\n          id: ".concat(data.commentId, ",\n          moderation_state: $moderationState\n        }\n      ) {\n        community_post_comment {\n          id\n          content\n          liked_by_user\n          cached_votes_up\n          moderation_state\n          comment_id\n          best_comment\n          medias {\n            id\n            url\n            kind\n          }\n          user {\n            id\n            name\n            photo\n          }\n          community_user {\n            id\n            permission\n            is_active\n            is_muted\n          }\n        }\n        message\n      }\n    }")
  };
  return api().get(query);
};

var fetchById = function fetchById(commentId) {
  var query = {
    query: "query community_post_comment {\n      community_post_comment(id: ".concat(commentId, ")\n      {\n        id\n        content\n        moderation_state\n        number_of_replies\n        comment_id\n        cached_votes_up\n        liked_by_user\n        best_comment\n        medias {\n          id\n          url\n          kind\n        }\n        user {\n          id\n          name\n          photo\n        }\n        community_user {\n          id\n          permission\n          is_active\n          is_muted\n        }\n      }\n    }")
  };
  return api().get(query);
};

var fetchCommunityComments = function fetchCommunityComments(communityId, params) {
  var page = params.page,
      moderationState = params.moderationState;
  var query = {
    variables: {
      moderationState: moderationState
    },
    query: "query community_comments($moderationState: [String]) {\n      community_comments(\n        community_id: \"".concat(communityId, "\",\n        moderation_state: $moderationState,\n        page: ").concat(page || 1, ",\n      )\n      {\n        id\n        content\n        moderation_state\n        created_at\n        updated_at\n        best_comment\n        user {\n          id\n          name\n          photo\n        }\n        community_post {\n          id\n          title\n          content\n          created_at\n          user {\n            id\n            name\n            photo\n          }\n          community_user {\n            id\n            permission\n            is_active\n            is_muted\n          }\n        }\n        community_user {\n          id\n          permission\n          is_active\n          is_muted\n        }\n        comment_id\n        parent_comment {\n          id\n          content\n          moderation_state\n          created_at\n          updated_at\n          best_comment\n          user {\n            id\n            name\n            photo\n          }\n          community_user {\n            id\n            permission\n            is_active\n            is_muted\n          }\n        }\n      }\n    }")
  };
  return api().get(query);
};

var countCommunityComments = function countCommunityComments(communityId, moderationState) {
  var query = {
    variables: {
      moderationState: moderationState
    },
    query: "query count_community_comments($moderationState: [String]) {\n      count_community_comments(community_id: \"".concat(communityId, "\", moderation_state: $moderationState) {}\n    }")
  };
  return api().get(query);
};

var toggleBestComment = function toggleBestComment(comment) {
  var query = {
    query: "mutation toggleBestComment {\n      toggleBestComment(\n        input: {\n          id: ".concat(comment.id, "\n        }\n      )\n      {\n        community_post_comment {\n          id\n          content\n          moderation_state\n          number_of_replies\n          comment_id\n          cached_votes_up\n          liked_by_user\n          best_comment\n          medias {\n            id\n            url\n            kind\n          }\n          user {\n            id\n            name\n            photo\n          }\n          community_user {\n            id\n            permission\n            is_active\n            is_muted\n          }\n        }\n      }\n    }")
  };
  return api().get(query);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  createComment: createComment,
  fetchPostComments: fetchPostComments,
  countPostComments: countPostComments,
  updateComment: updateComment,
  destroyComment: destroyComment,
  updateModerationState: updateModerationState,
  like: like,
  fetchById: fetchById,
  fetchCommunityComments: fetchCommunityComments,
  countCommunityComments: countCommunityComments,
  toggleBestComment: toggleBestComment
});

/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_request_api__ = __webpack_require__(0);


var api = function api() {
  return new __WEBPACK_IMPORTED_MODULE_0__helpers_request_api__["a" /* default */]();
};

var fetchUserCommunities = function fetchUserCommunities() {
  var query = {
    query: "{\n      user_communities {\n        id\n        agreed_terms\n        permission\n        is_muted\n        community {\n          id\n          name\n          use_terms\n          enable_use_terms\n          is_open\n          updated_at\n          auto_approval_post\n          auto_approval_comment\n          moderator_alias\n        }\n      }\n    }"
  };
  return api().get(query);
};

var fetchById = function fetchById(communityId) {
  var showLoader = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var query = {
    query: "{\n      user_community(community_id: \"".concat(communityId, "\") {\n        id\n        agreed_terms\n        permission\n        is_muted\n        theme\n        is_active\n        qty_post_bookmarks\n        qty_not_read_notifications\n        user {\n          id\n          name\n          photo\n        }\n        community {\n          id\n          name\n          description\n          use_terms\n          enable_use_terms\n          is_open\n          posts_to_moderate\n          comments_to_moderate\n          updated_at\n          auto_approval_post\n          auto_approval_comment\n          moderator_alias\n        }\n      }\n    }")
  };
  return api().get(query, showLoader);
};

var acceptUseTerms = function acceptUseTerms(communityId) {
  var query = {
    query: "mutation acceptUseTerms {\n      acceptUseTerms(input: {\n        community_id: ".concat(communityId, "\n      }) {\n        community_user {\n          id\n          agreed_terms\n          permission\n          is_muted\n          theme\n          is_active\n          qty_not_read_notifications\n          user {\n            id\n            name\n            photo\n          }\n          community {\n            id\n            name\n            use_terms\n            enable_use_terms\n            is_open\n            posts_to_moderate\n            comments_to_moderate\n            updated_at\n            auto_approval_post\n            auto_approval_comment\n            moderator_alias\n          }\n        }\n      }\n    }")
  };
  return api().get(query);
};

var changeUserTheme = function changeUserTheme(_ref) {
  var communityId = _ref.communityId,
      theme = _ref.theme;
  var query = {
    query: "mutation changeCommunityUserTheme {\n      changeCommunityUserTheme(input: {\n        community_id: ".concat(communityId, "\n        theme: \"").concat(theme, "\"\n      }) {\n        community_user {\n          id\n          agreed_terms\n          permission\n          is_muted\n          theme\n          is_active\n          qty_not_read_notifications\n          qty_post_bookmarks\n          user {\n            id\n            name\n            photo\n          }\n          community {\n            id\n            name\n            use_terms\n            enable_use_terms\n            is_open\n            posts_to_moderate\n            comments_to_moderate\n            updated_at\n            auto_approval_post\n            auto_approval_comment\n            moderator_alias\n          }\n        }\n      }\n    }")
  };
  return api().get(query);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  acceptUseTerms: acceptUseTerms,
  fetchUserCommunities: fetchUserCommunities,
  fetchById: fetchById,
  changeUserTheme: changeUserTheme
});

/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_request_api__ = __webpack_require__(0);


var api = function api() {
  return new __WEBPACK_IMPORTED_MODULE_0__helpers_request_api__["a" /* default */]();
};

var postAttributes = "{\n  id\n  title\n  content\n  kind\n  open_date\n  close_date\n  liked_by_user\n  cached_votes_up\n  moderation_state\n  number_of_comments\n  created_at\n  followed_by_user\n  bookmarked\n  pinned_at\n  pinned_at_aside\n  medias {\n    id\n    url\n    kind\n  }\n  user {\n    id\n    name\n    photo\n  }\n  community_user {\n    id\n    permission\n    is_active\n    is_muted\n    qty_badges\n  }\n  tags {\n    id\n    name\n  }\n}";

var fetchPosts = function fetchPosts(params) {
  var communityId = params.communityId,
      title = params.title,
      content = params.content,
      moderationState = params.moderationState,
      _params$tag = params.tag,
      tag = _params$tag === void 0 ? null : _params$tag,
      _params$kind = params.kind,
      kind = _params$kind === void 0 ? '' : _params$kind,
      postsOrderBy = params.postsOrderBy;
  var page = params.page || 1;
  var student = '';
  var search = '';

  if (params.search && params.search.startsWith('#')) {
    student = params.search.substring(1).trim();
  } else {
    search = params.search;
  }

  var query = {
    variables: {
      communityId: communityId,
      page: page,
      title: title,
      content: content,
      postsOrderBy: postsOrderBy,
      search: search,
      moderationState: moderationState,
      student: student
    },
    query: "query community_posts($communityId: String!, $page: Int!, $title: String, $postsOrderBy: String, $content: String, $search: String, $moderationState: [String], $student: String) {\n      community_posts(\n        community_id: $communityId,\n        page: $page,\n        tag: ".concat(tag, ",\n        kind: \"").concat(kind, "\",\n        title: $title,\n        order_column: $postsOrderBy,\n        content: $content,\n        moderation_state: $moderationState,\n        search: $search,\n        student: $student\n      ) ").concat(postAttributes, "\n    }")
  };
  return api().get(query);
};

var countPosts = function countPosts(params) {
  var communityId = params.communityId,
      title = params.title,
      content = params.content,
      moderationState = params.moderationState,
      _params$tag2 = params.tag,
      tag = _params$tag2 === void 0 ? null : _params$tag2,
      _params$kind2 = params.kind,
      kind = _params$kind2 === void 0 ? '' : _params$kind2;
  var student = '';
  var search = '';

  if (params.search && params.search.startsWith('#')) {
    student = params.search.substring(1).trim();
  } else {
    search = params.search;
  }

  var query = {
    variables: {
      communityId: communityId,
      title: title,
      content: content,
      search: search,
      moderationState: moderationState,
      student: student
    },
    query: "query count_community_posts($communityId: String!, $title: String, $content: String, $search: String, $moderationState: [String], $student: String) {\n      count_community_posts(\n        community_id: $communityId,\n        tag: ".concat(tag, ",\n        kind: \"").concat(kind, "\",\n        title: $title,\n        content: $content,\n        moderation_state: $moderationState,\n        search: $search,\n        student: $student,\n      ) {}\n    }")
  };
  return api().get(query);
};

var fetchAsidePosts = function fetchAsidePosts(params) {
  var communityId = params.communityId,
      title = params.title,
      content = params.content,
      search = params.search,
      moderationState = params.moderationState,
      _params$tag3 = params.tag,
      tag = _params$tag3 === void 0 ? null : _params$tag3;
  var page = params.page || 1;
  var query = {
    variables: {
      communityId: communityId,
      page: page,
      title: title,
      content: content,
      search: search,
      moderationState: moderationState
    },
    query: "query community_aside_posts($communityId: String!, $page: Int!, $title: String, $content: String, $search: String, $moderationState: [String]) {\n      community_aside_posts(\n        community_id: $communityId,\n        page: $page,\n        tag: ".concat(tag, ",\n        is_pinned_aside: true,\n        title: $title,\n        content: $content,\n        moderation_state: $moderationState,\n        search: $search\n      ) ").concat(postAttributes, "\n    }")
  };
  return api().get(query);
};

var countAsidePosts = function countAsidePosts(params) {
  var communityId = params.communityId,
      title = params.title,
      content = params.content,
      search = params.search,
      moderationState = params.moderationState,
      _params$tag4 = params.tag,
      tag = _params$tag4 === void 0 ? null : _params$tag4;
  var query = {
    variables: {
      communityId: communityId,
      title: title,
      content: content,
      search: search,
      moderationState: moderationState
    },
    query: "query count_community_aside_posts($communityId: String!, $title: String, $content: String, $search: String, $moderationState: [String]) {\n      count_community_aside_posts(\n        community_id: $communityId,\n        tag: ".concat(tag, ",\n        is_pinned_aside: true,\n        title: $title,\n        content: $content,\n        moderation_state: $moderationState,\n        search: $search\n      ) {}\n    }")
  };
  return api().get(query);
};

var createPost = function createPost(postData) {
  var openDate = postData.open_date || '';
  var closeDate = postData.close_date || '';
  var pinnedAt = postData.pinned_at || '';
  var pinnedAtAside = postData.pinned_at_aside || '';
  var title = postData.title,
      communityId = postData.communityId,
      content = postData.content,
      kind = postData.kind,
      tags = postData.tags,
      videos = postData.videos,
      images = postData.images,
      mentions = postData.mentions;
  var query = {
    variables: {
      title: title,
      content: content,
      kind: kind,
      openDate: openDate,
      closeDate: closeDate,
      pinnedAt: pinnedAt,
      pinnedAtAside: pinnedAtAside,
      tags: tags,
      videos: videos,
      images: images,
      mentions: mentions
    },
    query: "mutation createCommunityPost(\n      $title: String!,\n      $content: String,\n      $kind: String!,\n      $openDate: String!,\n      $closeDate: String!,\n      $pinnedAt: String!,\n      $pinnedAtAside: String!,\n      $tags: [Int],\n      $videos: [String],\n      $images: [String],\n      $mentions: [Int]\n    ) {\n      createCommunityPost(input: {\n        community_id: ".concat(communityId, ",\n        title: $title,\n        content: $content,\n        kind: $kind,\n        open_date: $openDate,\n        close_date: $closeDate,\n        pinned_at: $pinnedAt,\n        pinned_at_aside: $pinnedAtAside,\n        videos: $videos,\n        images: $images,\n        tags: $tags,\n        mentions: $mentions\n      }) {\n        community_post ").concat(postAttributes, "\n      }\n    }")
  };
  return api().get(query);
};

var updatePost = function updatePost(data) {
  var openDate = data.open_date || '';
  var closeDate = data.close_date || '';
  var pinnedAt = data.pinned_at || '';
  var pinnedAtAside = data.pinned_at_aside || '';
  var tags = data.tags,
      videos = data.videos,
      title = data.title,
      content = data.content,
      kind = data.kind,
      id = data.id,
      images = data.images;
  var query = {
    variables: {
      title: title,
      content: content,
      kind: kind,
      openDate: openDate,
      closeDate: closeDate,
      pinnedAt: pinnedAt,
      pinnedAtAside: pinnedAtAside,
      tags: tags,
      videos: videos,
      images: images
    },
    query: "mutation updateUserCommunityPost(\n      $title: String!,\n      $content: String!,\n      $kind: String!,\n      $openDate: String!,\n      $closeDate: String!,\n      $pinnedAt: String!,\n      $pinnedAtAside: String!,\n      $tags: [Int],\n      $videos: [String],\n      $images: [String]\n    ) {\n      updateUserCommunityPost(input: {\n        id: ".concat(id, ",\n        title: $title,\n        content: $content,\n        kind: $kind,\n        open_date: $openDate,\n        close_date: $closeDate,\n        pinned_at: $pinnedAt,\n        pinned_at_aside: $pinnedAtAside,\n        videos: $videos,\n        images: $images,\n        tags: $tags\n      }) {\n        community_post ").concat(postAttributes, "\n      }\n    }")
  };
  return api().get(query);
};

var fetchPost = function fetchPost(postId) {
  var query = {
    query: "query community_post {\n      community_post(id: ".concat(postId, ") ").concat(postAttributes, "\n    }")
  };
  return api().get(query);
};

var updateModerationState = function updateModerationState(data) {
  var moderationState = data.moderationState;
  var query = {
    variables: {
      moderationState: moderationState
    },
    query: "mutation updateAdminCommunityPost ($moderationState: String!) {\n      updateAdminCommunityPost(\n        input: {\n          id: ".concat(data.postId, ",\n          moderation_state: $moderationState\n        }\n      ) {\n        community_post ").concat(postAttributes, "\n        message\n      }\n    }")
  };
  return api().get(query);
};

var likePost = function likePost(id) {
  var query = {
    query: "mutation likeCommunityPost {\n      likeCommunityPost(input: {\n        id: ".concat(id, "\n      }) {\n        community_post ").concat(postAttributes, "\n      }\n    }")
  };
  return api().get(query);
};

var destroy = function destroy(id) {
  var query = {
    query: "mutation destroyCommunityPost {\n      destroyCommunityPost(\n        input: {\n          id: ".concat(id, "\n        }\n      )\n      {\n        message\n      }\n    }")
  };
  return api().get(query);
};

var follow = function follow(id) {
  var query = {
    query: "mutation followCommunityPost {\n      followCommunityPost(\n        input: {\n          id: ".concat(id, "\n        }\n      )\n      {\n        community_post ").concat(postAttributes, "\n        message\n      }\n    }")
  };
  return api().get(query);
};

var unfollow = function unfollow(id) {
  var query = {
    query: "mutation unfollowCommunityPost {\n      unfollowCommunityPost(\n        input: {\n          id: ".concat(id, "\n        }\n      )\n      {\n        community_post ").concat(postAttributes, "\n        message\n      }\n    }")
  };
  return api().get(query);
};

var fetchBookmarkedPosts = function fetchBookmarkedPosts(communityData) {
  var communityId = communityData.communityId,
      _communityData$search = communityData.search,
      search = _communityData$search === void 0 ? '' : _communityData$search,
      _communityData$tag = communityData.tag,
      tag = _communityData$tag === void 0 ? null : _communityData$tag;
  var page = communityData.page || 1;
  var query = {
    variables: {
      communityId: communityId,
      page: page,
      search: search
    },
    query: "query community_bookmark_posts($communityId: String!, $page: Int!, $search: String) {\n      community_bookmark_posts(\n        community_id: $communityId,\n        page: $page,\n        tag: ".concat(tag, ",\n        search: $search\n      ) ").concat(postAttributes, "\n    }")
  };
  return api().get(query);
};

var countBookmarkedPosts = function countBookmarkedPosts(communityData) {
  var communityId = communityData.communityId,
      search = communityData.search,
      _communityData$tag2 = communityData.tag,
      tag = _communityData$tag2 === void 0 ? null : _communityData$tag2;
  var query = {
    variables: {
      communityId: communityId,
      search: search
    },
    query: "query count_community_bookmark_posts($communityId: String!, $search: String) {\n      count_community_bookmark_posts(\n        community_id: $communityId,\n        tag: ".concat(tag, ",\n        search: $search\n      ) {}\n    }")
  };
  return api().get(query);
};

var createBookmark = function createBookmark(id) {
  var query = {
    query: "mutation createBookmarkCommunityPost {\n      createBookmarkCommunityPost(\n        input: {\n          id: ".concat(id, "\n        }\n      )\n      {\n        community_post ").concat(postAttributes, "\n        message\n      }\n    }")
  };
  return api().get(query);
};

var removeBookmark = function removeBookmark(id) {
  var query = {
    query: "mutation removeBookmarkCommunityPost {\n      removeBookmarkCommunityPost(\n        input: {\n          id: ".concat(id, "\n        }\n      )\n      {\n        community_post ").concat(postAttributes, "\n        message\n      }\n    }")
  };
  return api().get(query);
};

var pin = function pin(postId) {
  var query = {
    query: "mutation pinCommunityPost {\n      pinCommunityPost(\n        input: {\n          id: ".concat(postId, "\n        }\n      )\n      {\n        community_post {\n          id\n          pinned_at\n        }\n      }\n    }")
  };
  return api().get(query);
};

var pinAside = function pinAside(postId) {
  var query = {
    query: "mutation pinAsideCommunityPost {\n      pinAsideCommunityPost(\n        input: {\n          id: ".concat(postId, "\n        }\n      )\n      {\n        community_post {\n          id\n          pinned_at_aside\n        }\n      }\n    }")
  };
  return api().get(query);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  fetchPosts: fetchPosts,
  countPosts: countPosts,
  fetchAsidePosts: fetchAsidePosts,
  countAsidePosts: countAsidePosts,
  createPost: createPost,
  updatePost: updatePost,
  fetchPost: fetchPost,
  updateModerationState: updateModerationState,
  likePost: likePost,
  destroy: destroy,
  follow: follow,
  unfollow: unfollow,
  fetchBookmarkedPosts: fetchBookmarkedPosts,
  countBookmarkedPosts: countBookmarkedPosts,
  createBookmark: createBookmark,
  removeBookmark: removeBookmark,
  pin: pin,
  pinAside: pinAside
});

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_request_api__ = __webpack_require__(0);


var api = function api() {
  return new __WEBPACK_IMPORTED_MODULE_0__helpers_request_api__["a" /* default */]();
};

var fetchTags = function fetchTags(communityData) {
  var communityId = communityData.communityId;
  var query = {
    variables: {
      communityId: communityId
    },
    query: "query community_all_tags($communityId: String!) {\n      community_all_tags(\n        community_id: $communityId,\n      ) {\n        id\n        name\n        description\n      }\n    }"
  };
  return api().get(query);
};

var fetchPopularTags = function fetchPopularTags(communityId, postFilter) {
  var query = {
    query: "query popular_community_tags {\n      popular_community_tags(\n        community_id: ".concat(communityId, ",\n        search: \"").concat(postFilter.search, "\",\n        moderation_state: \"").concat(postFilter.moderationState, "\"\n      ) {\n        id\n        name\n        posts\n      }\n    }")
  };
  return api().get(query);
};

var fetchPopularCommunityBookmarkedTags = function fetchPopularCommunityBookmarkedTags(communityId) {
  var query = {
    query: "query popular_community_bookmarked_tags {\n      popular_community_bookmarked_tags(\n        community_id: \"".concat(communityId, "\",\n      ) {\n        id\n        name\n        posts\n      }\n    }")
  };
  return api().get(query);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  fetchTags: fetchTags,
  fetchPopularTags: fetchPopularTags,
  fetchPopularCommunityBookmarkedTags: fetchPopularCommunityBookmarkedTags
});

/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_request_api__ = __webpack_require__(0);


var api = function api() {
  return new __WEBPACK_IMPORTED_MODULE_0__helpers_request_api__["a" /* default */]();
};

var communityUserProfileData = function communityUserProfileData(extra) {
  return "{\n  id\n  qty_valid_posts\n  qty_valid_post_likes\n  qty_visible_comments\n  qty_visible_comment_likes\n  qty_visible_comment_best_comments\n  permission\n  is_active\n  is_muted\n  user {\n    id\n    name\n    email\n    status\n    photo\n  }\n  badges {\n    id\n    name\n    medal_color\n    tie_color\n    icon {\n      icon\n    }\n    community_badge_image_url\n  }\n  user_badges {\n    id\n    badge {\n      id\n      name\n      medal_color\n      tie_color\n      icon {\n        icon\n      }\n      community_badge_image_url\n    }\n  }\n  qty_badges\n  ".concat(extra, "\n}");
};

var emailSettings = "email_settings {\n    kind\n  }";

var fetch = function fetch(communityId, page, orderBy) {
  var search = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
  var query = {
    variables: {
      communityId: communityId,
      page: page,
      orderBy: orderBy,
      search: search
    },
    query: "query community_users($communityId: String!, $page: Int!, $orderBy: String, $search: String) {\n      community_users(\n        community_id: $communityId,\n        page: $page,\n        order_column: $orderBy,\n        order_attribute: \"DESC\",\n        by_data: $search,\n      ) ".concat(communityUserProfileData(emailSettings), "\n    }")
  };
  return api().get(query);
};

var searchUsers = function searchUsers(data) {
  var search = data.search,
      communityId = data.communityId;
  var query = {
    query: "query search_community_users {\n      search_community_users(\n        search: \"".concat(search, "\",\n        community_id: ").concat(communityId, ",\n      ) {\n        id\n        user {\n          id\n          name\n          email\n          status\n          photo\n        }\n      }\n    }")
  };
  return api().get(query);
};

var updateState = function updateState(userData) {
  var id = userData.id,
      is_muted = userData.is_muted,
      permission = userData.permission,
      is_active = userData.is_active;
  var query = {
    variables: {
      id: Number(id),
      is_muted: is_muted,
      permission: permission,
      is_active: is_active
    },
    query: "mutation updateCommunityUserState($id: Int!, $permission: String!, $is_active: Boolean!, $is_muted: Boolean!) {\n      updateCommunityUserState(\n        input: {\n          id: $id,\n          permission: $permission,\n          is_active: $is_active,\n          is_muted: $is_muted,\n        }\n      )\n      {\n        community_user {\n          id,\n          permission\n          is_active\n          is_muted\n          user {\n            id\n            name\n            email\n            status\n            photo\n          }\n        }\n        message\n      }\n    }"
  };
  return api().get(query);
};

var getCount = function getCount(communityId) {
  var search = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var query = {
    variables: {
      communityId: communityId,
      search: search
    },
    query: "query count_community_users($communityId: Int!, $search: String) {\n      count_community_users(community_id: $communityId, by_data: $search) {}\n    }"
  };
  return api().get(query);
};

var fetchNotifications = function fetchNotifications(communityId, page) {
  var query = {
    query: "query community_user_notifications {\n      community_user_notifications(\n        community_id: ".concat(communityId, ",\n        page: ").concat(page, ",\n      ) {\n        id\n        message\n        kind\n        created_at\n        read\n        community_post_id\n        community_post_comment_id\n        community_user_badge_id\n        sender_user {\n          name\n          photo\n        }\n        community_sender_user {\n          id\n        }\n      }\n    }")
  };
  return api().get(query);
};

var fetchTotalNotifications = function fetchTotalNotifications(communityId) {
  var query = {
    query: "query count_community_user_notifications {\n      count_community_user_notifications(community_id: ".concat(communityId, ") {}\n    }")
  };
  return api().get(query);
};

var updateReadNotification = function updateReadNotification(notificationId, notificationRead) {
  var query = {
    query: "mutation updateReadNotification {\n      updateReadNotification(\n        input: {\n          notification_id: [".concat(notificationId, "]\n          notification_read: ").concat(notificationRead, "\n        }\n      )\n      {\n        community_notifications {\n          id\n          read\n          kind\n          created_at\n          sender_user {\n            name\n            photo\n          }\n        }\n        message\n      }\n    }")
  };
  return api().get(query);
};

var markAllAsReadNotification = function markAllAsReadNotification(communityId) {
  var query = {
    query: "mutation markAllAsRead {\n      markAllAsRead(\n        input: {\n          community_id: ".concat(communityId, "\n        }\n      )\n      {\n        message\n      }\n    }")
  };
  return api().get(query);
};

var updateEmailSettings = function updateEmailSettings(userData) {
  var communityUserId = userData.communityUserId,
      kinds = userData.kinds;
  var query = {
    variables: {
      kinds: kinds
    },
    query: "mutation updateCommunityUserEmailSettings($kinds: [String]) {\n      updateCommunityUserEmailSettings(\n        input: {\n          community_user_id: ".concat(communityUserId, ",\n          kinds: $kinds,\n        }\n      )\n      {\n        community_user {\n          id\n          email_settings {\n            kind\n          }\n        }\n        message\n      }\n    }")
  };
  return api().get(query);
};

var getProfileData = function getProfileData(communityUserId) {
  var isSameUser = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var attributes = isSameUser ? communityUserProfileData(emailSettings) : communityUserProfileData('');
  var query = {
    variables: {
      communityUserId: communityUserId
    },
    query: "query community_user_profile_data($communityUserId: String!) {\n      community_user_profile_data(\n        community_user_id: $communityUserId\n      )\n      ".concat(attributes, "\n    }")
  };
  return api().get(query);
};

var assignBadges = function assignBadges(data) {
  var isSameUser = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var attributes = isSameUser ? communityUserProfileData(emailSettings) : communityUserProfileData('');
  var query = {
    variables: data,
    query: "mutation assignBadges($userId: String!, $badges: [Int]!) {\n      assignBadges(\n        input: {\n          community_user_id: $userId,\n          badges: $badges,\n        }\n      )\n      {\n        community_user ".concat(attributes, "\n        message\n      }\n    }")
  };
  return api().get(query);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  fetch: fetch,
  getCount: getCount,
  searchUsers: searchUsers,
  updateState: updateState,
  fetchNotifications: fetchNotifications,
  fetchTotalNotifications: fetchTotalNotifications,
  updateReadNotification: updateReadNotification,
  markAllAsReadNotification: markAllAsReadNotification,
  updateEmailSettings: updateEmailSettings,
  getProfileData: getProfileData,
  assignBadges: assignBadges
});

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_define_property__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_core_js_object_define_properties__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_core_js_object_define_properties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_core_js_object_define_properties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_core_js_object_get_own_property_descriptors__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_core_js_object_get_own_property_descriptors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_core_js_object_get_own_property_descriptors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_core_js_object_get_own_property_descriptor__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs2_core_js_object_get_own_property_symbols__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs2_core_js_object_get_own_property_symbols___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs2_core_js_object_get_own_property_symbols__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_corejs2_core_js_object_keys__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_corejs2_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_corejs2_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_corejs2_core_js_parse_int__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_corejs2_core_js_parse_int___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_corejs2_core_js_parse_int__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_corejs2_helpers_defineProperty__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_corejs2_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_corejs2_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_corejs2_helpers_objectWithoutProperties__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_corejs2_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_corejs2_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__types__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__queries_community__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__queries_comment__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__queries_post__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__queries_tag__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__queries_user__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__queries_badge__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__helpers_request_communityMedia__ = __webpack_require__(196);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchList", function() { return fetchList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setActive", function() { return setActive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchTags", function() { return fetchTags; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetPosts", function() { return resetPosts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "countAsidePosts", function() { return countAsidePosts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchAsidePosts", function() { return fetchAsidePosts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchAndCountAsidePosts", function() { return fetchAndCountAsidePosts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "appendAsidePinnedPost", function() { return appendAsidePinnedPost; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updatePostOnAsideList", function() { return updatePostOnAsideList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "countPosts", function() { return countPosts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchPosts", function() { return fetchPosts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchAppendPosts", function() { return fetchAppendPosts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchPost", function() { return fetchPost; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setActivePost", function() { return setActivePost; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createPost", function() { return createPost; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchAndCountPosts", function() { return fetchAndCountPosts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "postsOrderBy", function() { return postsOrderBy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updatePost", function() { return updatePost; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updatePostOnList", function() { return updatePostOnList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateModerationState", function() { return updateModerationState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchPostComments", function() { return fetchPostComments; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchAndAppendPostComments", function() { return fetchAndAppendPostComments; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchAndSetPostComments", function() { return fetchAndSetPostComments; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "countPostComments", function() { return countPostComments; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setActiveComment", function() { return setActiveComment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetActiveComment", function() { return resetActiveComment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createComment", function() { return createComment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateComment", function() { return updateComment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "destroyComment", function() { return destroyComment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchCommentReplies", function() { return fetchCommentReplies; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setActiveTerm", function() { return setActiveTerm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "acceptUseTerms", function() { return acceptUseTerms; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchById", function() { return fetchById; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "likePost", function() { return likePost; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "likeComment", function() { return likeComment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateActivePost", function() { return updateActivePost; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updatePostList", function() { return updatePostList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateCommentModerationState", function() { return updateCommentModerationState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updatePostCommentList", function() { return updatePostCommentList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateReplyList", function() { return updateReplyList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addReplyOnList", function() { return addReplyOnList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "changeUserTheme", function() { return changeUserTheme; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchPopularCommunityBookmarkedTags", function() { return fetchPopularCommunityBookmarkedTags; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchPopularTags", function() { return fetchPopularTags; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setTagFilter", function() { return setTagFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setSearchFilter", function() { return setSearchFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setMemberSearch", function() { return setMemberSearch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setModerationStateFilter", function() { return setModerationStateFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toggleModerationStateFilter", function() { return toggleModerationStateFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetPostFilter", function() { return resetPostFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "destroyPost", function() { return destroyPost; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchCommentById", function() { return fetchCommentById; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "uploadPostMedia", function() { return uploadPostMedia; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "uploadPostImage", function() { return uploadPostImage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setPostUpload", function() { return setPostUpload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetPostUpload", function() { return resetPostUpload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchComments", function() { return fetchComments; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "countComments", function() { return countComments; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateCommentList", function() { return updateCommentList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "changeMobileSidebar", function() { return changeMobileSidebar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "followPost", function() { return followPost; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "unfollowPost", function() { return unfollowPost; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchUsers", function() { return fetchUsers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "countUsers", function() { return countUsers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "searchUsers", function() { return searchUsers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateUserState", function() { return updateUserState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateUserStateOnList", function() { return updateUserStateOnList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "usersOrderBy", function() { return usersOrderBy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setActiveUser", function() { return setActiveUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetActiveUser", function() { return resetActiveUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toggleAsReadNotification", function() { return toggleAsReadNotification; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "markAllAsReadNotification", function() { return markAllAsReadNotification; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchUserNotifications", function() { return fetchUserNotifications; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchTotalUserNotifications", function() { return fetchTotalUserNotifications; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateEmailSettings", function() { return updateEmailSettings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createPostBookmark", function() { return createPostBookmark; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removePostBookmark", function() { return removePostBookmark; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "countBookmarkedPosts", function() { return countBookmarkedPosts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchBookmarkedPosts", function() { return fetchBookmarkedPosts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchAppendBookmarkedPosts", function() { return fetchAppendBookmarkedPosts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCommunityUserProfile", function() { return getCommunityUserProfile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetCommunityUserProfile", function() { return resetCommunityUserProfile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addPostCommentToList", function() { return addPostCommentToList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadUniqueComment", function() { return loadUniqueComment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadUniquePrimaryComment", function() { return loadUniquePrimaryComment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetPostComments", function() { return resetPostComments; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetCommentReplies", function() { return resetCommentReplies; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "pin", function() { return pin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "pinAside", function() { return pinAside; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getBadgesList", function() { return getBadgesList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "assignBadges", function() { return assignBadges; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setReplyingComment", function() { return setReplyingComment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toggleBestComment", function() { return toggleBestComment; });










function ownKeys(object, enumerableOnly) { var keys = __WEBPACK_IMPORTED_MODULE_5__babel_runtime_corejs2_core_js_object_keys___default()(object); if (__WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs2_core_js_object_get_own_property_symbols___default.a) { var symbols = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs2_core_js_object_get_own_property_symbols___default()(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_core_js_object_get_own_property_descriptor___default()(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_7__babel_runtime_corejs2_helpers_defineProperty___default()(target, key, source[key]); }); } else if (__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_core_js_object_get_own_property_descriptors___default.a) { __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_core_js_object_define_properties___default()(target, __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_core_js_object_get_own_property_descriptors___default()(source)); } else { ownKeys(Object(source)).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_define_property___default()(target, key, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_core_js_object_get_own_property_descriptor___default()(source, key)); }); } } return target; }









var fetchList = function fetchList(_ref) {
  var commit = _ref.commit;
  return __WEBPACK_IMPORTED_MODULE_10__queries_community__["a" /* default */].fetchUserCommunities().then(function (response) {
    var data = response.data;
    commit(__WEBPACK_IMPORTED_MODULE_9__types__["a" /* SET_COMMUNITIES_LIST */], data.user_communities);
  });
};
var setActive = function setActive(_ref2, communityData) {
  var commit = _ref2.commit;

  var community = communityData.community,
      communityUser = __WEBPACK_IMPORTED_MODULE_8__babel_runtime_corejs2_helpers_objectWithoutProperties___default()(communityData, ["community"]);

  commit(__WEBPACK_IMPORTED_MODULE_9__types__["b" /* SET_ACTIVE_COMMUNITY */], community);
  commit(__WEBPACK_IMPORTED_MODULE_9__types__["c" /* SET_ACTIVE_COMMUNITY_USER */], communityUser);
};
var fetchTags = function fetchTags(_ref3, communityData) {
  var commit = _ref3.commit;
  return __WEBPACK_IMPORTED_MODULE_13__queries_tag__["a" /* default */].fetchTags(communityData).then(function (response) {
    var data = response.data;
    commit(__WEBPACK_IMPORTED_MODULE_9__types__["d" /* SET_TAGS */], data.community_all_tags);
  });
};
var resetPosts = function resetPosts(_ref4) {
  var commit = _ref4.commit;
  return commit(__WEBPACK_IMPORTED_MODULE_9__types__["h" /* SET_POSTS */], []);
};
var countAsidePosts = function countAsidePosts(_ref5, communityData) {
  var commit = _ref5.commit;
  return __WEBPACK_IMPORTED_MODULE_12__queries_post__["a" /* default */].countAsidePosts(communityData).then(function (response) {
    var data = response.data;
    commit(__WEBPACK_IMPORTED_MODULE_9__types__["f" /* SET_ASIDE_POSTS_COUNTER */], data.count_community_aside_posts);
  });
};
var fetchAsidePosts = function fetchAsidePosts(_ref6, communityData) {
  var commit = _ref6.commit;
  return __WEBPACK_IMPORTED_MODULE_12__queries_post__["a" /* default */].fetchAsidePosts(communityData).then(function (response) {
    var data = response.data;
    commit(__WEBPACK_IMPORTED_MODULE_9__types__["e" /* SET_ASIDE_POSTS */], data.community_aside_posts);
  });
};
var fetchAndCountAsidePosts = function fetchAndCountAsidePosts(_ref7) {
  var dispatch = _ref7.dispatch,
      state = _ref7.state;
  var communityId = state.activeCommunity.id;
  dispatch('fetchAsidePosts', {
    communityId: communityId
  });
  dispatch('countAsidePosts', {
    communityId: communityId
  });
};
var appendAsidePinnedPost = function appendAsidePinnedPost(_ref8, postItem) {
  var commit = _ref8.commit;
  return commit(__WEBPACK_IMPORTED_MODULE_9__types__["g" /* APPEND_ASIDE_POST */], postItem);
};
var updatePostOnAsideList = function updatePostOnAsideList(_ref9, postItem) {
  var commit = _ref9.commit;
  return commit(__WEBPACK_IMPORTED_MODULE_9__types__["v" /* UPDATE_POST_ON_ASIDE_LIST */], postItem);
};

var filterParams = function filterParams(state) {
  return {
    communityId: state.activeCommunity.id,
    tag: state.postFilter.tag,
    moderationState: state.postFilter.moderationState,
    search: state.postFilter.search,
    postsOrderBy: state.postsOrderBy
  };
};

var countPosts = function countPosts(_ref10) {
  var commit = _ref10.commit,
      state = _ref10.state;
  var params = filterParams(state);
  return __WEBPACK_IMPORTED_MODULE_12__queries_post__["a" /* default */].countPosts(params).then(function (_ref11) {
    var data = _ref11.data;
    commit(__WEBPACK_IMPORTED_MODULE_9__types__["k" /* SET_POSTS_COUNTER */], data.count_community_posts);
  });
};
var fetchPosts = function fetchPosts(_ref12) {
  var commit = _ref12.commit,
      state = _ref12.state;
  var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var params = filterParams(state);
  params = _objectSpread({}, params, {
    page: page
  });
  return __WEBPACK_IMPORTED_MODULE_12__queries_post__["a" /* default */].fetchPosts(params).then(function (response) {
    var data = response.data;
    commit(__WEBPACK_IMPORTED_MODULE_9__types__["h" /* SET_POSTS */], data.community_posts);
  });
};
var fetchAppendPosts = function fetchAppendPosts(_ref13) {
  var commit = _ref13.commit,
      state = _ref13.state;
  var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var params = filterParams(state);
  params = _objectSpread({}, params, {
    page: page
  });
  return __WEBPACK_IMPORTED_MODULE_12__queries_post__["a" /* default */].fetchPosts(params).then(function (_ref14) {
    var data = _ref14.data;
    commit(__WEBPACK_IMPORTED_MODULE_9__types__["i" /* APPEND_POSTS */], data.community_posts);
    return data.community_posts;
  });
};
var fetchPost = function fetchPost(_ref15, postId) {
  var commit = _ref15.commit;
  return __WEBPACK_IMPORTED_MODULE_12__queries_post__["a" /* default */].fetchPost(postId).then(function (response) {
    var data = response.data;
    commit(__WEBPACK_IMPORTED_MODULE_9__types__["l" /* SET_ACTIVE_POST */], data.community_post);
  });
};
var setActivePost = function setActivePost(_ref16, postData) {
  var commit = _ref16.commit;
  return commit(__WEBPACK_IMPORTED_MODULE_9__types__["l" /* SET_ACTIVE_POST */], postData);
};
var createPost = function createPost(_ref17, postData) {
  var commit = _ref17.commit,
      dispatch = _ref17.dispatch;
  __WEBPACK_IMPORTED_MODULE_12__queries_post__["a" /* default */].createPost(postData).then(function () {
    commit(__WEBPACK_IMPORTED_MODULE_9__types__["G" /* RESET_POST_FILTER */]);
    dispatch('fetchAndCountPosts');

    if (postData.tagsChanged) {
      dispatch('fetchPopularTags');
    }
  });
};
var fetchAndCountPosts = function fetchAndCountPosts(_ref18) {
  var dispatch = _ref18.dispatch;
  dispatch('fetchPosts');
  dispatch('countPosts');
};
var postsOrderBy = function postsOrderBy(_ref19, order) {
  var commit = _ref19.commit,
      state = _ref19.state,
      dispatch = _ref19.dispatch;
  commit(__WEBPACK_IMPORTED_MODULE_9__types__["H" /* SET_POSTS_ORDER_BY */], order);
  dispatch('fetchPosts');
};
var updatePost = function updatePost(_ref20, post) {
  var _ = _ref20._;
  return __WEBPACK_IMPORTED_MODULE_12__queries_post__["a" /* default */].updatePost(post);
};
var updatePostOnList = function updatePostOnList(_ref21, postId) {
  var commit = _ref21.commit;
  return __WEBPACK_IMPORTED_MODULE_12__queries_post__["a" /* default */].fetchPost(postId).then(function (response) {
    var data = response.data;
    commit(__WEBPACK_IMPORTED_MODULE_9__types__["w" /* UPDATE_POST_ON_LIST */], data.community_post);
  });
};
var updateModerationState = function updateModerationState(_ref22, data) {
  var _ = _ref22._;
  return __WEBPACK_IMPORTED_MODULE_12__queries_post__["a" /* default */].updateModerationState(data);
};
var fetchPostComments = function fetchPostComments(post) {
  post.commentId = null;
  return __WEBPACK_IMPORTED_MODULE_11__queries_comment__["a" /* default */].fetchPostComments(post);
};
var fetchAndAppendPostComments = function fetchAndAppendPostComments(_ref23, post) {
  var commit = _ref23.commit;
  return fetchPostComments(post).then(function (response) {
    var data = response.data;
    commit(__WEBPACK_IMPORTED_MODULE_9__types__["n" /* APPEND_POST_COMMENTS */], data.community_post_comments);
    return data.community_post_comments;
  });
};
var fetchAndSetPostComments = function fetchAndSetPostComments(_ref24, post) {
  var commit = _ref24.commit;
  return fetchPostComments(post).then(function (response) {
    commit(__WEBPACK_IMPORTED_MODULE_9__types__["o" /* SET_POST_COMMENTS */], response.data.community_post_comments);
  });
};
var countPostComments = function countPostComments(_ref25, postId) {
  var commit = _ref25.commit;
  return __WEBPACK_IMPORTED_MODULE_11__queries_comment__["a" /* default */].countPostComments(postId).then(function (response) {
    var data = response.data;
    commit(__WEBPACK_IMPORTED_MODULE_9__types__["p" /* SET_POST_COMMENTS_COUNTER */], data.count_community_post_comments);
  });
};
var setActiveComment = function setActiveComment(_ref26, commentData) {
  var commit = _ref26.commit;
  return commit(__WEBPACK_IMPORTED_MODULE_9__types__["q" /* SET_ACTIVE_COMMENT */], commentData);
};
var resetActiveComment = function resetActiveComment(_ref27) {
  var commit = _ref27.commit;
  return commit(__WEBPACK_IMPORTED_MODULE_9__types__["t" /* RESET_ACTIVE_COMMENT */]);
};
var createComment = function createComment(_ref28, commentData) {
  var rootState = _ref28.rootState,
      dispatch = _ref28.dispatch,
      state = _ref28.state;
  var postId = rootState.route.params.postId || state.activePost.id;
  commentData.postId = postId;
  return __WEBPACK_IMPORTED_MODULE_11__queries_comment__["a" /* default */].createComment(commentData).then(function (response) {
    dispatch('countPostComments', postId);
    dispatch('updatePostOnList', postId);
    return response;
  });
};
var updateComment = function updateComment(_ref29, commentData) {
  var _ = _ref29._;
  return __WEBPACK_IMPORTED_MODULE_11__queries_comment__["a" /* default */].updateComment(commentData);
};
var destroyComment = function destroyComment(_ref30) {
  var state = _ref30.state,
      rootState = _ref30.rootState,
      dispatch = _ref30.dispatch;
  var postId = rootState.route.params.postId;
  return __WEBPACK_IMPORTED_MODULE_11__queries_comment__["a" /* default */].destroyComment(state.activeComment.id).then(function () {
    if (state.activeComment.comment_id) {
      dispatch('fetchCommentById', state.activeComment.comment_id);
    }

    dispatch('fetchPost', postId);
  });
};
var fetchCommentReplies = function fetchCommentReplies(_ref31, _ref32) {
  var commit = _ref31.commit;
  var comment = _ref32.comment,
      postId = _ref32.postId,
      page = _ref32.page,
      reset = _ref32.reset;

  var commentData = _objectSpread({}, comment);

  commentData.postId = postId;
  commentData.page = page;
  commentData.commentId = comment.id;
  return __WEBPACK_IMPORTED_MODULE_11__queries_comment__["a" /* default */].fetchPostComments(commentData).then(function (response) {
    var data = response.data;
    commit(__WEBPACK_IMPORTED_MODULE_9__types__["r" /* SET_REPLIES_TO_COMMENT */], {
      replies: data.community_post_comments,
      comment: comment,
      reset: reset || false
    });
  });
};
var setActiveTerm = function setActiveTerm(_ref33, communityTerm) {
  var commit = _ref33.commit;
  return commit(__WEBPACK_IMPORTED_MODULE_9__types__["u" /* SET_ACTIVE_COMMUNITY_TERMS */], communityTerm);
};
var acceptUseTerms = function acceptUseTerms(_ref34) {
  var state = _ref34.state;
  var communityId = Number(state.activeCommunityTerms.id);
  return __WEBPACK_IMPORTED_MODULE_10__queries_community__["a" /* default */].acceptUseTerms(communityId);
};
var fetchById = function fetchById(_ref35, _ref36) {
  var dispatch = _ref35.dispatch;
  var communityId = _ref36.communityId,
      showLoader = _ref36.showLoader;
  return __WEBPACK_IMPORTED_MODULE_10__queries_community__["a" /* default */].fetchById(communityId, showLoader).then(function (response) {
    var data = response.data;
    var userCommunity = data.user_community;
    dispatch('setActive', userCommunity);
  });
};
var likePost = function likePost(_ref37, id) {
  var commit = _ref37.commit;
  return __WEBPACK_IMPORTED_MODULE_12__queries_post__["a" /* default */].likePost(id);
};
var likeComment = function likeComment(_ref38, comment) {
  var dispatch = _ref38.dispatch;
  return __WEBPACK_IMPORTED_MODULE_11__queries_comment__["a" /* default */].like(comment.id).then(function (response) {
    var data = response.data.likeCommunityPostComment;
    var action = !comment.comment_id ? 'updatePostCommentList' : 'updateReplyList';
    dispatch(action, data.community_post_comment);
  });
};
var updateActivePost = function updateActivePost(_ref39, post) {
  var commit = _ref39.commit;
  return commit(__WEBPACK_IMPORTED_MODULE_9__types__["l" /* SET_ACTIVE_POST */], post);
};
var updatePostList = function updatePostList(_ref40, post) {
  var commit = _ref40.commit;
  return commit(__WEBPACK_IMPORTED_MODULE_9__types__["j" /* UPDATE_POST_LIST */], post);
};
var updateCommentModerationState = function updateCommentModerationState(_ref41, data) {
  var _ = _ref41._;
  return __WEBPACK_IMPORTED_MODULE_11__queries_comment__["a" /* default */].updateModerationState(data);
};
var updatePostCommentList = function updatePostCommentList(_ref42, comment) {
  var commit = _ref42.commit;
  return commit(__WEBPACK_IMPORTED_MODULE_9__types__["x" /* UPDATE_POST_COMMENT_ON_LIST */], comment);
};
var updateReplyList = function updateReplyList(_ref43, reply) {
  var commit = _ref43.commit;
  return commit(__WEBPACK_IMPORTED_MODULE_9__types__["y" /* UPDATE_REPLY_ON_LIST */], reply);
};
var addReplyOnList = function addReplyOnList(_ref44, reply) {
  var commit = _ref44.commit;
  return commit(__WEBPACK_IMPORTED_MODULE_9__types__["z" /* ADD_REPLY_ON_LIST */], reply);
};
var changeUserTheme = function changeUserTheme(_ref45, theme) {
  var rootState = _ref45.rootState,
      commit = _ref45.commit;
  var communityId = rootState.route.params.communityId;
  return __WEBPACK_IMPORTED_MODULE_10__queries_community__["a" /* default */].changeUserTheme({
    communityId: communityId,
    theme: theme
  }).then(function (response) {
    var communityUser = response.data.changeCommunityUserTheme.community_user;
    commit(__WEBPACK_IMPORTED_MODULE_9__types__["c" /* SET_ACTIVE_COMMUNITY_USER */], communityUser);
  });
};
var fetchPopularCommunityBookmarkedTags = function fetchPopularCommunityBookmarkedTags(_ref46) {
  var commit = _ref46.commit,
      rootState = _ref46.rootState,
      state = _ref46.state;
  var communityId = rootState.route.params.communityId;
  return __WEBPACK_IMPORTED_MODULE_13__queries_tag__["a" /* default */].fetchPopularCommunityBookmarkedTags(communityId, state.postFilter).then(function (response) {
    var data = response.data;
    commit(__WEBPACK_IMPORTED_MODULE_9__types__["A" /* SET_POPULAR_TAGS */], data.popular_community_bookmarked_tags);
  });
};
var fetchPopularTags = function fetchPopularTags(_ref47) {
  var commit = _ref47.commit,
      rootState = _ref47.rootState,
      state = _ref47.state;
  var communityId = rootState.route.params.communityId;
  return __WEBPACK_IMPORTED_MODULE_13__queries_tag__["a" /* default */].fetchPopularTags(communityId, state.postFilter).then(function (response) {
    var data = response.data;
    commit(__WEBPACK_IMPORTED_MODULE_9__types__["A" /* SET_POPULAR_TAGS */], data.popular_community_tags);
  });
};
var setTagFilter = function setTagFilter(_ref48, tags) {
  var commit = _ref48.commit;
  return commit(__WEBPACK_IMPORTED_MODULE_9__types__["B" /* SET_TAG_FILTER */], tags);
};
var setSearchFilter = function setSearchFilter(_ref49, search) {
  var commit = _ref49.commit;
  return commit(__WEBPACK_IMPORTED_MODULE_9__types__["C" /* SET_SEARCH_FILTER */], search);
};
var setMemberSearch = function setMemberSearch(_ref50, search) {
  var commit = _ref50.commit;
  return commit(__WEBPACK_IMPORTED_MODULE_9__types__["D" /* SET_USER_SEARCH */], search);
};
var setModerationStateFilter = function setModerationStateFilter(_ref51, moderationState) {
  var commit = _ref51.commit;
  return commit(__WEBPACK_IMPORTED_MODULE_9__types__["E" /* SET_MODERATION_STATE_FILTER */], moderationState);
};
var toggleModerationStateFilter = function toggleModerationStateFilter(_ref52, moderationState) {
  var commit = _ref52.commit;
  return commit(__WEBPACK_IMPORTED_MODULE_9__types__["F" /* TOGGLE_MODERATION_STATE_FILTER */], moderationState);
};
var resetPostFilter = function resetPostFilter(_ref53) {
  var commit = _ref53.commit;
  return commit(__WEBPACK_IMPORTED_MODULE_9__types__["G" /* RESET_POST_FILTER */]);
};
var destroyPost = function destroyPost(_ref54, id) {
  var _ = _ref54._;
  return __WEBPACK_IMPORTED_MODULE_12__queries_post__["a" /* default */].destroy(id);
};
var fetchCommentById = function fetchCommentById(_ref55, commentId) {
  var dispatch = _ref55.dispatch;
  return __WEBPACK_IMPORTED_MODULE_11__queries_comment__["a" /* default */].fetchById(commentId).then(function (response) {
    dispatch('updatePostCommentList', response.data.community_post_comment);
  });
};
var uploadPostMedia = function uploadPostMedia(_ref56, uploadData) {
  var _ = _ref56._;
  return __WEBPACK_IMPORTED_MODULE_16__helpers_request_communityMedia__["a" /* default */].upload(uploadData);
};
var uploadPostImage = function uploadPostImage(_ref57, uploadData) {
  var _ = _ref57._;
  return __WEBPACK_IMPORTED_MODULE_16__helpers_request_communityMedia__["a" /* default */].uploadPostImage(uploadData);
};
var setPostUpload = function setPostUpload(_ref58, progress) {
  var commit = _ref58.commit;
  return commit(__WEBPACK_IMPORTED_MODULE_9__types__["I" /* SET_POST_UPLOAD */], progress);
};
var resetPostUpload = function resetPostUpload(_ref59) {
  var commit = _ref59.commit;
  return commit(__WEBPACK_IMPORTED_MODULE_9__types__["J" /* RESET_POST_UPLOAD */]);
};
var fetchComments = function fetchComments(_ref60, params) {
  var commit = _ref60.commit,
      rootState = _ref60.rootState,
      dispatch = _ref60.dispatch;
  var communityId = rootState.route.params.communityId;
  dispatch('countComments', params.moderationState);
  return __WEBPACK_IMPORTED_MODULE_11__queries_comment__["a" /* default */].fetchCommunityComments(communityId, params).then(function (response) {
    var data = response.data;
    commit(__WEBPACK_IMPORTED_MODULE_9__types__["K" /* SET_COMMENTS */], data.community_comments);
  });
};
var countComments = function countComments(_ref61, moderationState) {
  var commit = _ref61.commit,
      rootState = _ref61.rootState;
  var communityId = rootState.route.params.communityId;
  return __WEBPACK_IMPORTED_MODULE_11__queries_comment__["a" /* default */].countCommunityComments(communityId, moderationState).then(function (response) {
    var data = response.data;
    commit(__WEBPACK_IMPORTED_MODULE_9__types__["L" /* SET_TOTAL_COMMENTS */], data.count_community_comments);
  });
};
var updateCommentList = function updateCommentList(_ref62, comment) {
  var commit = _ref62.commit;
  return commit(__WEBPACK_IMPORTED_MODULE_9__types__["M" /* UPDATE_COMMENT_ON_LIST */], comment);
};
var changeMobileSidebar = function changeMobileSidebar(_ref63, data) {
  var commit = _ref63.commit;
  return commit(__WEBPACK_IMPORTED_MODULE_9__types__["N" /* CHANGE_MOBILE_SIDEBAR */], data);
};
var followPost = function followPost(_ref64, postId) {
  var _ = _ref64._;
  return __WEBPACK_IMPORTED_MODULE_12__queries_post__["a" /* default */].follow(postId);
};
var unfollowPost = function unfollowPost(_ref65, postId) {
  var _ = _ref65._;
  return __WEBPACK_IMPORTED_MODULE_12__queries_post__["a" /* default */].unfollow(postId);
};
var fetchUsers = function fetchUsers(_ref66) {
  var commit = _ref66.commit,
      rootState = _ref66.rootState,
      state = _ref66.state;
  var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var communityId = rootState.route.params.communityId;
  var usersOrderBy = state.usersOrderBy,
      userFilter = state.userFilter;
  return __WEBPACK_IMPORTED_MODULE_14__queries_user__["a" /* default */].fetch(communityId, page, usersOrderBy, userFilter).then(function (response) {
    var data = response.data;
    commit(__WEBPACK_IMPORTED_MODULE_9__types__["O" /* SET_USERS */], data.community_users);
  });
};
var countUsers = function countUsers(_ref67) {
  var commit = _ref67.commit,
      state = _ref67.state,
      rootState = _ref67.rootState;
  var communityId = rootState.route.params.communityId;
  var userFilter = state.userFilter;
  __WEBPACK_IMPORTED_MODULE_14__queries_user__["a" /* default */].getCount(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_corejs2_core_js_parse_int___default()(communityId, 10), userFilter).then(function (response) {
    var data = response.data;
    commit(__WEBPACK_IMPORTED_MODULE_9__types__["P" /* SET_USERS_COUNTER */], data.count_community_users);
  });
};
var searchUsers = function searchUsers(_ref68, search) {
  var _ = _ref68._;
  return __WEBPACK_IMPORTED_MODULE_14__queries_user__["a" /* default */].searchUsers(search);
};
var updateUserState = function updateUserState(_ref69, userData) {
  var _ = _ref69._;
  return __WEBPACK_IMPORTED_MODULE_14__queries_user__["a" /* default */].updateState(userData);
};
var updateUserStateOnList = function updateUserStateOnList(_ref70, userState) {
  var commit = _ref70.commit;
  return commit(__WEBPACK_IMPORTED_MODULE_9__types__["R" /* UPDATE_USER_STATE_ON_LIST */], userState);
};
var usersOrderBy = function usersOrderBy(_ref71, order) {
  var commit = _ref71.commit;
  return commit(__WEBPACK_IMPORTED_MODULE_9__types__["Q" /* SET_USERS_ORDER_BY */], order);
};
var setActiveUser = function setActiveUser(_ref72, communityUser) {
  var commit = _ref72.commit;
  return commit(__WEBPACK_IMPORTED_MODULE_9__types__["c" /* SET_ACTIVE_COMMUNITY_USER */], communityUser);
};
var resetActiveUser = function resetActiveUser(_ref73) {
  var commit = _ref73.commit;
  return commit(__WEBPACK_IMPORTED_MODULE_9__types__["c" /* SET_ACTIVE_COMMUNITY_USER */], {});
};
var toggleAsReadNotification = function toggleAsReadNotification(_ref74, notification) {
  var commit = _ref74.commit,
      dispatch = _ref74.dispatch,
      rootState = _ref74.rootState;
  return __WEBPACK_IMPORTED_MODULE_14__queries_user__["a" /* default */].updateReadNotification(notification.id, !notification.read).then(function (response) {
    var data = response.data;
    commit(__WEBPACK_IMPORTED_MODULE_9__types__["S" /* UPDATE_READ_NOTIFICATION */], data.updateReadNotification.community_notifications);
    var communityId = rootState.route.params.communityId;
    dispatch('fetchById', {
      communityId: communityId,
      showLoader: false
    });
  });
};
var markAllAsReadNotification = function markAllAsReadNotification(_ref75) {
  var commit = _ref75.commit,
      dispatch = _ref75.dispatch,
      rootState = _ref75.rootState;
  var communityId = rootState.route.params.communityId;
  __WEBPACK_IMPORTED_MODULE_14__queries_user__["a" /* default */].markAllAsReadNotification(communityId).then(function () {
    commit(__WEBPACK_IMPORTED_MODULE_9__types__["T" /* MARK_ALL_AS_READ_NOTIFICATION */]);
    dispatch('fetchById', {
      communityId: communityId,
      showLoader: false
    });
  });
};
var fetchUserNotifications = function fetchUserNotifications(_ref76) {
  var commit = _ref76.commit,
      rootState = _ref76.rootState;
  var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var communityId = rootState.route.params.communityId;
  return __WEBPACK_IMPORTED_MODULE_14__queries_user__["a" /* default */].fetchNotifications(communityId, page).then(function (response) {
    var data = response.data;
    commit(__WEBPACK_IMPORTED_MODULE_9__types__["U" /* SET_USER_NOTIFICATIONS */], {
      notifications: data.community_user_notifications,
      page: page
    });
  });
};
var fetchTotalUserNotifications = function fetchTotalUserNotifications(_ref77) {
  var commit = _ref77.commit,
      rootState = _ref77.rootState;
  var communityId = rootState.route.params.communityId;
  return __WEBPACK_IMPORTED_MODULE_14__queries_user__["a" /* default */].fetchTotalNotifications(communityId).then(function (response) {
    var data = response.data;
    commit(__WEBPACK_IMPORTED_MODULE_9__types__["V" /* SET_TOTAL_USER_NOTIFICATIONS */], data.count_community_user_notifications);
  });
};
var updateEmailSettings = function updateEmailSettings(_ref78, kinds) {
  var commit = _ref78.commit,
      state = _ref78.state;
  var communityUserId = state.activeCommunityUser.id;
  return __WEBPACK_IMPORTED_MODULE_14__queries_user__["a" /* default */].updateEmailSettings({
    kinds: kinds,
    communityUserId: communityUserId
  }).then(function (response) {
    var data = response.data;
    var communityUser = data.updateCommunityUserEmailSettings.community_user;
    commit(__WEBPACK_IMPORTED_MODULE_9__types__["W" /* UPDATE_USER_EMAIL_SETTINGS_ON_LIST */], communityUser);
  });
};
var createPostBookmark = function createPostBookmark(_ref79, postId) {
  var _ = _ref79._;
  return __WEBPACK_IMPORTED_MODULE_12__queries_post__["a" /* default */].createBookmark(postId);
};
var removePostBookmark = function removePostBookmark(_ref80, postId) {
  var _ = _ref80._;
  return __WEBPACK_IMPORTED_MODULE_12__queries_post__["a" /* default */].removeBookmark(postId);
};
var countBookmarkedPosts = function countBookmarkedPosts(_ref81) {
  var commit = _ref81.commit,
      state = _ref81.state;
  var params = filterParams(state);
  return __WEBPACK_IMPORTED_MODULE_12__queries_post__["a" /* default */].countBookmarkedPosts(params).then(function (_ref82) {
    var data = _ref82.data;
    commit(__WEBPACK_IMPORTED_MODULE_9__types__["k" /* SET_POSTS_COUNTER */], data.count_community_bookmark_posts);
  });
};
var fetchBookmarkedPosts = function fetchBookmarkedPosts(_ref83) {
  var commit = _ref83.commit,
      state = _ref83.state;
  var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var params = filterParams(state);
  params = _objectSpread({}, params, {
    page: page
  });
  return __WEBPACK_IMPORTED_MODULE_12__queries_post__["a" /* default */].fetchBookmarkedPosts(_objectSpread({}, params, {
    page: page
  })).then(function (response) {
    var data = response.data;
    commit(__WEBPACK_IMPORTED_MODULE_9__types__["h" /* SET_POSTS */], data.community_bookmark_posts);
  });
};
var fetchAppendBookmarkedPosts = function fetchAppendBookmarkedPosts(_ref84) {
  var commit = _ref84.commit,
      state = _ref84.state;
  var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var params = filterParams(state);
  params = _objectSpread({}, params, {
    page: page
  });
  return __WEBPACK_IMPORTED_MODULE_12__queries_post__["a" /* default */].fetchBookmarkedPosts(_objectSpread({}, params, {
    page: page
  })).then(function (response) {
    var data = response.data;
    commit(__WEBPACK_IMPORTED_MODULE_9__types__["i" /* APPEND_POSTS */], data.community_bookmark_posts);
    return data.community_bookmark_posts;
  });
};
var getCommunityUserProfile = function getCommunityUserProfile(_ref85, communityUserId) {
  var commit = _ref85.commit,
      state = _ref85.state;
  var isSameUser = communityUserId === state.activeCommunityUser.id;
  return __WEBPACK_IMPORTED_MODULE_14__queries_user__["a" /* default */].getProfileData(communityUserId, isSameUser).then(function (response) {
    var data = response.data;
    var communityUser = data.community_user_profile_data;
    commit(__WEBPACK_IMPORTED_MODULE_9__types__["X" /* SET_COMMUNITY_USER_PROFILE */], communityUser);
  });
};
var resetCommunityUserProfile = function resetCommunityUserProfile(_ref86) {
  var commit = _ref86.commit;
  return commit(__WEBPACK_IMPORTED_MODULE_9__types__["Y" /* RESET_COMMUNITY_USER_PROFILE */]);
};
var addPostCommentToList = function addPostCommentToList(_ref87, commentId) {
  var commit = _ref87.commit;
  return __WEBPACK_IMPORTED_MODULE_11__queries_comment__["a" /* default */].fetchById(commentId).then(function (response) {
    commit(__WEBPACK_IMPORTED_MODULE_9__types__["m" /* ADD_COMMENT_TO_LIST */], response.data.community_post_comment);
  });
};
var loadUniqueComment = function loadUniqueComment(_ref88, commentId) {
  var commit = _ref88.commit,
      dispatch = _ref88.dispatch,
      rootState = _ref88.rootState;
  return __WEBPACK_IMPORTED_MODULE_11__queries_comment__["a" /* default */].fetchById(commentId).then(function (response) {
    var postComment = response.data.community_post_comment;
    var postId = rootState.route.params.postId;

    if (postComment.comment_id) {
      return dispatch('loadUniquePrimaryComment', postComment);
    }

    commit(__WEBPACK_IMPORTED_MODULE_9__types__["m" /* ADD_COMMENT_TO_LIST */], postComment);
    return dispatch('fetchCommentReplies', {
      comment: postComment,
      postId: postId,
      page: 1,
      reset: true
    });
  });
};
var loadUniquePrimaryComment = function loadUniquePrimaryComment(_ref89, replyComment) {
  var commit = _ref89.commit;
  return __WEBPACK_IMPORTED_MODULE_11__queries_comment__["a" /* default */].fetchById(replyComment.comment_id).then(function (_ref90) {
    var data = _ref90.data;
    var parentComment = data.community_post_comment;
    commit(__WEBPACK_IMPORTED_MODULE_9__types__["m" /* ADD_COMMENT_TO_LIST */], parentComment);
    commit(__WEBPACK_IMPORTED_MODULE_9__types__["r" /* SET_REPLIES_TO_COMMENT */], {
      comment: parentComment,
      replies: [replyComment],
      reset: true
    });
  });
};
var resetPostComments = function resetPostComments(_ref91) {
  var commit = _ref91.commit;
  return commit(__WEBPACK_IMPORTED_MODULE_9__types__["o" /* SET_POST_COMMENTS */], []);
};
var resetCommentReplies = function resetCommentReplies(_ref92) {
  var commit = _ref92.commit;
  return commit(__WEBPACK_IMPORTED_MODULE_9__types__["s" /* RESET_COMMENT_REPLIES */]);
};
var pin = function pin(_ref93, itemId) {
  var _ = _ref93._;
  return __WEBPACK_IMPORTED_MODULE_12__queries_post__["a" /* default */].pin(itemId);
};
var pinAside = function pinAside(_ref94, itemId) {
  var _ = _ref94._;
  return __WEBPACK_IMPORTED_MODULE_12__queries_post__["a" /* default */].pinAside(itemId);
};
var getBadgesList = function getBadgesList(_ref95) {
  var rootState = _ref95.rootState,
      commit = _ref95.commit;
  var communityId = rootState.route.params.communityId;
  return __WEBPACK_IMPORTED_MODULE_15__queries_badge__["a" /* default */].getList(communityId).then(function (response) {
    commit(__WEBPACK_IMPORTED_MODULE_9__types__["Z" /* SET_BADGES */], response.data.community_badges);
  });
};
var assignBadges = function assignBadges(_ref96, _ref97) {
  var commit = _ref96.commit,
      state = _ref96.state;
  var userId = _ref97.userId,
      badges = _ref97.badges,
      isSameUser = _ref97.isSameUser;
  return __WEBPACK_IMPORTED_MODULE_14__queries_user__["a" /* default */].assignBadges({
    userId: userId,
    badges: badges
  }, isSameUser).then(function (response) {
    var data = response.data.assignBadges.community_user;

    if (state.communityUserProfile.id) {
      commit(__WEBPACK_IMPORTED_MODULE_9__types__["X" /* SET_COMMUNITY_USER_PROFILE */], data);
    }

    commit(__WEBPACK_IMPORTED_MODULE_9__types__["_0" /* UPDATE_USER_BADGES_ON_LIST */], data);
  });
};
var setReplyingComment = function setReplyingComment(_ref98, comment) {
  var commit = _ref98.commit;
  return commit(__WEBPACK_IMPORTED_MODULE_9__types__["_1" /* SET_REPLYING_COMMENT */], comment);
};
var toggleBestComment = function toggleBestComment(_ref99, comment) {
  var commit = _ref99.commit;
  return __WEBPACK_IMPORTED_MODULE_11__queries_comment__["a" /* default */].toggleBestComment(comment).then(function (response) {
    var data = response.data;
    var toggleBestComment = data.toggleBestComment;
    commit(__WEBPACK_IMPORTED_MODULE_9__types__["x" /* UPDATE_POST_COMMENT_ON_LIST */], toggleBestComment.community_post_comment);
  });
};

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "list", function() { return list; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "active", function() { return active; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "activeUser", function() { return activeUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "activeCommunityUser", function() { return activeCommunityUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "asidePostsList", function() { return asidePostsList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "asidePostsCounter", function() { return asidePostsCounter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "postsList", function() { return postsList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "postsCounter", function() { return postsCounter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "activePost", function() { return activePost; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "postsOrderBy", function() { return postsOrderBy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "postComments", function() { return postComments; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "postCommentsCounter", function() { return postCommentsCounter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "activeComment", function() { return activeComment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "activeTerms", function() { return activeTerms; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "commentReplies", function() { return commentReplies; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "newCommentReplies", function() { return newCommentReplies; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "tags", function() { return tags; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "popularTags", function() { return popularTags; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "postFilter", function() { return postFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "postActiveUpload", function() { return postActiveUpload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "comments", function() { return comments; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "totalComments", function() { return totalComments; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mobileSidebar", function() { return mobileSidebar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "usersList", function() { return usersList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "totalUsers", function() { return totalUsers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "userFilter", function() { return userFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "usersOrderBy", function() { return usersOrderBy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "usersCount", function() { return usersCount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "activeUserNotifications", function() { return activeUserNotifications; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "totalNotifications", function() { return totalNotifications; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "communityUserProfile", function() { return communityUserProfile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "badges", function() { return badges; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "replyingComment", function() { return replyingComment; });
var list = function list(state) {
  return state.communitiesList;
};
var active = function active(state) {
  return state.activeCommunity;
};
var activeUser = function activeUser(state) {
  return state.activeUser;
};
var activeCommunityUser = function activeCommunityUser(state) {
  return state.activeCommunityUser;
};
var asidePostsList = function asidePostsList(state) {
  return state.asidePosts;
};
var asidePostsCounter = function asidePostsCounter(state) {
  return state.totalAsidePosts;
};
var postsList = function postsList(state) {
  return state.posts;
};
var postsCounter = function postsCounter(state) {
  return state.totalPosts;
};
var activePost = function activePost(state) {
  return state.activePost;
};
var postsOrderBy = function postsOrderBy(state) {
  return state.postsOrderBy;
};
var postComments = function postComments(state) {
  return state.postComments;
};
var postCommentsCounter = function postCommentsCounter(state) {
  return state.postTotalComments;
};
var activeComment = function activeComment(state) {
  return state.activeComment;
};
var activeTerms = function activeTerms(state) {
  return state.activeCommunityTerms;
};
var commentReplies = function commentReplies(state) {
  return function (commentId) {
    return state.commentReplies[commentId] || [];
  };
};
var newCommentReplies = function newCommentReplies(state) {
  return function (commentId) {
    return state.newCommentReplies[commentId] || [];
  };
};
var tags = function tags(state) {
  return state.tags;
};
var popularTags = function popularTags(state) {
  return state.popularTags;
};
var postFilter = function postFilter(state) {
  return state.postFilter;
};
var postActiveUpload = function postActiveUpload(state) {
  return state.postActiveUpload;
};
var comments = function comments(state) {
  return state.comments;
};
var totalComments = function totalComments(state) {
  return state.totalComments;
};
var mobileSidebar = function mobileSidebar(state) {
  return state.mobileSidebar;
};
var usersList = function usersList(state) {
  return state.users;
};
var totalUsers = function totalUsers(state) {
  return state.totalUsers;
};
var userFilter = function userFilter(state) {
  return state.userFilter;
};
var usersOrderBy = function usersOrderBy(state) {
  return state.usersOrderBy;
};
var usersCount = function usersCount(state) {
  return state.users.length;
};
var activeUserNotifications = function activeUserNotifications(state) {
  return state.activeUserNotifications;
};
var totalNotifications = function totalNotifications(state) {
  return state.totalNotifications;
};
var communityUserProfile = function communityUserProfile(state) {
  return state.communityUserProfile;
};
var badges = function badges(state) {
  return state.badges;
};
var replyingComment = function replyingComment(state) {
  return state.replyingComment;
};

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(269);



/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__,
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__,
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* mutations */],
  state: __WEBPACK_IMPORTED_MODULE_2__mutations__["b" /* state */]
});

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_define_property__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_core_js_object_define_properties__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_core_js_object_define_properties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_core_js_object_define_properties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_core_js_object_get_own_property_descriptors__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_core_js_object_get_own_property_descriptors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_core_js_object_get_own_property_descriptors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_core_js_object_get_own_property_descriptor__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs2_core_js_object_get_own_property_symbols__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs2_core_js_object_get_own_property_symbols___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs2_core_js_object_get_own_property_symbols__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_corejs2_core_js_object_keys__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_corejs2_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_corejs2_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_corejs2_core_js_array_is_array__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_corejs2_core_js_array_is_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_corejs2_core_js_array_is_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_corejs2_core_js_object_assign__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_corejs2_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_corejs2_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_corejs2_helpers_toConsumableArray__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_corejs2_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_corejs2_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__babel_runtime_corejs2_helpers_objectWithoutProperties__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__babel_runtime_corejs2_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_corejs2_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__babel_runtime_corejs2_helpers_defineProperty__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__babel_runtime_corejs2_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_corejs2_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__types__ = __webpack_require__(96);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return state; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mutations; });












var _mutations;

function ownKeys(object, enumerableOnly) { var keys = __WEBPACK_IMPORTED_MODULE_5__babel_runtime_corejs2_core_js_object_keys___default()(object); if (__WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs2_core_js_object_get_own_property_symbols___default.a) { var symbols = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs2_core_js_object_get_own_property_symbols___default()(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_core_js_object_get_own_property_descriptor___default()(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_10__babel_runtime_corejs2_helpers_defineProperty___default()(target, key, source[key]); }); } else if (__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_core_js_object_get_own_property_descriptors___default.a) { __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_core_js_object_define_properties___default()(target, __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_core_js_object_get_own_property_descriptors___default()(source)); } else { ownKeys(Object(source)).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_define_property___default()(target, key, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_core_js_object_get_own_property_descriptor___default()(source, key)); }); } } return target; }


var defaultComment = {
  content: ''
};
var defaultPostUpload = {
  isLoading: false,
  progress: 0
};
var defaultPostFilter = {
  search: '',
  moderationState: [],
  tag: null
};

var updateItemOnList = function updateItemOnList(list, newItem) {
  return list.map(function (item) {
    if (item.id === newItem.id) {
      return _objectSpread({}, item, {}, newItem);
    }

    return item;
  });
};

var state = {
  communitiesList: [],
  activeCommunity: {},
  activeCommunityUser: {},
  activeUser: {},
  asidePosts: [],
  posts: [],
  tags: [],
  totalPosts: 0,
  totalAsidePosts: 0,
  activePost: {},
  postComments: [],
  postTotalComments: 0,
  activeComment: _objectSpread({}, defaultComment),
  commentReplies: {},
  newCommentReplies: {},
  activeCommunityTerms: {},
  popularTags: [],
  postFilter: _objectSpread({}, defaultPostFilter),
  postsOrderBy: 'created_at',
  postActiveUpload: _objectSpread({}, defaultPostUpload),
  comments: [],
  totalComments: 0,
  mobileSidebar: {
    rules: false,
    tags: false,
    search: false
  },
  users: [],
  totalUsers: 0,
  userFilter: '',
  usersOrderBy: 'qty_valid_posts',
  activeUserNotifications: [],
  totalNotifications: 0,
  communityUserProfile: {},
  badges: [],
  replyingComment: {}
};
var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_10__babel_runtime_corejs2_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_11__types__["a" /* SET_COMMUNITIES_LIST */], function (state, communitiesList) {
  state.communitiesList = communitiesList;
}), __WEBPACK_IMPORTED_MODULE_10__babel_runtime_corejs2_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_11__types__["b" /* SET_ACTIVE_COMMUNITY */], function (state, community) {
  state.activeCommunity = community;
}), __WEBPACK_IMPORTED_MODULE_10__babel_runtime_corejs2_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_11__types__["c" /* SET_ACTIVE_COMMUNITY_USER */], function (state, communityUser) {
  var user = communityUser.user,
      communityUserData = __WEBPACK_IMPORTED_MODULE_9__babel_runtime_corejs2_helpers_objectWithoutProperties___default()(communityUser, ["user"]);

  state.activeUser = _objectSpread({}, communityUserData, {}, user);
  state.activeCommunityUser = communityUser;
}), __WEBPACK_IMPORTED_MODULE_10__babel_runtime_corejs2_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_11__types__["d" /* SET_TAGS */], function (state, tags) {
  state.tags = tags;
}), __WEBPACK_IMPORTED_MODULE_10__babel_runtime_corejs2_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_11__types__["e" /* SET_ASIDE_POSTS */], function (state, asidePosts) {
  state.asidePosts = asidePosts;
}), __WEBPACK_IMPORTED_MODULE_10__babel_runtime_corejs2_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_11__types__["f" /* SET_ASIDE_POSTS_COUNTER */], function (state, totalAsidePosts) {
  state.totalAsidePosts = totalAsidePosts;
}), __WEBPACK_IMPORTED_MODULE_10__babel_runtime_corejs2_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_11__types__["g" /* APPEND_ASIDE_POST */], function (state, postItem) {
  state.asidePosts = [postItem].concat(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_corejs2_helpers_toConsumableArray___default()(state.asidePosts));
}), __WEBPACK_IMPORTED_MODULE_10__babel_runtime_corejs2_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_11__types__["h" /* SET_POSTS */], function (state, posts) {
  state.posts = posts;
}), __WEBPACK_IMPORTED_MODULE_10__babel_runtime_corejs2_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_11__types__["i" /* APPEND_POSTS */], function (state, posts) {
  state.posts = __WEBPACK_IMPORTED_MODULE_8__babel_runtime_corejs2_helpers_toConsumableArray___default()(state.posts).concat(posts);
}), __WEBPACK_IMPORTED_MODULE_10__babel_runtime_corejs2_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_11__types__["j" /* UPDATE_POST_LIST */], function (state, post) {
  var posts = state.posts.map(function (postItem) {
    if (postItem.id === post.id) {
      return __WEBPACK_IMPORTED_MODULE_7__babel_runtime_corejs2_core_js_object_assign___default()({}, postItem, post);
    }

    return postItem;
  });
  state.posts = __WEBPACK_IMPORTED_MODULE_8__babel_runtime_corejs2_helpers_toConsumableArray___default()(posts);
}), __WEBPACK_IMPORTED_MODULE_10__babel_runtime_corejs2_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_11__types__["k" /* SET_POSTS_COUNTER */], function (state, totalPosts) {
  state.totalPosts = totalPosts;
}), __WEBPACK_IMPORTED_MODULE_10__babel_runtime_corejs2_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_11__types__["l" /* SET_ACTIVE_POST */], function (state, post) {
  state.activePost = post;
}), __WEBPACK_IMPORTED_MODULE_10__babel_runtime_corejs2_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_11__types__["m" /* ADD_COMMENT_TO_LIST */], function (state, comment) {
  state.postComments.unshift(comment);
}), __WEBPACK_IMPORTED_MODULE_10__babel_runtime_corejs2_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_11__types__["n" /* APPEND_POST_COMMENTS */], function (state, comments) {
  state.postComments = __WEBPACK_IMPORTED_MODULE_8__babel_runtime_corejs2_helpers_toConsumableArray___default()(state.postComments).concat(comments);
}), __WEBPACK_IMPORTED_MODULE_10__babel_runtime_corejs2_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_11__types__["o" /* SET_POST_COMMENTS */], function (state, comments) {
  state.postComments = comments;
}), __WEBPACK_IMPORTED_MODULE_10__babel_runtime_corejs2_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_11__types__["p" /* SET_POST_COMMENTS_COUNTER */], function (state, commentsCounter) {
  state.postTotalComments = commentsCounter;
}), __WEBPACK_IMPORTED_MODULE_10__babel_runtime_corejs2_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_11__types__["q" /* SET_ACTIVE_COMMENT */], function (state, comment) {
  state.activeComment = _objectSpread({}, comment);
}), __WEBPACK_IMPORTED_MODULE_10__babel_runtime_corejs2_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_11__types__["r" /* SET_REPLIES_TO_COMMENT */], function (state, _ref) {
  var comment = _ref.comment,
      replies = _ref.replies,
      reset = _ref.reset;
  var repliesOfComments = state.commentReplies[comment.id] || [];
  var commentReplies = state.commentReplies;
  commentReplies[comment.id] = reset ? __WEBPACK_IMPORTED_MODULE_8__babel_runtime_corejs2_helpers_toConsumableArray___default()(replies) : [].concat(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_corejs2_helpers_toConsumableArray___default()(repliesOfComments), __WEBPACK_IMPORTED_MODULE_8__babel_runtime_corejs2_helpers_toConsumableArray___default()(replies));
  state.commentReplies = _objectSpread({}, commentReplies);
}), __WEBPACK_IMPORTED_MODULE_10__babel_runtime_corejs2_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_11__types__["s" /* RESET_COMMENT_REPLIES */], function (state) {
  state.commentReplies = {};
}), __WEBPACK_IMPORTED_MODULE_10__babel_runtime_corejs2_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_11__types__["t" /* RESET_ACTIVE_COMMENT */], function (state) {
  state.activeComment = _objectSpread({}, defaultComment);
}), __WEBPACK_IMPORTED_MODULE_10__babel_runtime_corejs2_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_11__types__["u" /* SET_ACTIVE_COMMUNITY_TERMS */], function (state, communityTerms) {
  state.activeCommunityTerms = communityTerms;
}), __WEBPACK_IMPORTED_MODULE_10__babel_runtime_corejs2_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_11__types__["v" /* UPDATE_POST_ON_ASIDE_LIST */], function (state, postItem) {
  state.asidePosts = updateItemOnList(state.asidePosts, postItem);
}), __WEBPACK_IMPORTED_MODULE_10__babel_runtime_corejs2_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_11__types__["w" /* UPDATE_POST_ON_LIST */], function (state, post) {
  state.posts = updateItemOnList(state.posts, post);
}), __WEBPACK_IMPORTED_MODULE_10__babel_runtime_corejs2_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_11__types__["x" /* UPDATE_POST_COMMENT_ON_LIST */], function (state, comment) {
  state.postComments = updateItemOnList(state.postComments, comment);
}), __WEBPACK_IMPORTED_MODULE_10__babel_runtime_corejs2_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_11__types__["y" /* UPDATE_REPLY_ON_LIST */], function (state, comment) {
  var id = comment.comment_id;
  var onNewList = state.newCommentReplies[id] ? state.newCommentReplies[id].some(function (reply) {
    return reply.id === comment.id;
  }) : false;
  var replyList = onNewList ? 'newCommentReplies' : 'commentReplies';
  var commentReplies = state[replyList];
  commentReplies[id] = updateItemOnList(state[replyList][id], comment);
  state[replyList] = _objectSpread({}, commentReplies);
}), __WEBPACK_IMPORTED_MODULE_10__babel_runtime_corejs2_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_11__types__["z" /* ADD_REPLY_ON_LIST */], function (state, reply) {
  var newCommentReplies = state.newCommentReplies;
  var id = reply.comment_id;
  var newRepliesOfComment = state.newCommentReplies[id] || [];
  newCommentReplies[id] = [].concat(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_corejs2_helpers_toConsumableArray___default()(newRepliesOfComment), [reply]);
  state.newCommentReplies = _objectSpread({}, newCommentReplies);
}), __WEBPACK_IMPORTED_MODULE_10__babel_runtime_corejs2_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_11__types__["A" /* SET_POPULAR_TAGS */], function (state, popularTags) {
  state.popularTags = popularTags;
}), __WEBPACK_IMPORTED_MODULE_10__babel_runtime_corejs2_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_11__types__["B" /* SET_TAG_FILTER */], function (state, tagFilter) {
  state.postFilter = _objectSpread({}, state.postFilter, {
    tag: tagFilter
  });
}), __WEBPACK_IMPORTED_MODULE_10__babel_runtime_corejs2_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_11__types__["C" /* SET_SEARCH_FILTER */], function (state, searchFilter) {
  state.postFilter = _objectSpread({}, state.postFilter, {
    search: searchFilter
  });
}), __WEBPACK_IMPORTED_MODULE_10__babel_runtime_corejs2_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_11__types__["D" /* SET_USER_SEARCH */], function (state, search) {
  state.userFilter = search;
}), __WEBPACK_IMPORTED_MODULE_10__babel_runtime_corejs2_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_11__types__["E" /* SET_MODERATION_STATE_FILTER */], function (state, filters) {
  filters = __WEBPACK_IMPORTED_MODULE_6__babel_runtime_corejs2_core_js_array_is_array___default()(filters) ? filters : [filters];
  state.postFilter = _objectSpread({}, state.postFilter, {
    moderationState: filters
  });
}), __WEBPACK_IMPORTED_MODULE_10__babel_runtime_corejs2_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_11__types__["F" /* TOGGLE_MODERATION_STATE_FILTER */], function (state, moderationStateFilter) {
  var moderationStates = state.postFilter.moderationState;
  var stateIndex = moderationStates.indexOf(moderationStateFilter);

  if (stateIndex !== -1) {
    moderationStates.splice(stateIndex, 1);
  } else {
    moderationStates.push(moderationStateFilter);
  }

  state.postFilter = _objectSpread({}, state.postFilter, {
    moderationState: moderationStates
  });
}), __WEBPACK_IMPORTED_MODULE_10__babel_runtime_corejs2_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_11__types__["G" /* RESET_POST_FILTER */], function (state) {
  state.postFilter = _objectSpread({}, defaultPostFilter);
}), __WEBPACK_IMPORTED_MODULE_10__babel_runtime_corejs2_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_11__types__["H" /* SET_POSTS_ORDER_BY */], function (state, order) {
  state.postsOrderBy = order;
}), __WEBPACK_IMPORTED_MODULE_10__babel_runtime_corejs2_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_11__types__["I" /* SET_POST_UPLOAD */], function (state, progress) {
  state.postActiveUpload.isLoading = true;
  state.postActiveUpload.progress = progress;
}), __WEBPACK_IMPORTED_MODULE_10__babel_runtime_corejs2_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_11__types__["J" /* RESET_POST_UPLOAD */], function (state) {
  state.postActiveUpload = _objectSpread({}, defaultPostUpload);
}), __WEBPACK_IMPORTED_MODULE_10__babel_runtime_corejs2_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_11__types__["K" /* SET_COMMENTS */], function (state, comments) {
  state.comments = comments;
}), __WEBPACK_IMPORTED_MODULE_10__babel_runtime_corejs2_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_11__types__["L" /* SET_TOTAL_COMMENTS */], function (state, totalComments) {
  state.totalComments = totalComments;
}), __WEBPACK_IMPORTED_MODULE_10__babel_runtime_corejs2_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_11__types__["M" /* UPDATE_COMMENT_ON_LIST */], function (state, comment) {
  var comments = state.comments;
  comments.map(function (item) {
    if (item.id === comment.id) {
      item.moderation_state = comment.moderation_state;
    }

    return item;
  });
  state.comments = __WEBPACK_IMPORTED_MODULE_8__babel_runtime_corejs2_helpers_toConsumableArray___default()(comments);
}), __WEBPACK_IMPORTED_MODULE_10__babel_runtime_corejs2_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_11__types__["N" /* CHANGE_MOBILE_SIDEBAR */], function (state, data) {
  var key = data.key,
      value = data.value;
  state.mobileSidebar = _objectSpread({}, state.mobileSidebar, __WEBPACK_IMPORTED_MODULE_10__babel_runtime_corejs2_helpers_defineProperty___default()({}, key, value));
}), __WEBPACK_IMPORTED_MODULE_10__babel_runtime_corejs2_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_11__types__["O" /* SET_USERS */], function (state, users) {
  state.users = users;
}), __WEBPACK_IMPORTED_MODULE_10__babel_runtime_corejs2_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_11__types__["P" /* SET_USERS_COUNTER */], function (state, totalUsers) {
  state.totalUsers = totalUsers;
}), __WEBPACK_IMPORTED_MODULE_10__babel_runtime_corejs2_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_11__types__["Q" /* SET_USERS_ORDER_BY */], function (state, order) {
  state.usersOrderBy = order;
}), __WEBPACK_IMPORTED_MODULE_10__babel_runtime_corejs2_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_11__types__["R" /* UPDATE_USER_STATE_ON_LIST */], function (state, userState) {
  var userList = state.users.map(function (user) {
    var userId = Number(user.id);

    if (userId === userState.id) {
      user.permission = userState.permission;
      user.is_active = userState.is_active;
      user.is_muted = userState.is_muted;
    }

    return user;
  });
  state.users = __WEBPACK_IMPORTED_MODULE_8__babel_runtime_corejs2_helpers_toConsumableArray___default()(userList);
}), __WEBPACK_IMPORTED_MODULE_10__babel_runtime_corejs2_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_11__types__["S" /* UPDATE_READ_NOTIFICATION */], function (state, notifications) {
  var newActiveNotifications = state.activeUserNotifications.map(function (item) {
    var newNotification = notifications.find(function (notification) {
      return item.id.includes(notification.id[0]);
    });

    if (!newNotification) {
      return item;
    }

    return _objectSpread({}, item, {
      read: newNotification.read
    });
  });
  state.activeUserNotifications = __WEBPACK_IMPORTED_MODULE_8__babel_runtime_corejs2_helpers_toConsumableArray___default()(newActiveNotifications);
}), __WEBPACK_IMPORTED_MODULE_10__babel_runtime_corejs2_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_11__types__["T" /* MARK_ALL_AS_READ_NOTIFICATION */], function (state) {
  var notifications = state.activeUserNotifications.map(function (item) {
    return _objectSpread({}, item, {
      read: true
    });
  });
  state.activeUserNotifications = __WEBPACK_IMPORTED_MODULE_8__babel_runtime_corejs2_helpers_toConsumableArray___default()(notifications);
}), __WEBPACK_IMPORTED_MODULE_10__babel_runtime_corejs2_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_11__types__["U" /* SET_USER_NOTIFICATIONS */], function (state, _ref2) {
  var notifications = _ref2.notifications,
      page = _ref2.page;
  state.activeUserNotifications = page === 1 ? notifications : [].concat(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_corejs2_helpers_toConsumableArray___default()(state.activeUserNotifications), __WEBPACK_IMPORTED_MODULE_8__babel_runtime_corejs2_helpers_toConsumableArray___default()(notifications));
}), __WEBPACK_IMPORTED_MODULE_10__babel_runtime_corejs2_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_11__types__["V" /* SET_TOTAL_USER_NOTIFICATIONS */], function (state, totalNotifications) {
  state.totalNotifications = totalNotifications;
}), __WEBPACK_IMPORTED_MODULE_10__babel_runtime_corejs2_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_11__types__["W" /* UPDATE_USER_EMAIL_SETTINGS_ON_LIST */], function (state, communityUser) {
  var userList = state.users.map(function (user) {
    var userId = user.id;

    if (userId === communityUser.id) {
      user.email_settings = communityUser.email_settings;
    }

    return user;
  });
  state.users = __WEBPACK_IMPORTED_MODULE_8__babel_runtime_corejs2_helpers_toConsumableArray___default()(userList);
}), __WEBPACK_IMPORTED_MODULE_10__babel_runtime_corejs2_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_11__types__["X" /* SET_COMMUNITY_USER_PROFILE */], function (state, communityUser) {
  state.communityUserProfile = communityUser;
}), __WEBPACK_IMPORTED_MODULE_10__babel_runtime_corejs2_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_11__types__["Y" /* RESET_COMMUNITY_USER_PROFILE */], function (state) {
  state.communityUserProfile = {};
}), __WEBPACK_IMPORTED_MODULE_10__babel_runtime_corejs2_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_11__types__["Z" /* SET_BADGES */], function (state, badges) {
  state.badges = badges;
}), __WEBPACK_IMPORTED_MODULE_10__babel_runtime_corejs2_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_11__types__["_0" /* UPDATE_USER_BADGES_ON_LIST */], function (state, _ref3) {
  var id = _ref3.id,
      badges = _ref3.badges;
  var userList = state.users.map(function (user) {
    if (user.id === id) {
      user.badges = badges;
      user.qty_badges = badges.length;
    }

    return user;
  });
  state.users = __WEBPACK_IMPORTED_MODULE_8__babel_runtime_corejs2_helpers_toConsumableArray___default()(userList);
}), __WEBPACK_IMPORTED_MODULE_10__babel_runtime_corejs2_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_11__types__["_1" /* SET_REPLYING_COMMENT */], function (state, comment) {
  state.replyingComment = comment;
}), _mutations);

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_request_api__ = __webpack_require__(0);


var getList = function getList() {
  var api = new __WEBPACK_IMPORTED_MODULE_0__helpers_request_api__["a" /* default */]();
  var query = {
    query: "{\n      current_user_info {\n        faq_categories {\n          id\n          name\n          faqs {\n            id\n            question\n            answer\n          }\n        }\n      }\n    }"
  };
  return api.get(query);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  getList: getList
});

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__queries_faq__ = __webpack_require__(270);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetch", function() { return fetch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setActive", function() { return setActive; });


var fetch = function fetch(_ref) {
  var commit = _ref.commit;
  __WEBPACK_IMPORTED_MODULE_1__queries_faq__["a" /* default */].getList().then(function (response) {
    var data = response.data;
    var currentUserInfo = data.current_user_info;
    var faqCategories = currentUserInfo.faq_categories;
    commit(__WEBPACK_IMPORTED_MODULE_0__types__["a" /* SET_FAQ_LIST */], faqCategories);
  });
};
var setActive = function setActive(_ref2, question) {
  var commit = _ref2.commit;
  commit(__WEBPACK_IMPORTED_MODULE_0__types__["b" /* SET_ACTIVE_FAQ */], question);
};

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "list", function() { return list; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "active", function() { return active; });
var list = function list(state) {
  return state.faqList;
};
var active = function active(state) {
  return state.active;
};

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(274);



/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__,
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__,
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* mutations */],
  state: __WEBPACK_IMPORTED_MODULE_2__mutations__["b" /* state */]
});

/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_defineProperty__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(97);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return state; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mutations; });


var _mutations;


var state = {
  faqList: [],
  active: {}
};
var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* SET_FAQ_LIST */], function (state, faqList) {
  state.faqList = faqList;
}), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["b" /* SET_ACTIVE_FAQ */], function (state, question) {
  state.active = question;
}), _mutations);

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_request_api__ = __webpack_require__(0);


var api = function api() {
  return new __WEBPACK_IMPORTED_MODULE_0__helpers_request_api__["a" /* default */]();
};

var userRelatedDetails = function userRelatedDetails(categoryIds) {
  var query = {
    query: "{\n      categories_by_ids(ids: [".concat(categoryIds, "]) {\n        id\n        status\n        progress\n        completed_at\n        quantity_finished_posts\n      }\n    }")
  };
  return api().get(query);
};

var fetchAll = function fetchAll(categoryId, projectId) {
  var query = {
    query: "{\n      available_categories_by_parent(\n        category_id: ".concat(categoryId, ",\n        project_id: ").concat(projectId, "\n      ) {\n        id\n        name\n        status\n        quantity_finished_posts\n        completed_at\n        scheduling_status\n        has_availabe_categories(project_id: ").concat(projectId, ")\n        available\n        progress\n        available_posts_count\n        scheduling_by_user {\n          id\n          open_date\n          close_date\n          days\n        }\n      }\n    }")
  };
  return api().get(query);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  userRelatedDetails: userRelatedDetails,
  fetchAll: fetchAll
});

/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_request_api__ = __webpack_require__(0);


var api = function api() {
  return new __WEBPACK_IMPORTED_MODULE_0__helpers_request_api__["a" /* default */]();
};

var fetchCurrent = function fetchCurrent() {
  var query = {
    query: "{\n      current_post {\n        id\n        slug\n      }\n    }"
  };
  return api().get(query);
};

var fetchFromCategory = function fetchFromCategory(category) {
  var postIds = category.published_posts.map(function (post) {
    return post.id;
  });
  var query = {
    query: "{\n      posts_by_ids(ids: [".concat(postIds, "]) {\n        id\n        category {\n          id\n        }\n        user_post {\n          status\n        }\n      }\n    }")
  };
  return api().get(query);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  fetchCurrent: fetchCurrent,
  fetchFromCategory: fetchFromCategory
});

/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_request_api__ = __webpack_require__(0);


var api = function api() {
  return new __WEBPACK_IMPORTED_MODULE_0__helpers_request_api__["a" /* default */]();
};

var fetch = function fetch() {
  var query = {
    query: "{\n      current_user_info {\n        group {\n          project {\n            project_introduction {\n              introduction\n              title\n              active\n            }\n          }\n        }\n      }\n    }"
  };
  return api().get(query);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  fetch: fetch
});

/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_request_api__ = __webpack_require__(0);


var api = function api() {
  return new __WEBPACK_IMPORTED_MODULE_0__helpers_request_api__["a" /* default */]();
};

var fetch = function fetch(userId, projectId) {
  var query = {
    query: "{\n      progress(\n        user_id: ".concat(userId, ",\n        id: ").concat(projectId, ",\n      ) {\n        progress(\n          user_id: ").concat(userId, ",\n        )\n      }\n    }")
  };
  return api().get(query);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  fetch: fetch
});

/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_request_api__ = __webpack_require__(0);


var api = function api() {
  return new __WEBPACK_IMPORTED_MODULE_0__helpers_request_api__["a" /* default */]();
};

var getScripts = function getScripts() {
  var query = {
    query: "{\n      current_user_info {\n        group {\n          project {\n            scripts {\n              placement\n              code\n            }\n          }\n        }\n      }\n    }"
  };
  return api().get(query);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  getScripts: getScripts
});

/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_request_api__ = __webpack_require__(0);


var getInfo = function getInfo() {
  var api = new __WEBPACK_IMPORTED_MODULE_0__helpers_request_api__["a" /* default */]();
  var query = {
    query: "{\n      current_user_info\n      {\n        id\n        name\n        email\n        registration_date\n        photo\n        language {\n          id\n          slug\n          name\n        }\n        group {\n          show_content_unavailable\n          progressive_post_release\n        }\n      }\n    }"
  };
  return api.get(query);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  getInfo: getInfo
});

/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__queries_categories__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__queries_user__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__queries_posts__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__queries_relatedClasses__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__queries_projectIntroduction__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__queries_projectProgress__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__queries_scripts__ = __webpack_require__(279);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchProgress", function() { return fetchProgress; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchCategories", function() { return fetchCategories; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchUserRelatedCategoryDetails", function() { return fetchUserRelatedCategoryDetails; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchCategoryPostDetails", function() { return fetchCategoryPostDetails; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchUserInfo", function() { return fetchUserInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setUserInfo", function() { return setUserInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetUserInfo", function() { return resetUserInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchRelatedClasses", function() { return fetchRelatedClasses; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchCurrentPost", function() { return fetchCurrentPost; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchIntroduction", function() { return fetchIntroduction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toggleCategory", function() { return toggleCategory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hideCategory", function() { return hideCategory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "closeCategories", function() { return closeCategories; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchScripts", function() { return fetchScripts; });









var findCategory = function findCategory(categories, categoryId) {
  if (!categories) {
    return null;
  }

  for (var i = 0; i < categories.length; i += 1) {
    var category = categories[i];

    if (Number(category.id) === Number(categoryId)) {
      return category;
    }

    var foundCategory = findCategory(category.categories, categoryId);

    if (foundCategory) {
      return foundCategory;
    }
  }

  return null;
};

var fetchProgress = function fetchProgress(_ref) {
  var commit = _ref.commit,
      rootState = _ref.rootState,
      state = _ref.state;
  var projectId = rootState.app.project.id;
  var userId = state.userInfo.id;
  __WEBPACK_IMPORTED_MODULE_6__queries_projectProgress__["a" /* default */].fetch(userId, projectId).then(function (response) {
    var progress = response.data.progress.progress;
    commit(__WEBPACK_IMPORTED_MODULE_0__types__["l" /* SET_COURSE_PROGRESS */], progress);
  });
};
var fetchCategories = function fetchCategories(_ref2, categoryId) {
  var commit = _ref2.commit,
      dispatch = _ref2.dispatch,
      rootState = _ref2.rootState,
      state = _ref2.state;
  var projectId = rootState.app.project.id;
  var categoriesList = state.categoriesList;
  var category = findCategory(categoriesList, categoryId);

  if (categoryId !== null && category && category.categories.length) {
    return;
  }

  __WEBPACK_IMPORTED_MODULE_1__queries_categories__["a" /* default */].fetchAll(categoryId, projectId).then(function (response) {
    var categories = response.data.available_categories_by_parent;
    commit(__WEBPACK_IMPORTED_MODULE_0__types__["c" /* SET_CATEGORIES_LIST */], {
      categories: categories,
      categoryId: categoryId
    });
    dispatch('fetchUserRelatedCategoryDetails', categories);
  });
};
var fetchUserRelatedCategoryDetails = function fetchUserRelatedCategoryDetails(_ref3, categoryList) {
  var commit = _ref3.commit;
  var categoryIds = categoryList.map(function (category) {
    return category.id;
  });
  __WEBPACK_IMPORTED_MODULE_1__queries_categories__["a" /* default */].userRelatedDetails(categoryIds).then(function (response) {
    var categoriesDetails = response.data.categories_by_ids;
    commit(__WEBPACK_IMPORTED_MODULE_0__types__["g" /* SET_CATEGORIES_STATUS */], categoriesDetails);
  });
};
var fetchCategoryPostDetails = function fetchCategoryPostDetails(_ref4, category) {
  var commit = _ref4.commit;

  if (!category.published_posts) {
    return;
  }

  __WEBPACK_IMPORTED_MODULE_3__queries_posts__["a" /* default */].fetchFromCategory(category).then(function (response) {
    var posts = response.data.posts_by_ids;
    commit(__WEBPACK_IMPORTED_MODULE_0__types__["f" /* SET_POSTS_DETAILS */], posts);
  });
};
var fetchUserInfo = function fetchUserInfo(_ref5) {
  var dispatch = _ref5.dispatch;
  return __WEBPACK_IMPORTED_MODULE_2__queries_user__["a" /* default */].getInfo().then(function (response) {
    var userInfo = response.data.current_user_info;
    return dispatch('setUserInfo', userInfo);
  });
};
var setUserInfo = function setUserInfo(_ref6, userInfo) {
  var commit = _ref6.commit;
  commit(__WEBPACK_IMPORTED_MODULE_0__types__["a" /* SET_USER_INFO */], userInfo);
};
var resetUserInfo = function resetUserInfo(_ref7) {
  var commit = _ref7.commit;
  return commit(__WEBPACK_IMPORTED_MODULE_0__types__["b" /* RESET_USER_INFO */]);
};
var fetchRelatedClasses = function fetchRelatedClasses(_ref8) {
  var commit = _ref8.commit;
  __WEBPACK_IMPORTED_MODULE_4__queries_relatedClasses__["a" /* default */].fetch().then(function (response) {
    var data = response.data;
    commit(__WEBPACK_IMPORTED_MODULE_0__types__["d" /* SET_RELATED_POSTS */], data.related_classes);
  });
};
var fetchCurrentPost = function fetchCurrentPost(_ref9) {
  var commit = _ref9.commit;
  __WEBPACK_IMPORTED_MODULE_3__queries_posts__["a" /* default */].fetchCurrent().then(function (response) {
    var data = response.data;
    commit(__WEBPACK_IMPORTED_MODULE_0__types__["e" /* SET_CURRENT_POST */], data.current_post);
  });
};
var fetchIntroduction = function fetchIntroduction(_ref10) {
  var commit = _ref10.commit;
  return __WEBPACK_IMPORTED_MODULE_5__queries_projectIntroduction__["a" /* default */].fetch().then(function (response) {
    var projIntro = response.data.current_user_info.group.project.project_introduction;
    return commit(__WEBPACK_IMPORTED_MODULE_0__types__["h" /* SET_INTRODUCTION */], projIntro);
  });
};
var toggleCategory = function toggleCategory(_ref11, categoryId) {
  var commit = _ref11.commit,
      dispatch = _ref11.dispatch;
  commit(__WEBPACK_IMPORTED_MODULE_0__types__["i" /* TOGGLE_CATEGORY */], categoryId);
  return dispatch('fetchCategories', categoryId);
};
var hideCategory = function hideCategory(_ref12, categoryId) {
  var commit = _ref12.commit,
      dispatch = _ref12.dispatch;
  commit(__WEBPACK_IMPORTED_MODULE_0__types__["j" /* HIDE_CATEGORY */], categoryId);
};
var closeCategories = function closeCategories(_ref13) {
  var commit = _ref13.commit;
  return commit(__WEBPACK_IMPORTED_MODULE_0__types__["k" /* CLOSE_CATEGORIES */]);
};
var fetchScripts = function fetchScripts(_ref14) {
  var rootState = _ref14.rootState;
  return __WEBPACK_IMPORTED_MODULE_7__queries_scripts__["a" /* default */].getScripts(rootState.app.project.id).then(function (response) {
    return response.data.current_user_info.group.project.scripts;
  });
};

/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "categoriesList", function() { return categoriesList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "relatedPosts", function() { return relatedPosts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "userInfo", function() { return userInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "userName", function() { return userName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "progress", function() { return progress; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "currentPost", function() { return currentPost; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "introduction", function() { return introduction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "openCategories", function() { return openCategories; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "group", function() { return group; });
var categoriesList = function categoriesList(state) {
  return state.categoriesList;
};
var relatedPosts = function relatedPosts(state) {
  return state.relatedPosts;
};
var userInfo = function userInfo(state) {
  return state.userInfo;
};
var userName = function userName(state) {
  return state.userInfo.name;
};
var progress = function progress(state) {
  return state.userInfo.progress;
};
var currentPost = function currentPost(state) {
  return state.currentPost;
};
var introduction = function introduction(state) {
  return state.introduction;
};
var openCategories = function openCategories(state) {
  return state.openCategories;
};
var group = function group(state) {
  return state.group;
};

/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(284);



/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__,
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__,
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* mutations */],
  state: __WEBPACK_IMPORTED_MODULE_2__mutations__["b" /* state */]
});

/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_define_property__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_core_js_object_define_properties__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_core_js_object_define_properties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_core_js_object_define_properties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_core_js_object_get_own_property_descriptors__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_core_js_object_get_own_property_descriptors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_core_js_object_get_own_property_descriptors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_core_js_object_get_own_property_descriptor__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs2_core_js_object_get_own_property_symbols__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs2_core_js_object_get_own_property_symbols___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs2_core_js_object_get_own_property_symbols__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_corejs2_core_js_object_keys__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_corejs2_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_corejs2_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_corejs2_core_js_object_assign__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_corejs2_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_corejs2_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_corejs2_helpers_defineProperty__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_corejs2_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_corejs2_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__types__ = __webpack_require__(99);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return state; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mutations; });









var _mutations;

function ownKeys(object, enumerableOnly) { var keys = __WEBPACK_IMPORTED_MODULE_5__babel_runtime_corejs2_core_js_object_keys___default()(object); if (__WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs2_core_js_object_get_own_property_symbols___default.a) { var symbols = __WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs2_core_js_object_get_own_property_symbols___default()(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_core_js_object_get_own_property_descriptor___default()(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_7__babel_runtime_corejs2_helpers_defineProperty___default()(target, key, source[key]); }); } else if (__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_core_js_object_get_own_property_descriptors___default.a) { __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_core_js_object_define_properties___default()(target, __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_core_js_object_get_own_property_descriptors___default()(source)); } else { ownKeys(Object(source)).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_define_property___default()(target, key, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_core_js_object_get_own_property_descriptor___default()(source, key)); }); } } return target; }


var defaultUserInfo = {
  id: '',
  name: '',
  email: '',
  progress: 0
};
var defaultGroup = {
  show_content_unavailable: false
};
var state = {
  openCategories: [],
  userInfo: _objectSpread({}, defaultUserInfo),
  categoriesList: [],
  relatedPosts: [],
  projectCache: {},
  currentPost: {},
  introduction: {},
  group: defaultGroup
};

var findDetail = function findDetail(categoriesDetails, category) {
  return categoriesDetails.filter(function (detail) {
    return Number(detail.id) === category.id;
  })[0];
};

var findCategory = function findCategory(categories, categoryId) {
  if (!categories) {
    return null;
  }

  for (var i = 0; i < categories.length; i += 1) {
    var category = categories[i];

    if (Number(category.id) === Number(categoryId)) {
      return category;
    }

    var foundCategory = findCategory(category.categories, categoryId);

    if (foundCategory) {
      return foundCategory;
    }
  }

  return null;
};

var findPost = function findPost(posts, postId) {
  return posts.filter(function (post) {
    return Number(post.id) === Number(postId);
  })[0];
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_7__babel_runtime_corejs2_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_8__types__["a" /* SET_USER_INFO */], function (state, userInfo) {
  state.userInfo = userInfo;
  state.group = userInfo.group;
}), __WEBPACK_IMPORTED_MODULE_7__babel_runtime_corejs2_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_8__types__["b" /* RESET_USER_INFO */], function (state) {
  state.userInfo = defaultUserInfo;
}), __WEBPACK_IMPORTED_MODULE_7__babel_runtime_corejs2_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_8__types__["c" /* SET_CATEGORIES_LIST */], function (state, _ref) {
  var categories = _ref.categories,
      categoryId = _ref.categoryId;

  if (categoryId === null) {
    state.categoriesList = categories.map(function (category) {
      return _objectSpread({}, category, {
        categories: []
      });
    });
    return;
  }

  var category = findCategory(state.categoriesList, categoryId);

  if (!category) {
    return;
  }

  category.categories = categories.map(function (category) {
    return _objectSpread({}, category, {
      categories: []
    });
  });
  state.categoriesList = state.categoriesList.map(function (category) {
    return category;
  });
}), __WEBPACK_IMPORTED_MODULE_7__babel_runtime_corejs2_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_8__types__["d" /* SET_RELATED_POSTS */], function (state, relatedPosts) {
  state.relatedPosts = relatedPosts;
}), __WEBPACK_IMPORTED_MODULE_7__babel_runtime_corejs2_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_8__types__["e" /* SET_CURRENT_POST */], function (state, currentPost) {
  state.currentPost = currentPost;
}), __WEBPACK_IMPORTED_MODULE_7__babel_runtime_corejs2_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_8__types__["f" /* SET_POSTS_DETAILS */], function (state, posts) {
  if (!posts || !posts.length || !posts[0].category) {
    return;
  }

  var categoryId = posts[0].category.id;
  var category = findCategory(state.categoriesList, categoryId);
  category.published_posts = category.published_posts.map(function (post) {
    var postDetail = findPost(posts, post.id);
    return __WEBPACK_IMPORTED_MODULE_6__babel_runtime_corejs2_core_js_object_assign___default()({}, post, postDetail);
  });
}), __WEBPACK_IMPORTED_MODULE_7__babel_runtime_corejs2_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_8__types__["g" /* SET_CATEGORIES_STATUS */], function (state, categoriesDetails) {
  state.categoriesList = state.categoriesList.map(function (category) {
    var detail = findDetail(categoriesDetails, category);
    return __WEBPACK_IMPORTED_MODULE_6__babel_runtime_corejs2_core_js_object_assign___default()({}, category, detail);
  });
}), __WEBPACK_IMPORTED_MODULE_7__babel_runtime_corejs2_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_8__types__["h" /* SET_INTRODUCTION */], function (state, introduction) {
  state.introduction = introduction;
}), __WEBPACK_IMPORTED_MODULE_7__babel_runtime_corejs2_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_8__types__["i" /* TOGGLE_CATEGORY */], function (state, categoryId) {
  var index = state.openCategories.lastIndexOf(categoryId);

  if (index === -1) {
    state.openCategories.push(categoryId);
    return;
  }

  state.openCategories.splice(index, 1);
}), __WEBPACK_IMPORTED_MODULE_7__babel_runtime_corejs2_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_8__types__["j" /* HIDE_CATEGORY */], function (state, categoryId) {
  var index = state.openCategories.lastIndexOf(categoryId);
  if (index === -1) return;
  state.openCategories.splice(index, 1);
}), __WEBPACK_IMPORTED_MODULE_7__babel_runtime_corejs2_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_8__types__["k" /* CLOSE_CATEGORIES */], function (state) {
  state.openCategories = [];
}), __WEBPACK_IMPORTED_MODULE_7__babel_runtime_corejs2_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_8__types__["l" /* SET_COURSE_PROGRESS */], function (state, progress) {
  var userInfo = _objectSpread({}, state.userInfo);

  userInfo.progress = progress;
  state.userInfo = userInfo;
}), _mutations);

/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_request_api__ = __webpack_require__(0);


var api = function api() {
  return new __WEBPACK_IMPORTED_MODULE_0__helpers_request_api__["a" /* default */]();
};

var update = function update(updatedProfile) {
  var id = updatedProfile.id,
      name = updatedProfile.name;
  var newPassword = updatedProfile.newPassword || '';
  var photo = updatedProfile.photo || '';
  var query = {
    query: "mutation updateUserProfile {\n      updateUserProfile(input: {\n        id: ".concat(id, "\n        name: \"").concat(name, "\"\n        new_password: \"").concat(newPassword, "\"\n        photo: \"").concat(photo, "\"\n      })\n      {\n        user {\n          id\n          name\n          email\n          photo\n          language {\n            id\n            slug\n            name\n          }\n        }\n      }\n    }")
  };
  return api().get(query);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  update: update
});

/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_assign__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__queries_profile__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_request_media__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__types__ = __webpack_require__(100);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "updateProfile", function() { return updateProfile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "uploadMedia", function() { return uploadMedia; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "clearUserPhoto", function() { return clearUserPhoto; });




var updateProfile = function updateProfile(_ref, profile) {
  var rootState = _ref.rootState,
      dispatch = _ref.dispatch;
  var currentUserInfo = rootState.index.userInfo;

  var updatedProfile = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_assign___default()({}, currentUserInfo, profile);

  return __WEBPACK_IMPORTED_MODULE_1__queries_profile__["a" /* default */].update(updatedProfile).then(function (response) {
    var data = response.data;
    var user = data.updateUserProfile.user;
    dispatch('index/setUserInfo', user, {
      root: true
    });
  });
};
var uploadMedia = function uploadMedia(_ref2, _ref3) {
  var commit = _ref2.commit;
  var file = _ref3.file;
  return __WEBPACK_IMPORTED_MODULE_2__helpers_request_media__["a" /* default */].upload(file).then(function (response) {
    var data = response.data;
    commit(__WEBPACK_IMPORTED_MODULE_3__types__["a" /* SET_USER_PHOTO */], data.path);
  });
};
var clearUserPhoto = function clearUserPhoto(_ref4) {
  var commit = _ref4.commit;
  commit(__WEBPACK_IMPORTED_MODULE_3__types__["b" /* CLEAR_USER_PHOTO */]);
};

/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "userPhoto", function() { return userPhoto; });
var userPhoto = function userPhoto(state) {
  return state.userPhoto;
};
/* harmony default export */ __webpack_exports__["default"] = (userPhoto);

/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(289);



/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__,
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__,
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* mutations */],
  state: __WEBPACK_IMPORTED_MODULE_2__mutations__["b" /* state */]
});

/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_defineProperty__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(100);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return state; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mutations; });


var _mutations;


var state = {
  userPhoto: ''
};
var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* SET_USER_PHOTO */], function (state, userPhoto) {
  state.userPhoto = userPhoto;
}), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["b" /* CLEAR_USER_PHOTO */], function (state) {
  state.userPhoto = '';
}), _mutations);

/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_request_api__ = __webpack_require__(0);


var api = function api() {
  return new __WEBPACK_IMPORTED_MODULE_0__helpers_request_api__["a" /* default */]();
};

var search = function search(filter, projectId, page) {
  var query = {
    variables: {
      filter: filter
    },
    query: "{\n      posts_by_filter(\n        filter: \"".concat(filter.trim(), "\",\n        project_id: ").concat(projectId, ",\n        page: ").concat(page, "\n      ) {\n        id\n        title\n        description\n        slug\n        tags {\n          tag\n        }\n      }\n    }")
  };
  return api().get(query);
};

var count = function count(filter, projectId) {
  var query = {
    variables: {
      filter: filter
    },
    query: "{\n      posts_by_filter_count(\n        filter: \"".concat(filter, "\",\n        project_id: ").concat(projectId, "\n      ) { }\n    }")
  };
  return api().get(query);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  search: search,
  count: count
});

/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__queries_search__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_timers_debounce__ = __webpack_require__(114);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "execute", function() { return execute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "nextPage", function() { return nextPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setResults", function() { return setResults; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetSearch", function() { return resetSearch; });



var execute = function execute(_ref, _ref2) {
  var commit = _ref.commit,
      dispatch = _ref.dispatch,
      rootState = _ref.rootState;
  var filter = _ref2.filter,
      page = _ref2.page;
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__helpers_timers_debounce__["a" /* default */])(function () {
    commit(__WEBPACK_IMPORTED_MODULE_0__types__["a" /* SET_SEARCH_FILTER */], filter);
    var projectId = rootState.app.project.id;
    __WEBPACK_IMPORTED_MODULE_1__queries_search__["a" /* default */].count(filter, projectId, page).then(function (response) {
      return commit(__WEBPACK_IMPORTED_MODULE_0__types__["c" /* SET_COUNT */], response.data.posts_by_filter_count);
    });
    __WEBPACK_IMPORTED_MODULE_1__queries_search__["a" /* default */].search(filter, projectId, page).then(function (response) {
      return dispatch('setResults', response.data.posts_by_filter);
    });
  }, 500);
};
var nextPage = function nextPage(_ref3, _ref4) {
  var commit = _ref3.commit,
      rootState = _ref3.rootState;
  var filter = _ref4.filter,
      page = _ref4.page;
  var projectId = rootState.app.project.id;
  return __WEBPACK_IMPORTED_MODULE_1__queries_search__["a" /* default */].search(filter, projectId, page).then(function (response) {
    return commit(__WEBPACK_IMPORTED_MODULE_0__types__["d" /* APPEND_RESULT */], response.data.posts_by_filter);
  });
};
var setResults = function setResults(_ref5, results) {
  var commit = _ref5.commit;
  commit(__WEBPACK_IMPORTED_MODULE_0__types__["b" /* SET_SEARCH_RESULTS */], results);
};
var resetSearch = function resetSearch(_ref6) {
  var commit = _ref6.commit,
      dispatch = _ref6.dispatch;
  commit(__WEBPACK_IMPORTED_MODULE_0__types__["e" /* RESET_SEARCH_FILTER */]);
  commit(__WEBPACK_IMPORTED_MODULE_0__types__["c" /* SET_COUNT */], 0);
  dispatch('setResults', []);
};

/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "filter", function() { return filter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "results", function() { return results; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "count", function() { return count; });
var filter = function filter(state) {
  return state.searchFilter;
};
var results = function results(state) {
  return state.searchResults;
};
var count = function count(state) {
  return state.resultCount;
};

/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(294);



/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__,
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__,
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* mutations */],
  state: __WEBPACK_IMPORTED_MODULE_2__mutations__["b" /* state */]
});

/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_defineProperty__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_toConsumableArray__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(101);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return state; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mutations; });



var _mutations;


var state = {
  resultCount: 0,
  searchFilter: '',
  searchResults: []
};
var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__types__["a" /* SET_SEARCH_FILTER */], function (state, searchFilter) {
  state.searchFilter = searchFilter;
}), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__types__["b" /* SET_SEARCH_RESULTS */], function (state, searchResults) {
  state.searchResults = searchResults;
}), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__types__["c" /* SET_COUNT */], function (state, count) {
  state.resultCount = count;
}), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__types__["d" /* APPEND_RESULT */], function (state, results) {
  state.searchResults = [].concat(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_toConsumableArray___default()(state.searchResults), __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_toConsumableArray___default()(results));
}), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__types__["e" /* RESET_SEARCH_FILTER */], function (state) {
  state.searchFilter = '';
}), _mutations);

/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_request_api__ = __webpack_require__(0);


var api = function api() {
  return new __WEBPACK_IMPORTED_MODULE_0__helpers_request_api__["a" /* default */]();
};

var fetch = function fetch() {
  var query = {
    query: "{\n      current_user_info {\n        group {\n          project {\n            banner {\n              active\n              active_button\n              text\n              button_text\n              button_url\n            }\n          }\n        }\n      }\n    }"
  };
  return api().get(query);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  fetch: fetch
});

/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__queries_banner__ = __webpack_require__(295);


/* harmony default export */ __webpack_exports__["default"] = (function (_ref) {
  var commit = _ref.commit,
      state = _ref.state;

  if (state.fetched) {
    return;
  }

  __WEBPACK_IMPORTED_MODULE_1__queries_banner__["a" /* default */].fetch().then(function (response) {
    var banner = response.data.current_user_info.group.project.banner;
    return commit(__WEBPACK_IMPORTED_MODULE_0__types__["a" /* default */], banner);
  });
});

/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = (function (state) {
  return state.active;
});

/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(299);



/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__,
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__,
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* mutations */],
  state: __WEBPACK_IMPORTED_MODULE_2__mutations__["b" /* state */]
});

/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_defineProperty__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_core_js_object_assign__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(102);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return state; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mutations; });



var defaultBanner = {
  active: false,
  text: '',
  active_button: true,
  button_text: '',
  button_url: ''
};
var state = {
  fetched: false,
  active: __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_core_js_object_assign___default()({}, defaultBanner)
};
var mutations = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_2__types__["a" /* default */], function (state, banner) {
  state.fetched = true;
  state.active = banner;
});

/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(103);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "open", function() { return open; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "close", function() { return close; });

var open = function open(_ref, modal) {
  var commit = _ref.commit;
  document.body.className = 'c-modal-open';

  if (modal.params && modal.name) {
    return commit(__WEBPACK_IMPORTED_MODULE_0__types__["b" /* OPEN_CUSTOM_MODAL */], modal);
  }

  return commit(__WEBPACK_IMPORTED_MODULE_0__types__["a" /* OPEN_MODAL */], modal);
};
var close = function close(_ref2) {
  var commit = _ref2.commit;
  document.body.className = '';
  commit(__WEBPACK_IMPORTED_MODULE_0__types__["c" /* CLOSE_MODAL */]);
};

/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "active", function() { return active; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "activeParams", function() { return activeParams; });
var active = function active(state) {
  return state.active;
};
var activeParams = function activeParams(state) {
  return state.activeParams;
};

/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(303);



/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__,
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__,
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* mutations */],
  state: __WEBPACK_IMPORTED_MODULE_2__mutations__["b" /* state */]
});

/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_defineProperty__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(103);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return state; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mutations; });


var _mutations;


var state = {
  active: '',
  activeParams: {}
};
var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* OPEN_MODAL */], function (state, modal) {
  state.active = modal;
}), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["b" /* OPEN_CUSTOM_MODAL */], function (state, _ref) {
  var name = _ref.name,
      params = _ref.params;
  state.active = name;
  state.activeParams = params;
}), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["c" /* CLOSE_MODAL */], function (state) {
  state.active = '';
  state.activeParams = {};
}), _mutations);

/***/ }),
/* 304 */,
/* 305 */,
/* 306 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 307 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(17)(
  /* script */
  __webpack_require__(188),
  /* template */
  __webpack_require__(316),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(17)(
  /* script */
  __webpack_require__(191),
  /* template */
  __webpack_require__(320),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(17)(
  /* script */
  __webpack_require__(192),
  /* template */
  __webpack_require__(319),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 316 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.areCookiesEnabled) ? _c('LayoutGeneral', {
    staticClass: "c-modal--notification",
    attrs: {
      "show-close-button": false
    },
    on: {
      "close": _vm.close
    }
  }, [_c('template', {
    slot: "header"
  }), _vm._v(" "), _c('template', {
    slot: "body"
  }, [_c('div', [_c('i', {
    staticClass: "c-icon c-icon--cookie"
  }), _vm._v(" "), _c('h4', {
    staticClass: "c-modal--notification__title"
  }, [_vm._v(_vm._s(_vm.$t('cookie.disabled')))]), _vm._v(" "), _c('p', {
    staticClass: "c-modal--notification__description"
  }, [_vm._v(_vm._s(_vm.$t('cookie.enable')))])])])], 2) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 317 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "generalContainer",
    attrs: {
      "ondragstart": "return false;",
      "ondrop": "return false;"
    }
  }, [_c('NotificationContainer'), _vm._v(" "), (_vm.loadedRequisites) ? _c('router-view') : _vm._e(), _vm._v(" "), _c('NoCookiesModal')], 1)
},staticRenderFns: []}

/***/ }),
/* 318 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 1024 1024"
    }
  }, [_c('path', {
    attrs: {
      "d": "M602.6 512l402.7-402.7c25-25 25-65.6 0-90.6-25-25-65.5-25-90.6 0l-402.7 402.7-402.7-402.7c-25-25-65.5-25-90.6 0-25 25-25 65.6 0 90.6l402.7 402.7-402.7 402.7c-25 25-25 65.6 0 90.6 12.5 12.5 28.9 18.7 45.3 18.7s32.8-6.3 45.3-18.8l402.7-402.7 402.7 402.7c12.5 12.5 28.9 18.8 45.3 18.8s32.8-6.3 45.3-18.8c25-25 25-65.6 0-90.6l-402.7-402.7z"
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 319 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('notifications', {
    attrs: {
      "animation-type": "velocity",
      "group": "kmb-notifications",
      "animation": _vm.animation,
      "duration": 4200,
      "width": 315,
      "position": "bottom left"
    },
    scopedSlots: _vm._u([
      ["body", function(props) {
        return [_c('NotificationBody', {
          attrs: {
            "config": props,
            "description": props.item.data.description,
            "first-action": props.item.data.firstAction,
            "second-action": props.item.data.secondAction
          }
        })]
      }]
    ])
  })
},staticRenderFns: []}

/***/ }),
/* 320 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.containerClass
  }, [_c('div', {
    staticClass: "notification-wrapper__icon"
  }, [_c('i', {
    staticClass: "icon",
    class: _vm.iconClass
  })]), _vm._v(" "), _c('div', {
    staticClass: "notification-wrapper__content"
  }, [_c('a', {
    staticClass: "title"
  }, [_vm._v("\n      " + _vm._s(_vm.config.item.title) + "\n    ")]), _vm._v(" "), _c('a', {
    staticClass: "close",
    on: {
      "click": _vm.config.close
    }
  }, [_c('i', {
    staticClass: "notifications--icon"
  }, [_c('icon-close')], 1)]), _vm._v(" "), _c('div', [_c('h1', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.config.item.text))]), _vm._v(" "), (_vm.description) ? _c('h4', {
    staticClass: "description"
  }, [_vm._v(_vm._s(_vm.description))]) : _vm._e(), _vm._v(" "), (_vm.firstAction) ? _c('button', {
    staticClass: "button button--default-ghost",
    on: {
      "click": _vm.firstAction.action
    }
  }, [_vm._v(_vm._s(_vm.firstAction.text))]) : _vm._e(), _vm._v(" "), (_vm.secondAction) ? _c('button', {
    staticClass: "button button--default-ghost",
    on: {
      "click": _vm.secondAction.action
    }
  }, [_vm._v(_vm._s(_vm.secondAction.text))]) : _vm._e()])])])
},staticRenderFns: []}

/***/ }),
/* 321 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "klick-modal"
    }
  }, [_c('div', {
    staticClass: "klick-modal-mask",
    class: _vm.modalTypeClass
  }, [_c('div', {
    staticClass: "klick-modal-wrapper c-modal__wrapper u-scroll"
  }, [(_vm.showCloseButton) ? _c('button', {
    staticClass: "c-modal__close",
    on: {
      "click": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "c-icon--close"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "c-modal__body"
  }, [_vm._t("body")], 2), _vm._v(" "), _vm._t("footer")], 2)])])
},staticRenderFns: []}

/***/ })
],[206]);


// WEBPACK FOOTER //
// static/js/app.b8e6ce71f4754d9019e5.js